(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-sleepy-single-file"] && !Shopify.designMode) return;
  try {
    
/* Presentation only. The theme owns variant selection, pricing and cart submissions. */
(() => {
 if(!customElements.get('sleepy-option-notes')) {
  customElements.define('sleepy-option-notes',class extends HTMLElement {
   connectedCallback(){
    this.frame=requestAnimationFrame(()=>{
     this.decorate();
     this.observer=new MutationObserver(()=>this.decorate());
     this.observer.observe(this,{childList:true,subtree:true});
    });
   }
   decorate(){
    const notes=new Map((this.querySelector('[data-sp-notes]')?.content.textContent||'').split('\n').map(line=>{
     const parts=line.split('|');return [parts.shift().trim().toLowerCase(),parts.join('|').trim()];
    }).filter(([key,value])=>key&&value));
    const labels=[...this.querySelectorAll('label')];
    this.querySelectorAll('input[type="radio"]').forEach(input=>{
     const label=labels.find(label=>label.htmlFor===input.id)||input.closest('label');
     if(!label)return;
     const note=notes.get(input.value.trim().toLowerCase());
     const existing=label.querySelector('.sp-option-note');
     if(!note){existing?.remove();return;}
     if(existing){if(existing.textContent!==note)existing.textContent=note;return;}
     const span=document.createElement('span');span.className='sp-option-note';span.textContent=note;label.append(span);
    });
   }
   disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();}
  });
 }
 // The inventory bar lives in shadow DOM. Custom properties cross that boundary
 // and handle it, but only if the component reads the variable names above. This
 // injects a stylesheet directly into an open shadow root so the colours land
 // whatever those internals are named. Closed roots are already covered by the
 // custom properties, which inherit regardless of mode.
 const paintInventory = root => {
  root.querySelectorAll('.sp-font-block--inventory progress-bar').forEach(el => {
   if (!el.shadowRoot || el.shadowRoot.querySelector('style[data-sp-inv]')) return;
   const cs = getComputedStyle(el);
   const fill = cs.getPropertyValue('--sp-inv-fill').trim() || '#8A6565';
   const track = cs.getPropertyValue('--sp-inv-track').trim() || '#D9CACA';
   const style = document.createElement('style');
   style.dataset.spInv = '';
   // The host is the rounded track; whatever sits inside it is the filled part.
   style.textContent = ':host{background:var(--sp-inv-track) !important}:host > *,:host > * > *{background:var(--sp-inv-fill) !important;border-color:var(--sp-inv-fill) !important}';
   el.shadowRoot.append(style);
  });
 };
 const runInventory = () => requestAnimationFrame(() => paintInventory(document));
 runInventory();
 document.addEventListener('shopify:section:load', runInventory);
 document.addEventListener('variant:change', runInventory);

 if(!customElements.get('sleepy-pdp-thumbs')) {
  customElements.define('sleepy-pdp-thumbs',class extends HTMLElement {
   connectedCallback(){
    this.abort=new AbortController();
    this.addEventListener('click',event=>{
     const link=event.target.closest('a[data-sp-image]');if(!link)return;
     const gallery=this.closest('.sp-product__gallery')?.querySelector('.sp-native-gallery');if(!gallery)return;
     let path;try{path=new URL(link.dataset.spImage,location.href).pathname}catch{return;}
     const image=[...gallery.querySelectorAll('.product__media-list img')].find(img=>img.getClientRects().length && [img.currentSrc,img.src,img.dataset.src,img.getAttribute('srcset'),img.getAttribute('data-srcset')].some(src=>src&&src.includes(path)));
     if(!image)return; // The image link remains a usable fallback.
     event.preventDefault();
     this.querySelectorAll('a').forEach(a=>a.setAttribute('aria-current',String(a===link)));
     image.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    },{signal:this.abort.signal});
   }
   disconnectedCallback(){this.abort?.abort();}
  });
 }
})();


if (!customElements.get('sleepy-gallery-boundary')) {
 customElements.define('sleepy-gallery-boundary',class extends HTMLElement {
  connectedCallback(){
   this.section=document.getElementById('shopify-section-'+this.dataset.section);
   this.gallery=this.section?.querySelector('.sp-product__gallery');
   if(!this.gallery)return;
   this.controller=new AbortController();
   this.measure=()=>{
    const offset=parseFloat(getComputedStyle(this.section).getPropertyValue('--sp-sticky-top'))||0;
    // Tall galleries scroll fully into view before their bottom edge sticks.
    const top=Math.min(offset,window.innerHeight-this.gallery.offsetHeight-24);
    this.section.style.setProperty('--sp-gallery-stop',top+'px');
   };
   this.observer=new ResizeObserver(this.measure);this.observer.observe(this.gallery);
   window.addEventListener('resize',this.measure,{signal:this.controller.signal,passive:true});
   this.measure();
  }
  disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();}
 });
}


 if(!customElements.get('sleepy-stock-colors')) {
  customElements.define('sleepy-stock-colors',class extends HTMLElement {
   connectedCallback(){
    this.variants=JSON.parse(this.querySelector('[data-stock-variants]').textContent);
    this.section=this.closest('.shopify-section');
    this.current=this.dataset.initial;
    this.abort=new AbortController();
    this.paint=()=>{
     if(this.dataset.enabled!=='true')return;
     const variant=this.variants.find(v=>String(v.id)===String(this.current));
     if(!variant)return;
     const qty=Number(variant.quantity);
     // Unknown inventory and backorders use the neutral theme color.
     const color=!variant.available ? this.dataset.red : !variant.tracked || qty<=0 ? this.dataset.neutral : qty<=2 ? this.dataset.red : qty<=5 ? this.dataset.amber : this.dataset.neutral;
     const hex=color.replace('#','');
     const full=hex.length===3?hex.split('').map(x=>x+x).join(''):hex;
     const rgb=[0,2,4].map(i=>parseInt(full.slice(i,i+2),16)).join(' ');
     this.querySelectorAll('progress-bar').forEach(bar=>{
      if(bar.style.getPropertyValue('--sp-inv-fill')!==color){
       bar.style.setProperty('--sp-inv-fill',color);
       bar.style.setProperty('--sp-inv-fill-rgb',rgb);
      }
     });
    };
    const update=e=>{
     const variant=e?.detail?.variant || e?.detail?.data?.variant;
     if(variant?.id)this.current=variant.id;
     else {
      const input=this.section?.querySelector('form[action*="/cart/add"] [name="id"]');
      if(input?.value)this.current=input.value;
     }
     cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(this.paint);
    };
    this.section?.addEventListener('variant:change',update,{signal:this.abort.signal});
    this.section?.addEventListener('change',()=>setTimeout(()=>{if(this.isConnected)update();},0),{signal:this.abort.signal});
    this.observer=new MutationObserver(()=>update());
    this.observer.observe(this.section||this,{childList:true,subtree:true});
    this.paint();
   }
   disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);}
  });
 }


if(!customElements.get('sleepy-buy-now')){
 customElements.define('sleepy-buy-now',class extends HTMLElement{
  connectedCallback(){
   if(this.dataset.enabled==='false')return;
   this.abort=new AbortController();
   this.setup=()=>{
    const add=this.querySelector('button[name="add"]');
    if(!add)return;
    if(!add.parentElement.classList.contains('sp-buy-row')){
     const row=document.createElement('div');row.className='sp-buy-row';add.before(row);row.append(add);
     const button=document.createElement('button');button.type='button';button.className='sp-buy-now-button';button.textContent=this.dataset.label;row.append(button);
     button.addEventListener('click',()=>this.checkout(add,button),{signal:this.abort.signal});
     this.dataset.enhanced='true';
    }
    const button=add.parentElement.querySelector('.sp-buy-now-button');
    const disabled=add.disabled||add.getAttribute('aria-disabled')==='true'||Boolean(this.busy);
    if(button && button.disabled!==disabled)button.disabled=disabled;
   };
   this.observer=new MutationObserver(this.setup);
   this.observer.observe(this,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
   this.setup();
  }
  async checkout(add,button){
   if(this.busy||add.disabled)return;
   const form=add.form||add.closest('form');
   if(!form||!form.reportValidity())return;
   const error=this.querySelector('.sp-buy-now-error');
   error.hidden=true;this.busy=true;button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Please wait…';
   const wasDisabled=add.disabled;add.disabled=true;
   try{
    const data=new FormData(form);data.delete('sections');data.delete('sections_url');
    const root=window.Shopify?.routes?.root||'/';
    const response=await fetch(root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
    const result=await response.json();
    if(!response.ok||result.status>=400)throw new Error(result.description||result.message||'Unable to add this item. Please try again.');
    window.location.assign(root+'checkout');
   }catch(err){
    error.textContent=err.message||'Unable to start checkout. Please try again.';error.hidden=false;
    this.busy=false;add.disabled=wasDisabled;button.removeAttribute('aria-busy');button.textContent=this.dataset.label;this.setup();
   }
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-about-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=r=>r.querySelectorAll('[data-sah]:not([data-ready])').forEach(e=>{e.dataset.ready='true';if(!('IntersectionObserver'in window)){e.classList.add('is-visible');return}const o=new IntersectionObserver(a=>{if(a[0].isIntersecting){e.classList.add('is-visible');o.disconnect()}},{threshold:.15});o.observe(e)});init(document);document.addEventListener('shopify:section:load',e=>init(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-about-impact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => root.querySelectorAll('[data-sai]:not([data-ready])').forEach((section) => {
      section.dataset.ready = 'true';
      let hasRun = false;

      const run = () => {
        if (hasRun) return;
        hasRun = true;
        section.classList.add('is-visible');
        section.querySelectorAll('[data-sai-count]').forEach((number) => {
          const target = Number(number.dataset.saiCount) || 0;
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
            number.textContent = target.toLocaleString();
            return;
          }
          const start = performance.now();
          const duration = 1400;
          const draw = (time) => {
            const progress = Math.min(1, (time - start) / duration);
            number.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3))).toLocaleString();
            if (progress < 1) requestAnimationFrame(draw);
          };
          requestAnimationFrame(draw);
        });
      };

      if (!('IntersectionObserver' in window)) { run(); return; }
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        run();
        observer.disconnect();
      }, { threshold: .12 });
      observer.observe(section);
    });
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-about-showroom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sleepy-showroom-visit')) {
  customElements.define('sleepy-showroom-visit', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const signal = this.abort.signal;
      if(this.dataset.animation !== 'none' && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches){
        this.observer = new IntersectionObserver(entries => {
          if(entries.some(entry => entry.isIntersecting)){ this.classList.add('sc-showroom--enter'); this.observer.disconnect(); }
        }, {threshold:0.1}); this.observer.observe(this);
      }

      // Directions: desktop and Android follow the plain Google Maps link (Android
      // hands it to the Google Maps app). iPhone/iPad have no system chooser, so
      // only there we ask Apple Maps or Google Maps.
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const sheet = this.querySelector('[data-maps-sheet]');
      const dirLink = this.querySelector('[data-directions]');
      if (isIOS && sheet && dirLink) {
        const openSheet = () => { sheet.hidden = false; sheet.querySelector('a')?.focus(); };
        const closeSheet = () => { sheet.hidden = true; dirLink.focus({preventScroll:true}); };
        dirLink.addEventListener('click', e => { e.preventDefault(); openSheet(); }, {signal});
        sheet.addEventListener('click', e => { if (e.target === sheet || e.target.closest('[data-maps-cancel]') || e.target.closest('a')) closeSheet(); }, {signal});
        this.addEventListener('keydown', e => { if (e.key === 'Escape' && !sheet.hidden) { e.preventDefault(); closeSheet(); } }, {signal});
      }

      const dialog = this.querySelector('[data-visit-dialog]'); if(!dialog) return;
      const opener = this.querySelector('[data-visit-open]');
      const date = dialog.querySelector('[data-visit-date]');
      const times = dialog.querySelector('[data-visit-times]');
      const status = dialog.querySelector('[data-visit-status]');
      const submit = dialog.querySelector('[data-visit-submit]');
      const form = dialog.querySelector('form');
      const nowNZ = () => {
        const parts = new Intl.DateTimeFormat('en-NZ',{timeZone:'Pacific/Auckland',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
        const values = Object.fromEntries(parts.map(p=>[p.type,p.value]));
        return {date:`${values.year}-${values.month}-${values.day}`, minutes:Number(values.hour)*60+Number(values.minute)};
      };
      const drawTimes = () => {
        if(!date) return;
        const now=nowNZ(); date.min=now.date;
        const previous=times.querySelector('input:checked')?.value;
        times.replaceChildren(); submit.disabled=true;
        if(!date.value || date.value<now.date){status.textContent='Select today or a future date.';return;}
        const interval=Number(dialog.dataset.interval)===60?60:30;
        let count=0;
        for(let minute=600;minute<=1080;minute+=interval){
          const hour=Math.floor(minute/60), m=minute%60;
          const value=`${String(hour).padStart(2,'0')}:${String(m).padStart(2,'0')}`;
          const label=document.createElement('label');label.className='sc-visit__slot';
          const input=document.createElement('input');input.type='radio';input.name='contact[Visit time]';input.value=value;input.required=true;
          input.disabled=date.value===now.date && minute<=now.minutes;
          input.checked=!input.disabled && previous===value;
          if(!input.disabled)count++;
          if(input.checked)submit.disabled=false;
          const span=document.createElement('span');span.textContent=`${hour%12||12}:${String(m).padStart(2,'0')} ${hour<12?'am':'pm'}`;
          label.append(input,span);times.append(label);
        }
        status.textContent=count?'Choose a preferred arrival time (Auckland time).':'Today’s visit times have passed. Please choose another day.';
      };
      opener?.addEventListener('click',()=>{drawTimes();dialog.showModal();},{signal});
      dialog.querySelector('[data-visit-close]').addEventListener('click',()=>dialog.close(),{signal});
      dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}},{signal});
      dialog.addEventListener('close',()=>opener?.focus(),{signal});
      if(date){
        date.min=nowNZ().date;
        date.addEventListener('change',drawTimes,{signal});
        times.addEventListener('change',()=>{submit.disabled=!times.querySelector('input:checked');},{signal});
        form.addEventListener('submit',e=>{
          const now=nowNZ(), selected=times.querySelector('input:checked');
          const value=selected?.value.split(':').map(Number);
          if(!selected || date.value<now.date || (date.value===now.date && value[0]*60+value[1]<=now.minutes)){
            e.preventDefault();drawTimes();status.textContent='Please choose a future date and time.';date.focus();return;
          }
        },{signal});
      }
      if(dialog.querySelector('[data-visit-result]'))dialog.showModal();
    }
    disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();this.querySelector('dialog[open]')?.close();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-about-story"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=r=>r.querySelectorAll('[data-sas]:not([data-ready])').forEach(e=>{e.dataset.ready='true';const o=new IntersectionObserver(a=>{if(a[0].isIntersecting){e.classList.add('is-visible');o.disconnect()}},{threshold:.08});o.observe(e);
/* hosted videos: only play while on screen, so several rows don't all run at once */
e.querySelectorAll('.sas__media--video video[autoplay]').forEach(v=>{v.muted=true;const io=new IntersectionObserver(a=>{a.forEach(x=>{if(x.isIntersecting){v.play().catch(()=>{})}else{v.pause()}})},{threshold:.25});io.observe(v)})})
;init(document);document.addEventListener('shopify:section:load',e=>init(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-about-timeline"] && !Shopify.designMode) return;
  try {
    

(()=>{
 const init=root=>root.querySelectorAll('[data-sat]:not([data-ready])').forEach(section=>{
  section.dataset.ready='true';
  const ctrl=new AbortController(),signal=ctrl.signal;
  const viewport=section.querySelector('[data-sat-viewport]'),track=section.querySelector('[data-sat-track]'),cards=[...section.querySelectorAll('[data-sat-card]')],cursor=section.querySelector('[data-sat-cursor]');
  const behavior=()=>matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth';
  const isControl=el=>!!el.closest('button,a,.sat__story-inner,.sat__gallery,.sat__photo-tools');
  let openTimer=0,suppressUntil=0;
  const galleries=new Map();
  const backToStory=card=>{
   const g=galleries.get(card);if(!g)return;
   card.classList.remove('is-viewing');g.gallery.hidden=true;g.back.hidden=true;g.index=-1;
   g.photos.forEach(p=>p.hidden=true);g.thumbs.forEach(t=>t.setAttribute('aria-pressed','false'));
  };
  const showPhoto=(card,index)=>{
   const g=galleries.get(card);if(!g?.photos.length)return;
   g.index=(index+g.photos.length)%g.photos.length;
   g.gallery.hidden=false;g.back.hidden=false;card.classList.add('is-viewing');
   g.photos.forEach((p,i)=>p.hidden=i!==g.index);
   g.thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===g.index)));
   g.gallery.querySelector('[data-sat-photo-status]').textContent=`${g.index+1} / ${g.photos.length}`;
   const thumb=g.thumbs[g.index],rail=thumb.parentElement;
   if(thumb.offsetLeft<rail.scrollLeft)rail.scrollLeft=thumb.offsetLeft;
   else if(thumb.offsetLeft+thumb.offsetWidth>rail.scrollLeft+rail.clientWidth)rail.scrollLeft=thumb.offsetLeft+thumb.offsetWidth-rail.clientWidth;
  };
  cards.forEach(card=>{
   card.classList.toggle('is-mobile-image',section.dataset.mobileStyle==='image');
   const gallery=card.querySelector('[data-sat-gallery]');if(!gallery)return;
   const photos=[...gallery.querySelectorAll('[data-sat-photo]')],thumbs=[...card.querySelectorAll('[data-sat-thumb]')];
   const back=card.querySelector('[data-sat-back]');galleries.set(card,{gallery,photos,thumbs,back,index:-1});
   card.classList.toggle('has-photos',photos.length>0);
   gallery.querySelectorAll('.sat__photo-arrow').forEach(b=>b.hidden=photos.length<2);
   thumbs.forEach((t,i)=>t.addEventListener('click',()=>showPhoto(card,i),{signal}));
   gallery.querySelector('[data-sat-photo-prev]').addEventListener('click',()=>showPhoto(card,galleries.get(card).index-1),{signal});
   gallery.querySelector('[data-sat-photo-next]').addEventListener('click',()=>showPhoto(card,galleries.get(card).index+1),{signal});
   back.addEventListener('click',()=>{const i=galleries.get(card).index;backToStory(card);thumbs[i]?.focus({preventScroll:true});},{signal});
   let gesture=null;
   gallery.addEventListener('pointerdown',e=>{
    if(e.target.closest('button')||!e.isPrimary||e.button!==0)return;
    gesture={id:e.pointerId,x:e.clientX,y:e.clientY};gallery.setPointerCapture(e.pointerId);
   },{signal});
   gallery.addEventListener('pointerup',e=>{
    if(!gesture||gesture.id!==e.pointerId)return;
    const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;gesture=null;
    if(gallery.hasPointerCapture(e.pointerId))gallery.releasePointerCapture(e.pointerId);
    if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.25)showPhoto(card,galleries.get(card).index+(dx<0?1:-1));
   },{signal});
   gallery.addEventListener('pointercancel',()=>{gesture=null;},{signal});
   gallery.addEventListener('dragstart',e=>e.preventDefault(),{signal});
  });
  const setOpen=(card,open)=>{
   const story=card.querySelector('[data-sat-story]');if(!story)return;
   backToStory(card);card.classList.toggle('is-open',open);story.hidden=!open;
   card.querySelector('[data-sat-close]').hidden=!open;
   card.querySelector('[data-sat-photo-tools]').hidden=!open||!galleries.get(card)?.photos.length;
   card.querySelectorAll('[data-sat-toggle]').forEach(t=>t.setAttribute('aria-expanded',String(open)));
  };
  const syncTrack=()=>track.classList.toggle('has-open',cards.some(c=>c.classList.contains('is-open')));
  const close=card=>{clearTimeout(openTimer);setOpen(card,false);syncTrack();card.querySelector('[data-sat-toggle]')?.focus({preventScroll:true});};
  const open=card=>{
   clearTimeout(openTimer);cards.forEach(c=>{if(c!==card)setOpen(c,false);});setOpen(card,true);syncTrack();
   openTimer=setTimeout(()=>{if(!card.classList.contains('is-open'))return;viewport.scrollTo({left:card.offsetLeft-14,behavior:behavior()});},480);
  };
  section.addEventListener('click',e=>{
   const t=e.target.closest('[data-sat-toggle]');if(t){const c=t.closest('[data-sat-card]');c.classList.contains('is-open')?close(c):open(c);return;}
   const x=e.target.closest('[data-sat-close]');if(x)close(x.closest('[data-sat-card]'));
  },{signal});
  section.addEventListener('keydown',e=>{
   const card=e.target.closest('[data-sat-card]');if(!card?.classList.contains('is-open'))return;
   if(e.key==='Escape'){e.preventDefault();if(card.classList.contains('is-viewing')){const i=galleries.get(card).index;backToStory(card);galleries.get(card).thumbs[i]?.focus();}else close(card);}
   if(card.classList.contains('is-viewing')&&(e.key==='ArrowLeft'||e.key==='ArrowRight')){e.preventDefault();showPhoto(card,galleries.get(card).index+(e.key==='ArrowRight'?1:-1));}
  },{signal});
  section.addEventListener('shopify:block:select',e=>{const c=e.target.closest('[data-sat-card]');if(c?.querySelector('[data-sat-story]'))open(c);},{signal});
  let down=false,startX=0,startScroll=0,moved=false;
  viewport.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'||e.button!==0||isControl(e.target))return;down=true;moved=false;startX=e.clientX;startScroll=viewport.scrollLeft;},{signal});
  viewport.addEventListener('pointermove',e=>{if(cursor){cursor.style.left=e.clientX+'px';cursor.style.top=e.clientY+'px';}const over=isControl(e.target);viewport.classList.toggle('is-over-control',over);cursor?.classList.toggle('is-visible',!over&&e.pointerType==='mouse');},{signal});
  window.addEventListener('pointermove',e=>{if(!down)return;const dx=e.clientX-startX;if(Math.abs(dx)>8)moved=true;if(moved){viewport.classList.add('is-dragging');viewport.scrollLeft=startScroll-dx;e.preventDefault();}},{signal});
  const end=()=>{if(down&&moved)suppressUntil=performance.now()+400;down=false;viewport.classList.remove('is-dragging');};
  window.addEventListener('pointerup',end,{signal});window.addEventListener('pointercancel',end,{signal});
  viewport.addEventListener('mouseleave',()=>cursor?.classList.remove('is-visible'),{signal});
  viewport.addEventListener('click',e=>{if(performance.now()<suppressUntil){e.preventDefault();e.stopImmediatePropagation();}},{signal,capture:true});
  const reveal=()=>section.classList.add('is-visible');let observer;
  if(!('IntersectionObserver'in window))reveal();else{observer=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){reveal();observer.disconnect();}},{threshold:.1});observer.observe(section);}
  document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(section)){ctrl.abort();observer?.disconnect();clearTimeout(openTimer);}},{signal});
 });
 init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-about-values"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => root.querySelectorAll('[data-sav]:not([data-ready])').forEach((section) => {
      section.dataset.ready = 'true';
      if (!('IntersectionObserver' in window)) { section.classList.add('is-visible'); return; }
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        section.classList.add('is-visible');
        observer.disconnect();
      }, { threshold: .12 });
      observer.observe(section);
    });
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-bed-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sleepy-carousel')){
  customElements.define('sleepy-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.ctrl)return;
      this.track=this.querySelector('[data-sc-track]');
      if(!this.track)return;
      this.ctrl=new AbortController();
      const signal=this.ctrl.signal;
      this.slides=Array.from(this.track.children).filter(n=>n.nodeType===1);
      this.bar=this.querySelector('[data-sc-controls]');
      this.prevBtn=this.querySelector('[data-sc-prev]');
      this.nextBtn=this.querySelector('[data-sc-next]');
      this.pauseBtn=this.querySelector('[data-sc-pause]');
      this.dots=Array.from(this.querySelectorAll('[data-sc-dot]'));
      const reduce=matchMedia('(prefers-reduced-motion:reduce)');
      const behavior=()=>reduce.matches?'auto':'smooth';
      const maxScroll=()=>this.track.scrollWidth-this.track.clientWidth;
      const step=dir=>this.track.scrollBy({left:dir*this.track.clientWidth*0.9,behavior:behavior()});
      const goTo=i=>{
        const slide=this.slides[i];
        if(slide)this.track.scrollTo({left:slide.offsetLeft-this.track.offsetLeft,behavior:behavior()});
      };
      this.prevBtn?.addEventListener('click',()=>step(-1),{signal});
      this.nextBtn?.addEventListener('click',()=>step(1),{signal});
      this.dots.forEach(dot=>dot.addEventListener('click',()=>goTo(Number(dot.dataset.scDot)),{signal}));
      this.sync=()=>{
        const max=maxScroll();
        const scrollable=max>2;
        if(this.bar)this.bar.hidden=!scrollable;
        if(!scrollable)return;
        const x=this.track.scrollLeft;
        let best=0,bd=Infinity;
        this.slides.forEach((s,i)=>{const d=Math.abs(s.offsetLeft-this.track.offsetLeft-x);if(d<bd){bd=d;best=i}});
        this.dots.forEach((d,i)=>d.setAttribute('aria-selected',String(i===best)));
        if(this.prevBtn)this.prevBtn.disabled=x<=1;
        if(this.nextBtn)this.nextBtn.disabled=x>=max-1;
      };
      this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.raf);this.raf=requestAnimationFrame(this.sync)},{signal,passive:true});
      this.ro=new ResizeObserver(()=>this.sync());this.ro.observe(this.track);
      this.sync();

      // Pointer dragging. Touch is left to native panning so the browser can
      // axis-lock and still scroll the page vertically from inside the track.
      //
      // Deliberately no setPointerCapture: a captured pointer makes the browser
      // dispatch the following click to the capturing element instead of the
      // link under the cursor, so cards stop navigating. Window-level listeners
      // keep tracking a drag past the element edge without that side effect.
      // The threshold must also clear ordinary click drift (a trackpad press
      // easily moves 5-6px), or a plain click gets treated as a drag.
      const DRAG_START=10;
      let pending=false,dragging=false,startX=0,startLeft=0,travel=0;
      const onMove=e=>{
        if(!pending)return;
        const dx=e.clientX-startX;
        travel=Math.max(travel,Math.abs(dx));
        if(!dragging){
          if(travel<DRAG_START)return;
          dragging=true;this.track.style.cursor='grabbing';
        }
        this.track.scrollLeft=startLeft-dx;
        e.preventDefault();
      };
      const onUp=()=>{
        if(!pending)return;
        const wasDrag=dragging;
        pending=false;dragging=false;this.track.style.cursor='';
        if(wasDrag)this.track.addEventListener('click',ev=>{ev.preventDefault();ev.stopPropagation()},{capture:true,once:true});
      };
      this.track.addEventListener('pointerdown',e=>{
        if(e.pointerType==='touch'||e.button!==0)return;
        pending=true;dragging=false;travel=0;
        startX=e.clientX;startLeft=this.track.scrollLeft;
      },{signal});
      addEventListener('pointermove',onMove,{signal});
      addEventListener('pointerup',onUp,{signal});
      addEventListener('pointercancel',onUp,{signal});
      this.track.addEventListener('dragstart',e=>{if(dragging)e.preventDefault()},{signal});

      // Mobile tap navigation. Some browsers suppress the synthetic click on
      // links inside a horizontal scroller. Navigate directly after a short,
      // stationary touch while preserving genuine carousel swipes.
      let touchCard=null,touchX=0,touchY=0,touchMoved=false;
      this.track.addEventListener('pointerdown',e=>{
        if(e.pointerType!=='touch'&&e.pointerType!=='pen')return;
        touchCard=e.target.closest('[data-sc-card-url]');
        if(!touchCard)return;
        touchX=e.clientX;touchY=e.clientY;touchMoved=false;
      },{signal,passive:true});
      this.track.addEventListener('pointermove',e=>{
        if(!touchCard||(e.pointerType!=='touch'&&e.pointerType!=='pen'))return;
        if(Math.hypot(e.clientX-touchX,e.clientY-touchY)>10)touchMoved=true;
      },{signal,passive:true});
      this.track.addEventListener('pointerup',e=>{
        if(!touchCard||(e.pointerType!=='touch'&&e.pointerType!=='pen'))return;
        const card=touchCard;touchCard=null;
        if(touchMoved)return;
        const url=card.dataset.scCardUrl;
        if(url){e.preventDefault();window.location.assign(url)}
      },{signal});
      this.track.addEventListener('pointercancel',()=>{touchCard=null;touchMoved=false},{signal});
      this.addEventListener('keydown',e=>{
        if(e.target.closest('a,button')&&!e.target.closest('[data-sc-track]'))return;
        if(e.key==='ArrowLeft'){e.preventDefault();step(-1)}
        if(e.key==='ArrowRight'){e.preventDefault();step(1)}
      },{signal});
      this.addEventListener('shopify:block:select',e=>{
        const slide=e.target.closest('[data-sc-track] > *');
        if(slide)this.track.scrollTo({left:slide.offsetLeft-this.track.offsetLeft,behavior:'auto'});
      },{signal});

      // Autoplay, opt-in per section. Absent attributes leave it off.
      const interval=Number(this.dataset.scInterval)||0;
      if(this.dataset.scAutoplay==='true'&&interval>0){
        let paused=false;
        const stop=()=>{clearInterval(this.timer);this.timer=null};
        const start=()=>{
          stop();
          if(paused||reduce.matches||document.hidden||maxScroll()<=2)return;
          this.timer=setInterval(()=>{
            if(this.track.scrollLeft>=maxScroll()-2)this.track.scrollTo({left:0,behavior:behavior()});
            else step(1);
          },interval);
        };
        // A deliberate interaction ends autoplay for the session.
        const halt=()=>{paused=true;stop();if(this.pauseBtn)setPause(true)};
        const setPause=state=>{
          this.pauseBtn.setAttribute('aria-pressed',String(state));
          this.pauseBtn.setAttribute('aria-label',state?'Play carousel':'Pause carousel');
          this.pauseBtn.textContent=state?'▶':'❙❙';
        };
        this.addEventListener('pointerenter',stop,{signal});
        this.addEventListener('pointerleave',start,{signal});
        this.addEventListener('focusin',stop,{signal});
        this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget))start()},{signal});
        document.addEventListener('visibilitychange',()=>document.hidden?stop():start(),{signal});
        this.track.addEventListener('pointerdown',halt,{signal});
        this.track.addEventListener('touchstart',halt,{signal,passive:true});
        this.prevBtn?.addEventListener('click',halt,{signal});
        this.nextBtn?.addEventListener('click',halt,{signal});
        this.dots.forEach(d=>d.addEventListener('click',halt,{signal}));
        if(this.pauseBtn){
          setPause(false);
          this.pauseBtn.addEventListener('click',()=>{paused=!paused;setPause(paused);paused?stop():start()},{signal});
        }
        start();
      }
    }
    disconnectedCallback(){
      this.ctrl?.abort();this.ctrl=null;
      this.ro?.disconnect();
      cancelAnimationFrame(this.raf);
      clearInterval(this.timer);
    }
  });
}
if(!window.__sleepyReveal){
  window.__sleepyReveal=true;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}});
  },{rootMargin:'0px 0px -6% 0px',threshold:0.08}):null;
  const scan=root=>{
    root.querySelectorAll('[data-sc-reveal]:not([data-sc-seen])').forEach(el=>{
      el.dataset.scSeen='1';
      if(!io||reduce.matches||el.closest('[data-animation="none"]'))el.classList.add('is-in');
      else io.observe(el);
    });
  };
  window.__sleepyRevealScan=scan;
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
}else{window.__sleepyRevealScan?.(document)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-bedroom-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sleepy-bedroom-arranged-collage')){
  customElements.define('sleepy-bedroom-arranged-collage',class extends HTMLElement{
    connectedCallback(){
      if(this.ctrl)return;
      this.canvas=this.querySelector('[data-rbg-canvas]');
      if(!this.canvas)return;
      this.ctrl=new AbortController();
      const signal=this.ctrl.signal;
      this.cue=this.querySelector('[data-rbg-cue]');
      // Reuse real uploads as smaller decorative depth images.
      this.canvas.querySelectorAll('[data-rbg-depth]').forEach(el=>el.remove());
      const originals=[...this.canvas.children].filter(el=>!el.hasAttribute('data-sc-clone'));
      // Reset all original blocks, including photos saved with the old editor.
      originals.forEach(tile=>{
        ['--x','--y','--w','--mw','left','top','width','height','translate','rotate','filter','z-index'].forEach(key=>tile.style.removeProperty(key));
        tile.style.setProperty('--rot','0deg');tile.style.setProperty('--blur','0px');tile.style.setProperty('--z','3');
        tile.classList.add('is-in');
      });
      originals.filter((tile,i)=>i%3===0).forEach((tile,i)=>{
        const source=tile.querySelector('img');if(!source)return;
        const depth=document.createElement('figure');depth.className='rbg__tile rbg__tile--depth';
        depth.dataset.rbgDepth=String(i);depth.setAttribute('aria-hidden','true');
        depth.style.setProperty('--r',tile.style.getPropertyValue('--r'));
        const img=source.cloneNode(true);img.alt='';depth.append(img);this.canvas.append(depth);
      });

      this.tiles=Array.from(this.canvas.children).filter(n=>n.nodeType===1&&!n.hasAttribute('data-sc-clone'));
      const fine=matchMedia('(hover:hover) and (pointer:fine)');
      const wide=matchMedia('(min-width:990px)');
      const reduce=matchMedia('(prefers-reduced-motion:reduce)');
      const enabled=()=>this.dataset.drag==='true'&&fine.matches&&wide.matches;
      const loopX=()=>this.dataset.loop==='x'||this.dataset.loop==='both';
      const loopY=()=>false;
      const hoverPaused=()=>this.dataset.pauseHover==='true'&&fine.matches&&this.matches(':hover');
      const DRAG_START=10;
      const PAD=12;
      let ox=0,oy=0,pending=false,dragging=false,sx=0,sy=0,bx=0,by=0,moved=0;
      let vx=0,vy=0,lastX=0,lastY=0,lastT=0,glideRaf=null,box=null;
      let inView=!("IntersectionObserver" in window),lastFrame=performance.now(),autoRaf=null;

      const measure=()=>{
        const vw=this.clientWidth,vh=this.clientHeight;
        if(wide.matches){
          // Seeded scatter: organic positions that stay stable on resize.
          let seed=(Number(this.dataset.arrangement)||17)*419;
          const random=()=>{seed=(Math.imul(seed,1664525)+1013904223)>>>0;return seed/4294967296};
          const gap=Number(this.dataset.photoGap)||44,edge=gap;
          let canvasWidth=Math.max(vw,Math.ceil(originals.length/7)*vw);
          const placed=[];
          const heading=this.querySelector('.rbg__intro');
          const titleWidth=Math.min(vw*.55,620);
          const titleHeight=Math.min(vh*.26,(heading?.offsetHeight||120)+32);
          const reserved={x:(vw-titleWidth)/2,y:(vh-titleHeight)/2,w:titleWidth,h:titleHeight};
          const intersects=(a,b)=>a.x<b.x+b.w+gap&&a.x+a.w+gap>b.x&&a.y<b.y+b.h+gap&&a.y+a.h+gap>b.y;
          this.tiles.forEach((tile,i)=>{
            const ratio=Math.max(.7,Math.min(1.65,parseFloat(tile.style.getPropertyValue('--r'))||1.33));
            const isDepth=tile.hasAttribute('data-rbg-depth');
            const size=isDepth?.34+random()*.12:(i%5===0?1:.65+random()*.25);
            let width=Math.min(330,vw*.26)*size;
            let height=width/ratio;
            if(height>vh*.38){height=vh*.38;width=height*ratio;}
            let candidate=null;
            // Keep the original first-screen scatter. Once that fills up,
            // pack into the nearest available space instead of a huge canvas.
            for(let attempt=0;attempt<300;attempt++){
              const x=edge+random()*Math.max(1,vw-width-2*edge);
              const y=edge+random()*Math.max(1,vh-height-2*edge);
              const test={x,y,w:width,h:height};
              if(!intersects(test,reserved)&&!placed.some(other=>intersects(test,other))){candidate=test;break;}
            }
            if(!candidate){
              const xs=[edge,...placed.map(r=>r.x+r.w+gap+1)].sort((a,b)=>a-b);
              const ys=[edge,...placed.map(r=>r.y+r.h+gap+1)];
              for(let y=edge;y<=vh-height-edge;y+=24)ys.push(y);
              // Shuffle heights while selecting the smallest possible x.
              const heights=ys.filter(y=>y+height<=vh-edge).map(y=>({y,key:random()})).sort((a,b)=>a.key-b.key);
              for(const x of xs){
                for(const entry of heights){
                  const test={x,y:entry.y,w:width,h:height};
                  if(!intersects(test,reserved)&&!placed.some(other=>intersects(test,other))){candidate=test;break;}
                }
                if(candidate)break;
              }
            }
            if(!candidate){candidate={x:Math.max(edge,...placed.map(r=>r.x+r.w+gap+1)),y:edge,w:width,h:height};}
            placed.push(candidate);
            tile.style.left=candidate.x+'px';tile.style.top=candidate.y+'px';
            tile.style.width=width+'px';tile.style.height=height+'px';
            tile.style.setProperty('--rot','0deg');
          });
          canvasWidth=Math.max(vw,...placed.map(r=>r.x+r.w+edge));
          this.canvas.style.width=canvasWidth+'px';this.canvas.style.left='0';this.canvas.style.marginLeft='0';
        }else{
          ['width','left','margin-left'].forEach(key=>this.canvas.style.removeProperty(key));
          this.tiles.forEach(tile=>['left','top','width','height','--rot'].forEach(key=>tile.style.removeProperty(key)));
        }
        let maxW=0,maxH=0;
        this.tiles.forEach(t=>{
          t._x=t.offsetLeft;t._y=t.offsetTop;t._w=t.offsetWidth;t._h=t.offsetHeight;
          if(t._w>maxW)maxW=t._w;
          if(t._h>maxH)maxH=t._h;
        });
        box={
          pw:this.canvas.offsetWidth,
          ph:Math.max(this.canvas.offsetHeight,vh+maxH+2*PAD+16),
          maxX:Math.max(0,(this.canvas.offsetWidth-vw)/2),
          maxY:0
        };
      };
      const wrap=(v,size,period)=>((v+size+PAD)%period+period)%period-size-PAD;
      const layout=()=>{
        if(!box)measure();
        if(!wide.matches){this.tiles.forEach(t=>{t.style.translate=''});return}
        const wx=loopX(),wy=loopY();
        if(!wx)ox=Math.min(box.maxX,Math.max(-box.maxX,ox));
        if(!wy)oy=Math.min(box.maxY,Math.max(-box.maxY,oy));
        this.tiles.forEach(t=>{
          const x=wx?wrap(t._x+ox,t._w,box.pw)-t._x:ox;
          const y=wy?wrap(t._y+oy,t._h,box.ph)-t._y:oy;
          t.style.translate=x+'px '+y+'px';
        });
      };
      const stopGlide=()=>{if(glideRaf){cancelAnimationFrame(glideRaf);glideRaf=null}};
      const glide=()=>{
        vx*=0.93;vy*=0.93;
        if(Math.abs(vx)<0.15&&Math.abs(vy)<0.15){glideRaf=null;return}
        ox+=vx;oy+=vy;layout();glideRaf=requestAnimationFrame(glide);
      };
      const moveCue=e=>{
        if(!this.cue)return;
        const r=this.getBoundingClientRect();
        this.cue.style.translate=(e.clientX-r.left)+'px '+(e.clientY-r.top)+'px';
      };
      const autoTick=time=>{
        const elapsed=Math.min(50,time-lastFrame)/1000;lastFrame=time;
        const speed=Number(this.dataset.speed)||18;
        if(this.dataset.autoplay==='true'&&wide.matches&&inView&&!document.hidden&&!reduce.matches&&!pending&&!dragging&&!glideRaf&&!hoverPaused()){
          ox-=speed*elapsed;layout();
        }
        autoRaf=requestAnimationFrame(autoTick);
      };

      this.addEventListener('pointerenter',e=>{if(enabled()){this.classList.add('is-hover');moveCue(e)}},{signal});
      this.addEventListener('pointerleave',()=>this.classList.remove('is-hover'),{signal});
      this.addEventListener('pointerdown',e=>{
        if(!enabled()||e.button!==0||e.pointerType==='touch')return;
        stopGlide();pending=true;dragging=false;moved=0;
        sx=e.clientX;sy=e.clientY;bx=ox;by=oy;
        lastX=e.clientX;lastY=e.clientY;lastT=performance.now();vx=0;vy=0;
      },{signal});
      addEventListener('pointermove',e=>{
        if(enabled())moveCue(e);
        if(!pending)return;
        const dx=e.clientX-sx,dy=e.clientY-sy;
        moved=Math.max(moved,Math.abs(dx)+Math.abs(dy));
        if(!dragging){if(moved<DRAG_START)return;dragging=true;this.classList.add('is-dragging')}
        ox=bx+dx;oy=by+dy;layout();
        const now=performance.now(),dt=now-lastT;
        if(dt>0){vx=(e.clientX-lastX)/dt*16;vy=(e.clientY-lastY)/dt*16}
        lastX=e.clientX;lastY=e.clientY;lastT=now;e.preventDefault();
      },{signal});
      const end=()=>{
        if(!pending)return;
        const wasDrag=dragging;pending=false;dragging=false;this.classList.remove('is-dragging');
        if(wasDrag&&moved>6)this.addEventListener('click',ev=>{ev.preventDefault();ev.stopPropagation()},{capture:true,once:true});
        if(wasDrag&&this.dataset.glide==='true'&&!reduce.matches&&(Math.abs(vx)>0.5||Math.abs(vy)>0.5))glide();
      };
      addEventListener('pointerup',end,{signal});
      addEventListener('pointercancel',end,{signal});
      this.addEventListener('dragstart',e=>e.preventDefault(),{signal});
      this.ro=new ResizeObserver(()=>{measure();layout()});this.ro.observe(this);
      this.addEventListener('shopify:block:select',()=>{measure();layout()},{signal});
      this.canvas.querySelectorAll('img').forEach(img=>{
        if(!img.complete)img.addEventListener('load',()=>{measure();layout()},{signal,once:true});
      });
      if('IntersectionObserver' in window){
        this.io=new IntersectionObserver(entries=>{entries.forEach(entry=>{inView=entry.isIntersecting})},{threshold:.05});
        this.io.observe(this);
      }else inView=true;
      requestAnimationFrame(()=>{measure();layout()});
      autoRaf=requestAnimationFrame(autoTick);
      this.autoRaf=()=>autoRaf;
    }
    disconnectedCallback(){
      this.ctrl?.abort();this.ctrl=null;this.ro?.disconnect();this.io?.disconnect();
      const frame=this.autoRaf?.();if(frame)cancelAnimationFrame(frame);
    }
  });
}

if(!customElements.get('sleepy-bedroom-arranged-carousel')){
  customElements.define('sleepy-bedroom-arranged-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.ctrl)return;
      this.track=this.querySelector('[data-sc-track]');
      if(!this.track)return;
      this.ctrl=new AbortController();
      const signal=this.ctrl.signal;
      this.slides=Array.from(this.track.children).filter(n=>n.nodeType===1&&!n.hasAttribute('data-rbg-depth'));
      this.bar=this.querySelector('[data-sc-controls]');
      this.prevBtn=this.querySelector('[data-sc-prev]');
      this.nextBtn=this.querySelector('[data-sc-next]');
      this.dots=Array.from(this.querySelectorAll('[data-sc-dot]'));
      const reduce=matchMedia('(prefers-reduced-motion:reduce)');
      const fine=matchMedia('(hover:hover) and (pointer:fine)');
      const wide=matchMedia('(min-width:990px)');
      const behavior=()=>reduce.matches?'auto':'smooth';
      const maxScroll=()=>this.track.scrollWidth-this.track.clientWidth;
      let cycleWidth=0,position=0,lastFrame=performance.now(),resumeAt=0,lastAutoWrite=-Infinity;
      let pending=false,dragging=false,startX=0,startLeft=0,travel=0,touching=false,autoRaf=null,buildId=0;
      const hoverPaused=()=>this.dataset.scPauseHover==='true'&&fine.matches&&this.matches(':hover');

      const removeClones=()=>this.track.querySelectorAll('[data-sc-clone]').forEach(clone=>clone.remove());
      const buildClones=()=>{
        const build=++buildId;
        removeClones();cycleWidth=0;position=0;this.track.scrollLeft=0;
        if(wide.matches||this.slides.length<2)return;
        this.slides.forEach(slide=>{
          const clone=slide.cloneNode(true);
          clone.dataset.scClone='';clone.removeAttribute('data-sc-reveal');clone.classList.add('is-in');clone.setAttribute('aria-hidden','true');
          clone.querySelectorAll('[data-sc-reveal]').forEach(el=>{el.removeAttribute('data-sc-reveal');el.classList.add('is-in')});
          clone.querySelectorAll('a,button').forEach(el=>el.tabIndex=-1);
          ;[clone,...clone.querySelectorAll('*')].forEach(el=>[...el.attributes].forEach(attr=>{if(attr.name.startsWith('data-shopify'))el.removeAttribute(attr.name)}));
          this.track.append(clone);
        });
        requestAnimationFrame(()=>{
          if(build!==buildId)return;
          const firstClone=this.track.querySelector('[data-sc-clone]');
          cycleWidth=firstClone?firstClone.offsetLeft-this.slides[0].offsetLeft:0;
          position=this.track.scrollLeft;
          this.sync();
        });
      };
      const logicalLeft=()=>cycleWidth?((this.track.scrollLeft%cycleWidth)+cycleWidth)%cycleWidth:this.track.scrollLeft;
      const step=dir=>{
        const amount=this.track.clientWidth*.9;
        position=this.track.scrollLeft+dir*amount;
        this.track.scrollTo({left:position,behavior:behavior()});resumeAt=performance.now()+900;
      };
      const goTo=i=>{
        const slide=this.slides[i];
        if(!slide)return;
        position=slide.offsetLeft-this.track.offsetLeft;
        this.track.scrollTo({left:position,behavior:behavior()});resumeAt=performance.now()+900;
      };
      this.sync=()=>{
        const scrollable=maxScroll()>2;if(this.bar)this.bar.hidden=!scrollable;
        if(!scrollable)return;
        const x=logicalLeft();let best=0,bd=Infinity;
        this.slides.forEach((slide,i)=>{const d=Math.abs(slide.offsetLeft-this.track.offsetLeft-x);if(d<bd){bd=d;best=i}});
        this.dots.forEach((dot,i)=>dot.setAttribute('aria-selected',String(i===best)));
        if(this.prevBtn)this.prevBtn.disabled=false;
        if(this.nextBtn)this.nextBtn.disabled=false;
      };
      this.prevBtn?.addEventListener('click',()=>step(-1),{signal});
      this.nextBtn?.addEventListener('click',()=>step(1),{signal});
      this.dots.forEach(dot=>dot.addEventListener('click',()=>goTo(Number(dot.dataset.scDot)),{signal}));
      this.track.addEventListener('scroll',()=>{
        if(pending||touching||performance.now()-lastAutoWrite>80)position=this.track.scrollLeft;
        cancelAnimationFrame(this.syncRaf);this.syncRaf=requestAnimationFrame(this.sync);
      },{signal,passive:true});

      const DRAG_START=10;
      const onMove=e=>{
        if(!pending||e.pointerType==='touch'||e.pointerType==='pen')return;
        const dx=e.clientX-startX;travel=Math.max(travel,Math.abs(dx));
        if(!dragging){if(travel<DRAG_START)return;dragging=true;this.track.style.cursor='grabbing'}
        position=startLeft-dx;this.track.scrollLeft=position;e.preventDefault();
      };
      const onUp=e=>{
        if(e?.pointerType==='touch'||e?.pointerType==='pen')return;
        if(!pending)return;
        const wasDrag=dragging;pending=false;dragging=false;this.track.style.cursor='';position=this.track.scrollLeft;resumeAt=performance.now()+700;
        if(wasDrag)this.track.addEventListener('click',ev=>{ev.preventDefault();ev.stopPropagation()},{capture:true,once:true});
      };
      this.track.addEventListener('pointerdown',e=>{
        if(e.pointerType==='touch'||e.pointerType==='pen'||e.button!==0||wide.matches)return;
        pending=true;dragging=false;travel=0;startX=e.clientX;startLeft=this.track.scrollLeft;position=startLeft;
      },{signal});
      addEventListener('pointermove',onMove,{signal});
      addEventListener('pointerup',onUp,{signal});
      addEventListener('pointercancel',onUp,{signal});
      this.track.addEventListener('dragstart',e=>{if(dragging)e.preventDefault()},{signal});

      let touchCard=null,touchX=0,touchY=0,touchMoved=false;
      this.track.addEventListener('pointerdown',e=>{
        if(e.pointerType!=='touch'&&e.pointerType!=='pen')return;
        touching=true;position=this.track.scrollLeft;resumeAt=Infinity;
        touchCard=e.target.closest('[data-sc-card-url]');touchX=e.clientX;touchY=e.clientY;touchMoved=false;
      },{signal,passive:true});
      this.track.addEventListener('pointermove',e=>{
        if(!touching||(e.pointerType!=='touch'&&e.pointerType!=='pen'))return;
        if(Math.hypot(e.clientX-touchX,e.clientY-touchY)>10)touchMoved=true;
      },{signal,passive:true});
      this.track.addEventListener('pointerup',e=>{
        if(e.pointerType!=='touch'&&e.pointerType!=='pen')return;
        const card=touchCard;touchCard=null;touching=false;position=this.track.scrollLeft;resumeAt=performance.now()+1200;
        if(!touchMoved&&card?.dataset.scCardUrl){e.preventDefault();window.location.assign(card.dataset.scCardUrl)}
      },{signal});
      this.track.addEventListener('pointercancel',()=>{touchCard=null;touchMoved=false;touching=false;position=this.track.scrollLeft;resumeAt=performance.now()+1200},{signal});
      this.addEventListener('keydown',e=>{
        if(e.target.closest('a,button')&&!e.target.closest('[data-sc-track]'))return;
        if(e.key==='ArrowLeft'){e.preventDefault();step(-1)}
        if(e.key==='ArrowRight'){e.preventDefault();step(1)}
      },{signal});
      this.addEventListener('shopify:block:select',e=>{
        const slide=e.target.closest('[data-sc-track] > *');if(slide)goTo(this.slides.indexOf(slide));
      },{signal});

      const autoTick=time=>{
        const elapsed=Math.min(50,time-lastFrame)/1000;lastFrame=time;
        const speed=Number(this.dataset.scSpeed)||18;
        const canMove=this.dataset.scAutoplay==='true'&&!wide.matches&&cycleWidth>0&&!reduce.matches&&!document.hidden&&!pending&&!touching&&!hoverPaused()&&time>=resumeAt;
        if(canMove){
          position+=(speed*elapsed);
          if(position>=cycleWidth)position%=cycleWidth;
          if(position<0)position=cycleWidth+(position%cycleWidth);
          lastAutoWrite=time;
          this.track.scrollLeft=position;
        }
        autoRaf=requestAnimationFrame(autoTick);
      };
      const rebuild=()=>{buildClones();this.sync()};
      wide.addEventListener?.('change',rebuild,{signal});
      let observedWidth=this.track.clientWidth;
      this.ro=new ResizeObserver(()=>{
        const width=this.track.clientWidth;
        if(Math.abs(width-observedWidth)>1){observedWidth=width;buildClones()}
        this.sync();
      });
      this.ro.observe(this.track);buildClones();this.sync();
      autoRaf=requestAnimationFrame(autoTick);this.autoRaf=()=>autoRaf;
    }
    disconnectedCallback(){
      this.ctrl?.abort();this.ctrl=null;this.ro?.disconnect();
      cancelAnimationFrame(this.syncRaf);const frame=this.autoRaf?.();if(frame)cancelAnimationFrame(frame);
    }
  });
}

if(!window.__sleepyReveal){
  window.__sleepyReveal=true;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}});
  },{rootMargin:'0px 0px -6% 0px',threshold:0.08}):null;
  const scan=root=>{
    root.querySelectorAll('[data-sc-reveal]:not([data-sc-seen])').forEach(el=>{
      el.dataset.scSeen='1';
      if(!io||reduce.matches||el.closest('[data-animation="none"]'))el.classList.add('is-in');
      else io.observe(el);
    });
  };
  window.__sleepyRevealScan=scan;scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
}else{window.__sleepyRevealScan?.(document)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-benefits-bar"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('sleepy-benefits-smooth-loop')){
 customElements.define('sleepy-benefits-smooth-loop',class extends HTMLElement{
  connectedCallback(){
   if(this.ctrl)return;
   this.ctrl=new AbortController();const signal=this.ctrl.signal;
   const track=this.querySelector('[data-sc-track]');if(!track)return;
   const originals=[...track.children];
   const dots=[...this.querySelectorAll('[data-sc-dot]')];
   const controls=this.querySelector('[data-sc-controls]');
   const mobile=matchMedia('(max-width:749px)');
   const reduced=matchMedia('(prefers-reduced-motion:reduce)');
   let period=0,origin=0,position=0,last=0,inView=false,hold=false,focus=false,until=0,active=false,interacting=false,measuredWidth=-1;
   const speed=Number(this.dataset.speed)||28;
   const direction=1; // Increasing scrollLeft moves the visible cards left.
   const clones=[];
   // Copies on both sides allow forward and reverse swiping across the seam.
   const copy=()=>originals.map(el=>{
    const c=el.cloneNode(true);c.dataset.sbbClone='';c.setAttribute('aria-hidden','true');
    c.removeAttribute('data-shopify-editor-block');c.removeAttribute('id');
    c.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));
    c.querySelectorAll('a,button,input,[tabindex]').forEach(n=>n.tabIndex=-1);
    clones.push(c);return c;
   });
   const farBefore=copy(),before=copy(),after=copy(),farAfter=copy();
   track.prepend(...farBefore,...before);track.append(...after,...farAfter);
   const wrap=x=>origin+((x-origin)%period+period)%period;
   const current=()=>{
    if(!active)return 0;
    const offset=((track.scrollLeft-origin)%period+period)%period;
    let index=0,distance=Infinity;
    originals.forEach((el,i)=>{const d=Math.abs(el.offsetLeft-originals[0].offsetLeft-offset);if(d<distance){distance=d;index=i;}});
    return index;
   };
   const sync=()=>{const i=current();dots.forEach((d,n)=>d.setAttribute('aria-selected',String(n===i)));};
   const layout=()=>{
    const width=track.clientWidth;
    const nextActive=mobile.matches && track.dataset.mobile==='carousel' && originals.length>1;
    if(Math.abs(width-measuredWidth)<1 && nextActive===active)return;
    measuredWidth=width;
    const fraction=period?((position-origin)%period+period)%period/period:0;
    active=mobile.matches && track.dataset.mobile==='carousel' && originals.length>1;
    track.classList.toggle('is-looping',active);
    if(controls)controls.hidden=!active;
    if(active){
     period=originals[0].offsetLeft-before[0].offsetLeft;
     origin=period*2;position=origin+fraction*period;track.scrollLeft=position;
    }else{period=0;position=0;track.scrollLeft=0;}
    last=0;sync();
   };
   const go=i=>{
    if(!active||!period)return;
    interacting=true;until=performance.now()+900;
    const index=(i+originals.length)%originals.length;
    position=origin+originals[index].offsetLeft-originals[0].offsetLeft;
    track.scrollTo({left:position,behavior:reduced.matches?'auto':'smooth'});
   };
   this.querySelector('[data-sc-prev]')?.addEventListener('click',()=>go(current()-1),{signal});
   this.querySelector('[data-sc-next]')?.addEventListener('click',()=>go(current()+1),{signal});
   dots.forEach((d,i)=>d.addEventListener('click',()=>go(i),{signal}));
   track.addEventListener('touchstart',()=>{hold=true;interacting=true;position=track.scrollLeft;last=0;},{signal,passive:true});
   const release=e=>{if(e.touches?.length)return;hold=false;interacting=true;until=performance.now()+900;position=track.scrollLeft;};
   track.addEventListener('touchend',release,{signal,passive:true});
   track.addEventListener('touchcancel',release,{signal,passive:true});
   track.addEventListener('scroll',()=>{
    if(interacting){
     position=track.scrollLeft;
     // Keep extending the pause while native swipe momentum is still moving.
     until=performance.now()+900;
    }
    sync();
   },{signal,passive:true});
   track.addEventListener('wheel',()=>{interacting=true;until=performance.now()+900;},{signal,passive:true});
   this.addEventListener('focusin',()=>{focus=true;},{signal});
   this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget))focus=false;},{signal});
   this.addEventListener('shopify:block:select',e=>{const i=originals.indexOf(e.target.closest('.sbb__item'));if(i>=0){go(i);focus=true;}},{signal});
   this.addEventListener('shopify:block:deselect',()=>{focus=false;},{signal});
   this.ro=new ResizeObserver(layout);this.ro.observe(track);
   mobile.addEventListener('change',layout,{signal});
   reduced.addEventListener('change',()=>{last=0;},{signal});
   if('IntersectionObserver' in window){this.io=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;last=0;},{threshold:0.05});this.io.observe(this);}else inView=true;
   const tick=time=>{
    const dt=last?Math.min(time-last,40)/1000:0;last=time;
    if(active&&period&&inView&&!document.hidden&&!hold&&!focus&&time>=until&&!reduced.matches){
     if(interacting){
      // Resume from the final native scroll position, never the touch-end position.
      position=track.scrollLeft;interacting=false;last=time;
     }
     position=wrap(position+direction*speed*dt);track.scrollLeft=position;
    }
    this.raf=requestAnimationFrame(tick);
   };
   this.cleanup=()=>{clones.forEach(c=>c.remove());track.classList.remove('is-looping');};
   layout();this.raf=requestAnimationFrame(tick);
  }
  disconnectedCallback(){this.ctrl?.abort();this.ctrl=null;this.ro?.disconnect();this.io?.disconnect();cancelAnimationFrame(this.raf);this.cleanup?.();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-benefits"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>root.querySelectorAll('[data-scb]:not([data-ready])').forEach(section=>{section.dataset.ready='true';if(section.classList.contains('scb--none')||matchMedia('(prefers-reduced-motion:reduce)').matches){section.classList.add('is-visible');return}const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.2});observer.observe(section)});init(document);document.addEventListener('shopify:section:load',event=>init(event.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-category-beds"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sleepy-product-dots')) {
 customElements.define('sleepy-product-dots', class extends HTMLElement {
  connectedCallback() {
   if(this.abort) return;
   this.abort = new AbortController();
   this.frame = requestAnimationFrame(() => this.init());
  }
  init() {
   this.track = this.previousElementSibling;
   if(!this.track?.matches('[data-track]')) return;
   const signal = this.abort.signal;
   this.addEventListener('click', event => {
    const button = event.target.closest('button[data-slide]');
    if(!button) return;
    const left = this.positions[Number(button.dataset.slide)];
    if(left === undefined) return;
    this.track.scrollTo({left, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
   }, {signal});
   this.track.addEventListener('scroll', () => {
    if(this.scrollFrame) return;
    this.scrollFrame = requestAnimationFrame(() => {this.scrollFrame = 0; this.update();});
   }, {passive:true, signal});
   window.addEventListener('resize', () => this.build(), {signal});
   if('ResizeObserver' in window) {
    this.resize = new ResizeObserver(() => this.build());
    this.resize.observe(this.track);
   }
   this.build();
  }
  build() {
   const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
   const enabled = matchMedia('(max-width:749px)').matches && this.track.dataset.mobileLayout === 'slider' && max > 2;
   this.hidden = !enabled;
   this.track.classList.toggle('sc-has-dots', enabled);
   if(!enabled) return;
   const start = this.track.getBoundingClientRect().left;
   const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
   const positions = [];
   this.track.querySelectorAll('.sc-beds__card').forEach(card => {
    const left = Math.min(max, Math.max(0, card.getBoundingClientRect().left - start + this.track.scrollLeft - padding));
    if(!positions.length || Math.abs(left - positions[positions.length - 1]) > 2) positions.push(left);
   });
   this.positions = positions;
   if(this.children.length !== positions.length) {
    this.replaceChildren(...positions.map((_, index) => {
     const button = document.createElement('button');
     button.type = 'button'; button.dataset.slide = index;
     button.setAttribute('aria-label', `Go to product slide ${index + 1} of ${positions.length}`);
     return button;
    }));
   }
   this.update();
  }
  update() {
   if(!this.positions?.length) return;
   let active = 0;
   this.positions.forEach((left,index) => {
    if(Math.abs(left-this.track.scrollLeft) < Math.abs(this.positions[active]-this.track.scrollLeft)) active=index;
   });
   [...this.children].forEach((button,index) => button.setAttribute('aria-current', index === active ? 'true' : 'false'));
  }
  disconnectedCallback() {
   cancelAnimationFrame(this.frame); cancelAnimationFrame(this.scrollFrame);
   this.scrollFrame = 0;
   this.resize?.disconnect(); this.abort?.abort(); this.abort = null;
   this.track?.classList.remove('sc-has-dots');
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-category-cards"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sleepy-carousel')){
  customElements.define('sleepy-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.ctrl)return;
      this.track=this.querySelector('[data-sc-track]');
      if(!this.track)return;
      this.ctrl=new AbortController();
      const signal=this.ctrl.signal;
      this.slides=Array.from(this.track.children).filter(n=>n.nodeType===1);
      this.bar=this.querySelector('[data-sc-controls]');
      this.prevBtn=this.querySelector('[data-sc-prev]');
      this.nextBtn=this.querySelector('[data-sc-next]');
      this.pauseBtn=this.querySelector('[data-sc-pause]');
      this.dots=Array.from(this.querySelectorAll('[data-sc-dot]'));
      const reduce=matchMedia('(prefers-reduced-motion:reduce)');
      const behavior=()=>reduce.matches?'auto':'smooth';
      const maxScroll=()=>this.track.scrollWidth-this.track.clientWidth;
      const step=dir=>this.track.scrollBy({left:dir*this.track.clientWidth*0.9,behavior:behavior()});
      const goTo=i=>{
        const slide=this.slides[i];
        if(slide)this.track.scrollTo({left:slide.offsetLeft-this.track.offsetLeft,behavior:behavior()});
      };
      this.prevBtn?.addEventListener('click',()=>step(-1),{signal});
      this.nextBtn?.addEventListener('click',()=>step(1),{signal});
      this.dots.forEach(dot=>dot.addEventListener('click',()=>goTo(Number(dot.dataset.scDot)),{signal}));
      this.sync=()=>{
        const max=maxScroll();
        const scrollable=max>2;
        if(this.bar)this.bar.hidden=!scrollable;
        if(!scrollable)return;
        const x=this.track.scrollLeft;
        let best=0,bd=Infinity;
        this.slides.forEach((s,i)=>{const d=Math.abs(s.offsetLeft-this.track.offsetLeft-x);if(d<bd){bd=d;best=i}});
        this.dots.forEach((d,i)=>d.setAttribute('aria-selected',String(i===best)));
        if(this.prevBtn)this.prevBtn.disabled=x<=1;
        if(this.nextBtn)this.nextBtn.disabled=x>=max-1;
      };
      this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.raf);this.raf=requestAnimationFrame(this.sync)},{signal,passive:true});
      this.ro=new ResizeObserver(()=>this.sync());this.ro.observe(this.track);
      this.sync();

      // Pointer dragging. Touch is left to native panning so the browser can
      // axis-lock and still scroll the page vertically from inside the track.
      //
      // Deliberately no setPointerCapture: a captured pointer makes the browser
      // dispatch the following click to the capturing element instead of the
      // link under the cursor, so cards stop navigating. Window-level listeners
      // keep tracking a drag past the element edge without that side effect.
      // The threshold must also clear ordinary click drift (a trackpad press
      // easily moves 5-6px), or a plain click gets treated as a drag.
      const DRAG_START=10;
      let pending=false,dragging=false,startX=0,startLeft=0,travel=0;
      const onMove=e=>{
        if(!pending)return;
        const dx=e.clientX-startX;
        travel=Math.max(travel,Math.abs(dx));
        if(!dragging){
          if(travel<DRAG_START)return;
          dragging=true;this.track.style.cursor='grabbing';
        }
        this.track.scrollLeft=startLeft-dx;
        e.preventDefault();
      };
      const onUp=()=>{
        if(!pending)return;
        const wasDrag=dragging;
        pending=false;dragging=false;this.track.style.cursor='';
        if(wasDrag)this.track.addEventListener('click',ev=>{ev.preventDefault();ev.stopPropagation()},{capture:true,once:true});
      };
      this.track.addEventListener('pointerdown',e=>{
        if(e.pointerType==='touch'||e.button!==0)return;
        pending=true;dragging=false;travel=0;
        startX=e.clientX;startLeft=this.track.scrollLeft;
      },{signal});
      addEventListener('pointermove',onMove,{signal});
      addEventListener('pointerup',onUp,{signal});
      addEventListener('pointercancel',onUp,{signal});
      this.track.addEventListener('dragstart',e=>{if(dragging)e.preventDefault()},{signal});

      // Mobile tap navigation. Some browsers suppress the synthetic click on
      // links inside a horizontal scroller. Navigate directly after a short,
      // stationary touch while preserving genuine carousel swipes.
      let touchCard=null,touchX=0,touchY=0,touchMoved=false;
      this.track.addEventListener('pointerdown',e=>{
        if(e.pointerType!=='touch'&&e.pointerType!=='pen')return;
        touchCard=e.target.closest('[data-sc-card-url]');
        if(!touchCard)return;
        touchX=e.clientX;touchY=e.clientY;touchMoved=false;
      },{signal,passive:true});
      this.track.addEventListener('pointermove',e=>{
        if(!touchCard||(e.pointerType!=='touch'&&e.pointerType!=='pen'))return;
        if(Math.hypot(e.clientX-touchX,e.clientY-touchY)>10)touchMoved=true;
      },{signal,passive:true});
      this.track.addEventListener('pointerup',e=>{
        if(!touchCard||(e.pointerType!=='touch'&&e.pointerType!=='pen'))return;
        const card=touchCard;touchCard=null;
        if(touchMoved)return;
        const url=card.dataset.scCardUrl;
        if(url){e.preventDefault();window.location.assign(url)}
      },{signal});
      this.track.addEventListener('pointercancel',()=>{touchCard=null;touchMoved=false},{signal});

      this.addEventListener('keydown',e=>{
        if(e.target.closest('a,button')&&!e.target.closest('[data-sc-track]'))return;
        if(e.key==='ArrowLeft'){e.preventDefault();step(-1)}
        if(e.key==='ArrowRight'){e.preventDefault();step(1)}
      },{signal});
      this.addEventListener('shopify:block:select',e=>{
        const slide=e.target.closest('[data-sc-track] > *');
        if(slide)this.track.scrollTo({left:slide.offsetLeft-this.track.offsetLeft,behavior:'auto'});
      },{signal});

      // Autoplay, opt-in per section. Absent attributes leave it off.
      const interval=Number(this.dataset.scInterval)||0;
      if(this.dataset.scAutoplay==='true'&&interval>0){
        let paused=false;
        const stop=()=>{clearInterval(this.timer);this.timer=null};
        const start=()=>{
          stop();
          if(paused||reduce.matches||document.hidden||maxScroll()<=2)return;
          this.timer=setInterval(()=>{
            if(this.track.scrollLeft>=maxScroll()-2)this.track.scrollTo({left:0,behavior:behavior()});
            else step(1);
          },interval);
        };
        // A deliberate interaction ends autoplay for the session.
        const halt=()=>{paused=true;stop();if(this.pauseBtn)setPause(true)};
        const setPause=state=>{
          this.pauseBtn.setAttribute('aria-pressed',String(state));
          this.pauseBtn.setAttribute('aria-label',state?'Play carousel':'Pause carousel');
          this.pauseBtn.textContent=state?'▶':'❙❙';
        };
        this.addEventListener('pointerenter',stop,{signal});
        this.addEventListener('pointerleave',start,{signal});
        this.addEventListener('focusin',stop,{signal});
        this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget))start()},{signal});
        document.addEventListener('visibilitychange',()=>document.hidden?stop():start(),{signal});
        this.track.addEventListener('pointerdown',halt,{signal});
        this.track.addEventListener('touchstart',halt,{signal,passive:true});
        this.prevBtn?.addEventListener('click',halt,{signal});
        this.nextBtn?.addEventListener('click',halt,{signal});
        this.dots.forEach(d=>d.addEventListener('click',halt,{signal}));
        if(this.pauseBtn){
          setPause(false);
          this.pauseBtn.addEventListener('click',()=>{paused=!paused;setPause(paused);paused?stop():start()},{signal});
        }
        start();
      }
    }
    disconnectedCallback(){
      this.ctrl?.abort();this.ctrl=null;
      this.ro?.disconnect();
      cancelAnimationFrame(this.raf);
      clearInterval(this.timer);
    }
  });
}
if(!window.__sleepyReveal){
  window.__sleepyReveal=true;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}});
  },{rootMargin:'0px 0px -6% 0px',threshold:0.08}):null;
  const scan=root=>{
    root.querySelectorAll('[data-sc-reveal]:not([data-sc-seen])').forEach(el=>{
      el.dataset.scSeen='1';
      if(!io||reduce.matches||el.closest('[data-animation="none"]'))el.classList.add('is-in');
      else io.observe(el);
    });
  };
  window.__sleepyRevealScan=scan;
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
}else{window.__sleepyRevealScan?.(document)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-customer-gallery"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('sleepy-customer-gallery'))customElements.define('sleepy-customer-gallery',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const opt={signal:this.abort.signal},v=this.querySelector('.scg-viewport'),track=this.querySelector('.scg-track'),originals=[...track.children];let cycle=0,last=0,hover=false,focus=false,touch=false,userPaused=false,visible=true,resume=0,drag=null,moved=false,fraction=0,direction=1;const reduced=matchMedia('(prefers-reduced-motion: reduce)');
const normalize=()=>{};
const setup=()=>{cycle=Math.max(0,v.scrollWidth-v.clientWidth)};
this.observer=new ResizeObserver(()=>{if(drag||touch)return;setup()});this.observer.observe(v);
this.addEventListener('mouseenter',()=>{hover=this.hasAttribute('data-pause-hover')},opt);this.addEventListener('mouseleave',()=>hover=false,opt);v.addEventListener('focusin',()=>focus=true,opt);v.addEventListener('focusout',e=>focus=v.contains(e.relatedTarget),opt);
v.addEventListener('pointerdown',e=>{moved=false;if(e.pointerType!=='mouse'){touch=true;return}if(e.button!==0)return;drag={x:e.clientX,left:v.scrollLeft};v.classList.add('is-dragging')},opt);
window.addEventListener('pointermove',e=>{if(!drag)return;const dx=e.clientX-drag.x;if(Math.abs(dx)>5)moved=true;if(moved){e.preventDefault();v.scrollLeft=drag.left-dx}}, {...opt,passive:false});
const release=()=>{if(drag||touch){drag=null;touch=false;v.classList.remove('is-dragging');resume=performance.now()+1600;normalize()}};window.addEventListener('pointerup',release,opt);window.addEventListener('pointercancel',release,opt);
v.addEventListener('click',e=>{if(moved){e.preventDefault();e.stopPropagation()}}, {...opt,capture:true});v.addEventListener('scroll',()=>{if(!drag&&!touch)normalize()},opt);v.addEventListener('wheel',()=>resume=performance.now()+1600,{...opt,passive:true});
this.addEventListener('click',e=>{const trigger=e.target.closest('[data-video-open]');if(!trigger||moved)return;const dialog=this.querySelector('[data-video-dialog="'+trigger.dataset.videoOpen+'"]');if(dialog){dialog.showModal();dialog.querySelector('video')?.play().catch(()=>{});}},opt);
this.querySelectorAll('dialog').forEach(dialog=>{dialog.querySelector('[data-close]').addEventListener('click',()=>dialog.close(),opt);dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()},opt);dialog.addEventListener('close',()=>dialog.querySelector('video')?.pause(),opt)});
const control=this.querySelector('.scg-motion');control?.addEventListener('click',()=>{userPaused=!userPaused;control.setAttribute('aria-pressed',String(userPaused));control.textContent=userPaused?'Resume movement':'Pause movement'},opt);
this.visibility=new IntersectionObserver(entries=>visible=entries[0].isIntersecting);this.visibility.observe(this);
const tick=t=>{const dt=last?Math.min(t-last,40):0;last=t;if(cycle&&this.hasAttribute('data-autoplay')&&!reduced.matches&&!hover&&!focus&&!touch&&!drag&&!userPaused&&visible&&!document.hidden&&!this.querySelector("dialog[open]")&&t>resume){fraction+=Number(this.dataset.speed)*dt/1000;const pixels=Math.floor(fraction);if(pixels){if(v.scrollLeft>=cycle-1){direction=-1}else if(v.scrollLeft<=1){direction=1}v.scrollLeft+=pixels*direction;fraction-=pixels}}this.frame=requestAnimationFrame(tick)};setup();this.frame=requestAnimationFrame(tick);
}
disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();this.visibility?.disconnect();cancelAnimationFrame(this.frame);this.querySelectorAll('[data-clone]').forEach(n=>n.remove())}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sleepy-accordion')){
  customElements.define('sleepy-accordion',class extends HTMLElement{
    connectedCallback(){
      if(this.ctrl)return;
      this.ctrl=new AbortController();
      const signal=this.ctrl.signal;
      const reduce=matchMedia('(prefers-reduced-motion:reduce)');
      const items=Array.from(this.querySelectorAll('details'));
      const dur=()=>reduce.matches?0:Number(this.dataset.duration)||300;
      const EASE='cubic-bezier(.22,1,.36,1)';

      items.forEach(d=>{
        const summary=d.querySelector('summary');
        const panel=d.querySelector('[data-sfq-panel]');
        if(!summary||!panel)return;

        // <details> snaps open with no transition of its own, so the height is
        // animated explicitly. Any in-flight animation is cancelled first so
        // rapid clicks cannot leave a row stuck at a part-open height.
        const run=(from,to,after)=>{
          d._anim?.cancel();
          d.style.height=from+'px';
          d._anim=d.animate({height:[from+'px',to+'px']},{duration:dur(),easing:EASE});
          d._anim.onfinish=()=>{d._anim=null;d.style.height='';if(after)after()};
          d._anim.oncancel=()=>{d._anim=null};
        };
        const open=()=>{
          d.open=true;
          run(summary.offsetHeight, summary.offsetHeight+panel.offsetHeight);
        };
        const close=()=>{
          run(d.offsetHeight, summary.offsetHeight, ()=>{d.open=false});
        };
        d._close=close;

        summary.addEventListener('click',e=>{
          e.preventDefault();
          if(d.open){close();return}
          if(this.dataset.single==='true'){
            items.forEach(other=>{if(other!==d&&other.open&&other._close)other._close()});
          }
          open();
        },{signal});
      });

      // Opening a row inside a closed accordion via in-page search or a
      // deep link should not leave the height frozen mid-animation.
      this.addEventListener('toggle',e=>{
        const d=e.target;
        if(d.open&&!d._anim)d.style.height='';
      },{signal,capture:true});
    }
    disconnectedCallback(){this.ctrl?.abort();this.ctrl=null}
  });
}
if(!window.__sleepyReveal){
  window.__sleepyReveal=true;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}});
  },{rootMargin:'0px 0px -6% 0px',threshold:0.08}):null;
  const scan=root=>{
    root.querySelectorAll('[data-sc-reveal]:not([data-sc-seen])').forEach(el=>{
      el.dataset.scSeen='1';
      if(!io||reduce.matches||el.closest('[data-animation="none"]'))el.classList.add('is-in');
      else io.observe(el);
    });
  };
  window.__sleepyRevealScan=scan;
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
}else{window.__sleepyRevealScan?.(document)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-footer"] && !Shopify.designMode) return;
  try {
    
if(!window.__sleepyReveal){
  window.__sleepyReveal=true;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}});
  },{rootMargin:'0px 0px -6% 0px',threshold:0.08}):null;
  const scan=root=>{
    root.querySelectorAll('[data-sc-reveal]:not([data-sc-seen])').forEach(el=>{
      el.dataset.scSeen='1';
      if(!io||reduce.matches||el.closest('[data-animation="none"]'))el.classList.add('is-in');
      else io.observe(el);
    });
  };
  window.__sleepyRevealScan=scan;
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
}else{window.__sleepyRevealScan?.(document)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-giving-back"] && !Shopify.designMode) return;
  try {
    
if(!window.__sleepyReveal){
  window.__sleepyReveal=true;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}});
  },{rootMargin:'0px 0px -6% 0px',threshold:0.08}):null;
  const scan=root=>{
    root.querySelectorAll('[data-sc-reveal]:not([data-sc-seen])').forEach(el=>{
      el.dataset.scSeen='1';
      if(!io||reduce.matches||el.closest('[data-animation="none"]'))el.classList.add('is-in');
      else io.observe(el);
    });
  };
  window.__sleepyRevealScan=scan;
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
}else{window.__sleepyRevealScan?.(document)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-google-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    const initialize = (root) => {
      root.querySelectorAll('[data-sgr]:not([data-ready])').forEach((section) => {
        section.dataset.ready = 'true';
        const aborter = new AbortController();
        const signal = aborter.signal;
        const on = (target, event, handler, options = {}) => target?.addEventListener(event, handler, { ...options, signal });
        let slides = [...section.querySelectorAll('[data-sgr-slide]')];
        let dots = [...section.querySelectorAll('[data-sgr-dot]')];
        const slidesRoot = section.querySelector('[data-sgr-slides]');
        const dotsRoot = section.querySelector('.sgr__dots');
        const feature = section.querySelector('[data-sgr-feature]');
        const ticker = section.querySelector('[data-sgr-ticker]');
        const track = section.querySelector('[data-sgr-track]');
        const status = section.querySelector('[data-sgr-status]');
        const summaryRating = section.querySelector('[data-sgr-summary-rating]');
        const summaryCount = section.querySelector('[data-sgr-summary-count]');
        const liveTicker = section.querySelector('[data-sgr-live-ticker]');
        const hasDesignedFeature = section.dataset.sourceMode !== 'app';

        let current = 0;
        let featureTimer = null;
        let inView = !('IntersectionObserver' in window);
        let focused = false;
        let touching = false;
        let cycleWidth = 0;
        let tickerPosition = 0;
        let cloneBuild = 0;
        let lastFrame = performance.now();
        let resumeAt = 0;
        let pointerDown = false;
        let dragging = false;
        let suppressClick = false;
        let pointerStartX = 0;
        let pointerStartScroll = 0;
        let featureStartX = null;
        let appioPoll = null;
        let appioObserver = null;
        let appioHydrated = false;
        let appioTickerHydrated = false;

        const stopFeature = () => {
          if (featureTimer) window.clearTimeout(featureTimer);
          featureTimer = null;
        };

        const sharedMotionAllowed = () => inView && !document.hidden && !focused && !touching && !reducedMotion.matches;
        const hoverPauses = (element) => section.dataset.pauseHover === 'true' && finePointer.matches && element?.matches(':hover');
        const canFeatureMove = () => sharedMotionAllowed() && !hoverPauses(feature);
        const canTickerMove = () => sharedMotionAllowed() && !pointerDown && !hoverPauses(ticker);

        const scheduleFeature = () => {
          stopFeature();
          if (!hasDesignedFeature || slides.length < 2 || section.dataset.featureAutoplay !== 'true' || !canFeatureMove() || section.dataset.designMode === 'true') return;
          featureTimer = window.setTimeout(() => {
            show(current + 1, false);
            scheduleFeature();
          }, Number(section.dataset.featureDelay) || 6000);
        };

        const show = (index, announce) => {
          if (!slides.length) return;
          current = (index + slides.length) % slides.length;
          slides.forEach((slide, slideIndex) => {
            const active = slideIndex === current;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
            slide.inert = !active;
          });
          dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === current)));
          if (announce && status) status.textContent = `Review ${current + 1} of ${slides.length}`;
        };

        const safeUrl = (value) => {
          try {
            const url = new URL(value, window.location.origin);
            return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
          } catch (_) {
            return '';
          }
        };

        const readAppioData = () => {
          const script = document.getElementById('appio_google_reviews_script');
          const source = script?.textContent || '';
          const marker = source.indexOf('_appioGoogleReviewsData');
          const start = source.indexOf('{', marker);
          if (marker < 0 || start < 0) return null;

          let depth = 0;
          let inString = false;
          let escaped = false;
          for (let index = start; index < source.length; index += 1) {
            const character = source[index];
            if (inString) {
              if (escaped) escaped = false;
              else if (character === '\\') escaped = true;
              else if (character === '"') inString = false;
              continue;
            }
            if (character === '"') inString = true;
            else if (character === '{') depth += 1;
            else if (character === '}') {
              depth -= 1;
              if (depth === 0) {
                try { return JSON.parse(source.slice(start, index + 1)); } catch (_) { return null; }
              }
            }
          }
          return null;
        };

        const makeLiveStars = (rating) => {
          const stars = document.createElement('div');
          const rounded = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
          stars.className = 'sgr__stars';
          stars.setAttribute('aria-label', `${rounded} out of 5 stars`);
          for (let index = 1; index <= 5; index += 1) {
            const star = document.createElement('span');
            star.textContent = '★';
            if (index <= rounded) star.className = 'is-filled';
            stars.append(star);
          }
          return stars;
        };

        const makeLiveSlide = (review, index, total) => {
          const article = document.createElement('article');
          const author = review.authorName || 'Google reviewer';
          const profileUrl = safeUrl(review.authorProfileUrl || review.reviewUrl);
          article.id = `SgrLive-${index}-${Math.random().toString(36).slice(2, 8)}`;
          article.className = `sgr__slide${index === 0 ? ' is-active' : ''}`;
          article.dataset.sgrSlide = '';
          article.dataset.index = String(index);
          article.setAttribute('aria-label', `Review ${index + 1} of ${total}`);
          article.setAttribute('aria-hidden', String(index !== 0));
          article.inert = index !== 0;
          article.append(makeLiveStars(review.rating));

          const quote = document.createElement('blockquote');
          quote.textContent = `“${review.originalText || review.translatedText || ''}”`;
          article.append(quote);

          const authorWrap = document.createElement('div');
          authorWrap.className = 'sgr__feature-author';
          const photoUrl = safeUrl(review.authorPhotoUrl);
          if (photoUrl) {
            const image = document.createElement('img');
            image.className = 'sgr__avatar';
            image.src = photoUrl;
            image.alt = author;
            image.loading = 'lazy';
            authorWrap.append(image);
          } else {
            const fallback = document.createElement('span');
            fallback.className = 'sgr__avatar sgr__avatar--fallback';
            fallback.ariaHidden = 'true';
            fallback.textContent = author.slice(0, 1);
            authorWrap.append(fallback);
          }

          const name = document.createElement(profileUrl ? 'a' : 'strong');
          name.textContent = author;
          if (profileUrl) {
            name.href = profileUrl;
            name.target = '_blank';
            name.rel = 'noopener noreferrer';
          }
          authorWrap.append(name);

          const detail = document.createElement('em');
          detail.textContent = review.createdAtHuman || review.authorDetail || 'Google reviewer';
          authorWrap.append(detail);
          article.append(authorWrap);
          return article;
        };

        const makeLiveCard = (review) => {
          const article = document.createElement('article');
          const author = review.authorName || 'Google reviewer';
          const profileUrl = safeUrl(review.authorProfileUrl || review.reviewUrl);
          const photoUrl = safeUrl(review.authorPhotoUrl);
          article.className = 'sgr__card';
          article.dataset.sgrItem = '';

          const stars = makeLiveStars(review.rating);
          stars.className = 'sgr__card-stars';
          article.append(stars);

          const quote = document.createElement('blockquote');
          quote.textContent = `“${review.originalText || review.translatedText || ''}”`;
          article.append(quote);

          const footer = document.createElement('footer');
          footer.className = 'sgr__card-author';
          if (photoUrl) {
            const image = document.createElement('img');
            image.className = 'sgr__avatar';
            image.src = photoUrl;
            image.alt = author;
            image.loading = 'lazy';
            footer.append(image);
          } else {
            const fallback = document.createElement('span');
            fallback.className = 'sgr__avatar sgr__avatar--fallback';
            fallback.ariaHidden = 'true';
            fallback.textContent = author.slice(0, 1);
            footer.append(fallback);
          }

          const details = document.createElement('div');
          const name = document.createElement(profileUrl ? 'a' : 'strong');
          name.textContent = author;
          if (profileUrl) {
            name.href = profileUrl;
            name.target = '_blank';
            name.rel = 'noopener noreferrer';
          }
          details.append(name);

          const meta = document.createElement('span');
          meta.textContent = review.createdAtHuman ? `Google review · ${review.createdAtHuman}` : 'Google review';
          details.append(meta);
          footer.append(details);
          article.append(footer);
          return article;
        };

        const hydrateAppioFeature = () => {
          if (appioHydrated || section.dataset.sourceMode !== 'hybrid' || section.dataset.syncAppioFeature !== 'true' || !slidesRoot) return appioHydrated;
          const data = readAppioData();
          const reviews = data?.reviews?.filter((review) => review.originalText || review.translatedText).slice(0, 5) || [];
          if (!reviews.length) return false;
          stopFeature();
          slidesRoot.replaceChildren(...reviews.map((review, index) => makeLiveSlide(review, index, reviews.length)));
          slides = [...slidesRoot.querySelectorAll('[data-sgr-slide]')];

          if (dotsRoot) {
            dotsRoot.replaceChildren(...reviews.map((_, index) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.dataset.sgrDot = String(index);
              dot.setAttribute('aria-label', `Show review ${index + 1}`);
              dot.setAttribute('aria-controls', slides[index].id);
              dot.setAttribute('aria-current', String(index === 0));
              return dot;
            }));
            dots = [...dotsRoot.querySelectorAll('[data-sgr-dot]')];
          }

          if (section.dataset.syncAppioSummary === 'true') {
            const rating = Number(data?.place?.ratings ?? data?.place?.rating);
            const count = Number(data?.place?.total ?? data?.place?.reviewCount);
            if (summaryRating && Number.isFinite(rating)) summaryRating.textContent = rating.toFixed(1);
            if (summaryCount && Number.isFinite(count)) summaryCount.textContent = new Intl.NumberFormat('en-NZ').format(count);
          }

          appioHydrated = true;
          current = 0;
          show(0, false);
          if (status) status.textContent = 'Live Google reviews loaded';
          scheduleFeature();
          return true;
        };

        const hydrateAppioTicker = () => {
          if (appioTickerHydrated || section.dataset.sourceMode !== 'hybrid' || !liveTicker || !track) return appioTickerHydrated;
          const data = readAppioData();
          const reviews = data?.reviews?.filter((review) => review.originalText || review.translatedText) || [];
          if (!reviews.length) return false;
          track.replaceChildren(...reviews.map(makeLiveCard));
          appioTickerHydrated = true;
          cloneCards();
          return true;
        };

        const configureAppioRail = () => {
          const appioBody = section.querySelector('.sgr__app--rail .agrs__body');
          if (!appioBody) return false;
          const swiper = appioBody.swiper;
          if (swiper && appioBody.dataset.sgrConfigured !== 'true') {
            const gap = Number.parseFloat(getComputedStyle(section).getPropertyValue('--sgr-card-gap')) || 10;
            const updateParams = (params) => {
              if (!params) return;
              params.slidesPerView = 'auto';
              params.spaceBetween = gap;
            };
            updateParams(swiper.params);
            updateParams(swiper.originalParams);
            Object.values(swiper.params.breakpoints || {}).forEach(updateParams);
            Object.values(swiper.originalParams.breakpoints || {}).forEach(updateParams);
            swiper.update();
            appioBody.dataset.sgrConfigured = 'true';
          }
          return true;
        };

        on(dotsRoot, 'click', (event) => {
          const dot = event.target.closest('[data-sgr-dot]');
          if (!dot) return;
          show(Number(dot.dataset.sgrDot), true);
          scheduleFeature();
        });
        on(feature, 'keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          show(current + (event.key === 'ArrowLeft' ? -1 : 1), true);
          scheduleFeature();
        });

        on(feature, 'touchstart', (event) => {
          if (event.target.closest('a, button')) return;
          featureStartX = event.touches[0]?.clientX ?? null;
          touching = true;
          stopFeature();
        }, { passive: true });
        on(feature, 'touchend', (event) => {
          const endX = event.changedTouches[0]?.clientX;
          if (featureStartX !== null && typeof endX === 'number' && Math.abs(endX - featureStartX) > 45) show(current + (endX < featureStartX ? 1 : -1), true);
          featureStartX = null;
          touching = false;
          resumeAt = performance.now() + 1200;
          scheduleFeature();
        }, { passive: true });
        on(feature, 'touchcancel', () => {
          featureStartX = null;
          touching = false;
          resumeAt = performance.now() + 1200;
          scheduleFeature();
        }, { passive: true });

        const cloneCards = () => {
          if (!track || !ticker || pointerDown) return;
          const build = ++cloneBuild;
          const oldCycle = cycleWidth;
          const oldPosition = ticker.scrollLeft;
          const logicalPosition = oldCycle > 0 ? ((oldPosition % oldCycle) + oldCycle) % oldCycle : oldPosition;
          track.querySelectorAll('[data-sgr-clone]').forEach((clone) => clone.remove());
          const originals = [...track.querySelectorAll('[data-sgr-item]')];
          cycleWidth = 0;
          if (!originals.length) return;
          const appendCloneSet = () => originals.forEach((card) => {
              const clone = card.cloneNode(true);
              clone.dataset.sgrClone = '';
              clone.removeAttribute('data-sgr-item');
              clone.setAttribute('aria-hidden', 'true');
              [clone, ...clone.querySelectorAll('*')].forEach((item) => {
                [...item.attributes].forEach((attribute) => {
                  if (attribute.name.startsWith('data-shopify')) item.removeAttribute(attribute.name);
                });
              });
              clone.querySelectorAll('a,button').forEach((item) => item.tabIndex = -1);
              clone.querySelectorAll('[id]').forEach((item) => item.removeAttribute('id'));
              track.append(clone);
            });
          appendCloneSet();
          requestAnimationFrame(() => {
            if (build !== cloneBuild) return;
            const firstClone = track.querySelector('[data-sgr-clone]');
            cycleWidth = firstClone ? firstClone.offsetLeft - originals[0].offsetLeft : 0;
            let cloneSets = 1;
            while (cycleWidth && track.scrollWidth < ticker.clientWidth + (cycleWidth * 2) && cloneSets < 8) {
              appendCloneSet();
              cloneSets += 1;
            }
            if (!cycleWidth) return;
            if (oldCycle > 0) tickerPosition = logicalPosition;
            else if (section.dataset.tickerDirection === 'right') tickerPosition = cycleWidth;
            else tickerPosition = ticker.scrollLeft;
            ticker.scrollLeft = tickerPosition;
          });
        };

        if (ticker && track) {
          cloneCards();
          on(ticker, 'pointerdown', (event) => {
            if (event.pointerType === 'touch') return;
            pointerDown = true;
            dragging = false;
            pointerStartX = event.clientX;
            pointerStartScroll = ticker.scrollLeft;
            tickerPosition = pointerStartScroll;
            resumeAt = Infinity;
          });
          on(ticker, 'pointermove', (event) => {
            if (!pointerDown || event.pointerType === 'touch') return;
            const movement = event.clientX - pointerStartX;
            if (!dragging && Math.abs(movement) < 4) return;
            if (!dragging) {
              dragging = true;
              ticker.classList.add('is-dragging');
              ticker.setPointerCapture?.(event.pointerId);
            }
            tickerPosition = pointerStartScroll - movement;
            ticker.scrollLeft = tickerPosition;
            event.preventDefault();
          });
          const finishDrag = (event) => {
            if (!pointerDown) return;
            pointerDown = false;
            if (dragging) {
              dragging = false;
              suppressClick = true;
              ticker.classList.remove('is-dragging');
              if (ticker.hasPointerCapture?.(event.pointerId)) ticker.releasePointerCapture(event.pointerId);
              window.setTimeout(() => suppressClick = false, 0);
            }
            tickerPosition = ticker.scrollLeft;
            resumeAt = performance.now() + 1400;
          };
          on(ticker, 'pointerup', finishDrag);
          on(ticker, 'pointercancel', finishDrag);
          on(ticker, 'click', (event) => {
            if (!suppressClick) return;
            event.preventDefault();
            event.stopImmediatePropagation();
          }, { capture: true });
          on(ticker, 'touchstart', () => { touching = true; tickerPosition = ticker.scrollLeft; resumeAt = Infinity; }, { passive: true });
          on(ticker, 'touchend', () => { touching = false; tickerPosition = ticker.scrollLeft; resumeAt = performance.now() + 1600; }, { passive: true });
          on(ticker, 'touchcancel', () => { touching = false; tickerPosition = ticker.scrollLeft; resumeAt = performance.now() + 1600; }, { passive: true });
          if (section.dataset.pauseHover === 'true') {
            on(ticker, 'mouseleave', () => { resumeAt = performance.now() + 350; });
          }
        }

        const tick = (time) => {
          const elapsed = Math.min(50, time - lastFrame) / 1000;
          lastFrame = time;
          if (ticker && cycleWidth && section.dataset.tickerAutoplay === 'true' && canTickerMove() && time >= resumeAt) {
            const direction = section.dataset.tickerDirection === 'right' ? -1 : 1;
            tickerPosition += (Number(section.dataset.tickerSpeed) || 28) * direction * elapsed;
            if (tickerPosition >= cycleWidth) tickerPosition %= cycleWidth;
            if (tickerPosition < 0) tickerPosition = cycleWidth + (tickerPosition % cycleWidth);
            ticker.scrollLeft = tickerPosition;
          }
          section.sgrFrame = requestAnimationFrame(tick);
        };

        if (section.dataset.pauseHover === 'true' && feature) {
          on(feature, 'mouseenter', stopFeature);
          on(feature, 'mouseleave', scheduleFeature);
        }
        on(section, 'focusin', () => { focused = true; stopFeature(); });
        on(section, 'focusout', (event) => {
          if (section.contains(event.relatedTarget)) return;
          focused = false;
          scheduleFeature();
        });
        on(document, 'visibilitychange', scheduleFeature);
        on(reducedMotion, 'change', scheduleFeature);

        let observer = null;
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              inView = entry.isIntersecting;
              if (inView) section.classList.add('is-visible');
              scheduleFeature();
            });
          }, { threshold: .12 });
          observer.observe(section);
        } else {
          section.classList.add('is-visible');
        }

        let resizeObserver = null;
        if ('ResizeObserver' in window && ticker) {
          resizeObserver = new ResizeObserver(cloneCards);
          resizeObserver.observe(ticker);
        }

        if (section.dataset.sourceMode === 'hybrid') {
          let attempts = 0;
          const syncAppio = () => {
            attempts += 1;
            const featureReady = section.dataset.syncAppioFeature !== 'true' || hydrateAppioFeature();
            const tickerReady = hydrateAppioTicker();
            if ((tickerReady && featureReady) || attempts >= 60) {
              if (appioPoll) window.clearInterval(appioPoll);
              appioPoll = null;
              appioObserver?.disconnect();
            }
          };
          syncAppio();
          const featureNeedsData = section.dataset.syncAppioFeature === 'true' && !appioHydrated;
          if (!appioTickerHydrated || featureNeedsData) {
            appioPoll = window.setInterval(syncAppio, 250);
          }
          if ((!appioTickerHydrated || featureNeedsData) && 'MutationObserver' in window) {
            appioObserver = new MutationObserver(syncAppio);
            appioObserver.observe(document.documentElement, { childList: true, subtree: true });
          }
        }

        section.sgrDestroy = () => {
          stopFeature();
          if (section.sgrFrame) cancelAnimationFrame(section.sgrFrame);
          if (appioPoll) window.clearInterval(appioPoll);
          appioObserver?.disconnect();
          observer?.disconnect();
          resizeObserver?.disconnect();
          aborter.abort();
        };

        show(0, false);
        scheduleFeature();
        if (ticker) section.sgrFrame = requestAnimationFrame(tick);
      });
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-sgr]').forEach((section) => section.sgrDestroy?.()));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sleepy-header')) {
  customElements.define('sleepy-header', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.syncNavigation();
      window.addEventListener('popstate', () => this.syncNavigation(), {signal});
      window.addEventListener('hashchange', () => this.syncNavigation(), {signal});
      this.cartDialog = this.querySelector('.sc-cart-dialog');
      this.cartWrap = this.querySelector('.sc-cart-wrap');
      this.cartTrigger = this.querySelector('.sc-cart');
      const hoverCart = () => matchMedia('(hover:hover) and (pointer:fine)').matches;
      this.cartWrap.addEventListener('pointerenter', () => {
        clearTimeout(this.cartLeaveTimer);
        if (hoverCart()) this.openCart();
      }, {signal});
      this.cartWrap.addEventListener('pointerleave', () => {
        if (hoverCart() && !this.cartWrap.contains(document.activeElement))
          this.cartLeaveTimer = setTimeout(() => this.closeCart(), 180);
      }, {signal});
      this.cartTrigger.addEventListener('click', e => {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        if (hoverCart()) this.openCart();
        else if (this.cartDialog.hidden) this.openCart();
        else this.closeCart();
      }, {signal});
      this.cartTrigger.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();this.openCart();this.querySelector('.sc-cart-close').focus();
        }
      }, {signal});
      this.querySelector('.sc-cart-close').addEventListener('click', () => this.closeCart(true), {signal});
      this.cartWrap.addEventListener('keydown', e => {
        if (e.key === 'Escape') {e.preventDefault();e.stopPropagation();this.closeCart(true);}
      }, {signal});
      this.cartWrap.addEventListener('focusout', e => {
        if (!this.cartWrap.contains(e.relatedTarget)) this.closeCart();
      }, {signal});
      document.addEventListener('pointerdown', e => {
        if (!this.cartWrap.contains(e.target)) this.closeCart();
      }, {signal});
      this.details = this.querySelector('.sc-details');
      this.trigger = this.details.querySelector('summary');
      this.toggle = this.querySelector('.sc-mobile-toggle');
      this.nav = this.querySelector('.sc-nav');
      this.clip = this.querySelector('.sc-menu-clip');
      this.surface = this.querySelector('.sc-menu-surface');
      this.desktop = matchMedia('(min-width:990px)');
      this.pointer = matchMedia('(hover:hover) and (pointer:fine)');
      this.categoryTabs = Array.from(this.querySelectorAll('.sc-category-tab'));
      this.categoryPanels = Array.from(this.querySelectorAll('.sc-category-panel'));
      this.selectedCategory = 0;
      this.categoryAnimations = [];
      this.categoryTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectCategory(index), {signal});
        tab.addEventListener('keydown', e => {
          let target = index;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') target = (index + 1) % this.categoryTabs.length;
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') target = (index - 1 + this.categoryTabs.length) % this.categoryTabs.length;
          else if (e.key === 'Home') target = 0;
          else if (e.key === 'End') target = this.categoryTabs.length - 1;
          else return;
          e.preventDefault(); this.categoryTabs[target].focus(); this.selectCategory(target);
        }, {signal});
      });
      this.opened = false;
      this.clip.inert = true;
      this.trigger.addEventListener('click', e => { e.preventDefault(); this.setOpen(!this.opened); }, {signal});
      this.details.addEventListener('pointerenter', () => {
        clearTimeout(this.leaveTimer);
        if (this.dataset.hover === 'true' && this.desktop.matches && this.pointer.matches) this.setOpen(true);
      }, {signal});
      this.details.addEventListener('pointerleave', () => {
        if (this.desktop.matches && this.pointer.matches && !this.details.contains(document.activeElement)) {
          this.leaveTimer = setTimeout(() => this.setOpen(false), 120);
        }
      }, {signal});
      this.trigger.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') { e.preventDefault(); this.setOpen(true); clearTimeout(this.focusTimer); this.focusTimer = setTimeout(() => { if (this.opened) this.clip.querySelector('[role=tab][aria-selected=true]')?.focus({preventScroll:true}); }, this.motionDuration() + 20); }
      }, {signal});
      this.toggle.addEventListener('click', () => this.setMobile(!this.classList.contains('is-mobile-open')), {signal});
      document.addEventListener('pointerdown', e => {
        if (!this.contains(e.target)) { this.setOpen(false); this.setMobile(false); }
      }, {signal});
      this.addEventListener('focusout', e => {
        if (!e.relatedTarget) return;
        if (!this.details.contains(e.relatedTarget)) this.setOpen(false);
        if (!this.contains(e.relatedTarget)) this.setMobile(false);
      }, {signal});
      this.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const sub = e.target.closest('.sc-sub-details[open]');
        if (sub) {sub.open = false; sub.querySelector('summary').focus(); return;}
        if (this.opened) { this.setOpen(false); this.trigger.focus(); }
        else if (this.classList.contains('is-mobile-open')) { this.setMobile(false); this.toggle.focus(); }
      }, {signal});

  this.addEventListener('shopify:block:select', event => {if (!this.desktop.matches) this.setMobile(true); this.setOpen(true); const panel = event.target.closest('.sc-category-panel'); if (panel) this.selectCategory(this.categoryPanels.indexOf(panel));}, {signal});
      this.addEventListener('shopify:block:deselect', () => this.setOpen(false), {signal});
      this.desktop.addEventListener('change', () => {this.setOpen(false);this.setMobile(false);}, {signal});
      this.measure = () => {
        const host=this.closest('.shopify-section');
        const promo=this.querySelector('.sc-announcement');
        const promoHeight=promo ? promo.getBoundingClientRect().height : 0;
        if(host)host.style.setProperty('--sc-promo-height',promoHeight+'px');
        this.style.setProperty('--sc-header-bottom',Math.max(0,this.querySelector('.sc-bar').getBoundingClientRect().bottom)+'px');
      };
      this.observer = new ResizeObserver(this.measure); this.observer.observe(this); this.measure();
      window.addEventListener('scroll', this.measure, {signal,passive:true});
      window.addEventListener('resize', this.measure, {signal,passive:true});
      // Dawn publishes cart data after AJAX updates. No additional cart request is needed.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          const count = event?.cartData?.item_count;
          if (typeof count === 'number') this.updateCart(count);
          if (!this.cartDialog.hidden) this.loadCart();
        });
      }
    }

    syncNavigation() {
      const normalize = p => p.replace(/\/$/, '') || '/';
      const path = normalize(location.pathname);
      let matched = false;
      this.querySelectorAll('.sc-nav-list > li').forEach(li => {
        if (li.classList.contains('sc-mega-item')) return;
        const top = li.querySelector('.sc-nav-link');
        let active = false;
        li.querySelectorAll('a[href]').forEach(a => {
          const url = new URL(a.href, location.href);
          const same = url.origin === location.origin && normalize(url.pathname) === path && (!url.hash || url.hash === location.hash);
          a.removeAttribute('aria-current');
          if (same) {a.setAttribute('aria-current','page'); active = true;}
        });
        top?.classList.toggle('is-active', active); matched ||= active;
      });
      const mattress = this.querySelector('.sc-mattress');
      mattress.classList.toggle('is-active', !matched && (this.dataset.mattressActive === 'true' || path === normalize(this.dataset.mattressUrl)));
    }
    openCart() {
      clearTimeout(this.cartLeaveTimer);
      if (!this.cartDialog.hidden) return;
      this.setMobile(false);this.setOpen(false);
      this.cartDialog.hidden = false;
      this.cartTrigger.setAttribute('aria-expanded', 'true');
      this.loadCart();
    }
    closeCart(restoreFocus = false) {
      clearTimeout(this.cartLeaveTimer);
      this.cartDialog.hidden = true;
      this.cartTrigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.cartTrigger.focus();
    }
    async loadCart() {
      const revision = this.cartRevision = (this.cartRevision || 0) + 1;
      const status = this.querySelector('.sc-cart-status');
      const items = this.querySelector('.sc-cart-items');
      const footer = this.querySelector('.sc-cart-footer');
      status.textContent = 'Loading your cart…';
      footer.hidden = true;
      try {
        const response = await fetch(this.dataset.root + 'cart.js', {headers:{Accept:'application/json'}, cache:'no-store', signal:this.controller.signal});
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (revision !== this.cartRevision) return;
        const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {style:'currency',currency:cart.currency}).format(n / 100);
        items.replaceChildren();
        cart.items.forEach(item => {
          const row = document.createElement('article'); row.className = 'sc-cart-line';
          if (item.image) {const img = document.createElement('img');img.src=item.image;img.alt=item.product_title;img.loading='lazy';row.append(img);}
          const detail = document.createElement('div');
          const link = document.createElement('a');link.href=item.url;link.textContent=item.product_title;detail.append(link);
          if (item.variant_title && item.variant_title !== 'Default Title') {const v=document.createElement('p');v.textContent=item.variant_title;detail.append(v);}
          if (item.selling_plan_allocation) {const p=document.createElement('p');p.textContent=item.selling_plan_allocation.selling_plan.name;detail.append(p);}
          const qty=document.createElement('p');qty.textContent='Quantity: '+item.quantity;detail.append(qty);
          const price=document.createElement('strong');price.textContent=money(item.final_line_price);detail.append(price);
          row.append(detail);items.append(row);
        });
        this.updateCart(cart.item_count);
        status.textContent = cart.item_count ? '' : 'Your cart is empty.';
        footer.hidden = !cart.item_count;
        footer.querySelector('strong').textContent = money(cart.total_price);
      } catch (error) {
        if (error.name === 'AbortError' || revision !== this.cartRevision) return;
        items.replaceChildren(); status.textContent = 'Unable to load your cart. Please use “View and edit cart” below.';
      }
    }

    async selectCategory(index) {
      if (index < 0 || index >= this.categoryPanels.length || index === this.selectedCategory) return;
      const from = this.categoryPanels[this.selectedCategory], to = this.categoryPanels[index];
      this.selectedCategory = index;
      const revision = this.categoryRevision = (this.categoryRevision || 0) + 1;
      this.categoryAnimations.forEach(animation => animation.cancel());
      this.categoryAnimations = [];
      this.categoryTabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1;});
      const duration = this.motionDuration() === 0 ? 0 : 150;
      const animate = async (panel, frames) => {
        if (!duration) return;
        const animation = panel.animate(frames, {duration, easing:'ease', fill:'both'});
        this.categoryAnimations.push(animation);
        try {await animation.finished;} catch (_) {}
      };
      // A new click supersedes a running transition without displaying stale panels.
      this.categoryPanels.forEach(panel => {if(panel !== from) panel.hidden = true;});
      await animate(from, [{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(2rem)'}]);
      if (revision !== this.categoryRevision) return;
      this.categoryPanels.forEach(panel => {panel.hidden = panel !== to;});
      this.querySelector('.sc-shop-all').href = to.dataset.collectionUrl;
      await animate(to, [{opacity:0,transform:'translateY(2rem)'},{opacity:1,transform:'translateY(0)'}]);
      if (revision === this.categoryRevision) {this.categoryAnimations.forEach(animation => animation.cancel()); this.categoryAnimations = [];}
    }
    motionDuration() {
      return matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : parseFloat(getComputedStyle(this).getPropertyValue('--sc-duration')) || 0;
    }
    setMobile(open) {
      if (open) this.closeCart();
      this.classList.toggle('is-mobile-open', open);
      this.toggle.setAttribute('aria-expanded', String(open));
      this.toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      this.toggle.firstElementChild.textContent = open ? '×' : '☰';
      if (!open) this.setOpen(false);
    }
    setOpen(open) {
      clearTimeout(this.leaveTimer); clearTimeout(this.closeTimer); clearTimeout(this.focusTimer);
      if (open) this.closeCart();
      if (open === this.opened && (open || !this.details.open)) return;
      this.opened = open;
      this.trigger.setAttribute('aria-expanded', String(open));
      this.clip.inert = !open;
      if (open) {
        this.details.open = true;
        this.surface.getBoundingClientRect();
        this.details.classList.add('is-open');
      } else {
        this.details.classList.remove('is-open');
        const duration = this.motionDuration();
        this.closeTimer = setTimeout(() => {if (!this.opened) this.details.open = false;}, duration);
      }
    }
    updateCart(count) {
      this.querySelector('.sc-cart-dot').hidden = count === 0;
      this.querySelector('.sc-cart').setAttribute('aria-label', `Cart, ${count} items`);
    }
    disconnectedCallback() {
      clearTimeout(this.cartLeaveTimer); 
      this.categoryRevision = (this.categoryRevision || 0) + 1; this.categoryAnimations?.forEach(animation => animation.cancel());
      this.controller?.abort(); this.controller = null;
      clearTimeout(this.leaveTimer); clearTimeout(this.closeTimer); clearTimeout(this.focusTimer);
      this.observer?.disconnect(); this.unsubscribe?.();
    }
  });
}


if(!customElements.get('sleepy-promos'))customElements.define('sleepy-promos',class extends HTMLElement{
 connectedCallback(){
  this.items=[...this.querySelectorAll('[data-promo-message]')].filter(el=>el.textContent.trim());if(!this.items.length)return;this.index=0;this.abort=new AbortController();const signal=this.abort.signal;
  this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
  this.stop=()=>{clearTimeout(this.timer)};
  this.start=()=>{this.stop();if(this.dataset.rotate==='false'||this.paused||this.hovered||this.focused||document.hidden||this.reduced.matches||this.items.length<2)return;this.timer=setTimeout(()=>{this.show((this.index+1)%this.items.length);this.start()},(Number(this.dataset.seconds)||5)*1000)};
  this.show=i=>{this.index=i;this.items.forEach((el,j)=>{el.classList.toggle('is-current',j===i);el.setAttribute('aria-hidden',String(j!==i));el.inert=j!==i})};
  this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.stop()}},{signal});
  this.addEventListener('pointerleave',()=>{this.hovered=false;this.start()},{signal});
  this.addEventListener('focusin',()=>{this.focused=true;this.stop()},{signal});
  this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.start()}},{signal});
  this.querySelector('.sc-promo-prev')?.addEventListener('click',()=>{this.show((this.index-1+this.items.length)%this.items.length);this.start()},{signal});
  this.querySelector('.sc-promo-next')?.addEventListener('click',()=>{this.show((this.index+1)%this.items.length);this.start()},{signal});
  this.addEventListener('shopify:block:deselect',()=>{this.paused=false;this.start()},{signal});
  this.addEventListener('shopify:block:select',e=>{const i=this.items.findIndex(el=>el===e.target||el.contains(e.target));if(i>=0){this.show(i);this.paused=true;this.stop()}},{signal});
  document.addEventListener('visibilitychange',this.start,{signal});this.reduced.addEventListener('change',this.start,{signal});this.show(0);this.start();
 }
 disconnectedCallback(){this.stop?.();this.abort?.abort()}
});


if(!customElements.get('sleepy-header-search'))customElements.define('sleepy-header-search',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
  const details=this.querySelector('details'),toggle=this.querySelector('summary'),input=this.querySelector('input[type=search]');
  const results=this.querySelector('[data-search-results]'),status=this.querySelector('[data-search-status]'),all=this.querySelector('[data-search-all]');
  const form=this.querySelector('form');
  const close=restore=>{details.open=false;if(restore)toggle.focus();};
  const search=()=>{
   clearTimeout(this.timer);this.request?.abort();
   const query=input.value.trim();
   results.replaceChildren();all.hidden=true;results.setAttribute('aria-busy','false');
   if(!query){status.textContent='';return;}
   const full=new URL(form.action,location.origin);full.searchParams.set('q',query);full.searchParams.set('type','product');all.href=full.href;
   status.textContent='Searching products…';results.setAttribute('aria-busy','true');
   const request=new AbortController();this.request=request;
   this.timer=setTimeout(async()=>{
    try{
     const root=window.Shopify?.routes?.root||'/';
     const url=new URL(root+'search/suggest.json',location.origin);
     url.searchParams.set('q',query);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','6');
     const response=await fetch(url,{signal:request.signal,headers:{Accept:'application/json'}});
     if(!response.ok)throw new Error('Search unavailable');
     const data=await response.json();
     if(request.signal.aborted||input.value.trim()!==query)return;
     const products=data.resources?.results?.products||[];
     const fragment=document.createDocumentFragment();
     products.forEach(product=>{
      const link=document.createElement('a');link.className='sc-live-product';
      const target=new URL(product.url,location.origin);
      if(target.origin!==location.origin)return;
      link.href=target.href;
      const src=product.featured_image?.url||product.image;
      if(src){const img=document.createElement('img');img.src=src;img.alt='';img.width=64;img.height=64;img.loading='lazy';link.append(img);}
      const title=document.createElement('span');title.textContent=product.title;link.append(title);fragment.append(link);
     });
     results.replaceChildren(fragment);
     status.textContent=products.length?products.length+' products found':'No products found. Try another search.';
     all.hidden=false;
    }catch(error){
     if(error.name==='AbortError'||request.signal.aborted)return;
     status.textContent='Live search is unavailable. View all results below.';all.hidden=false;
    }finally{if(this.request===request)results.setAttribute('aria-busy','false');}
   },200);
  };
  input.addEventListener('input',event=>{if(!event.isComposing)search();},{signal});
  input.addEventListener('compositionend',search,{signal});
  details.addEventListener('toggle',()=>{if(details.open){input.focus({preventScroll:true});if(input.value.trim())search();}},{signal});
  this.querySelector('[data-search-close]').addEventListener('click',()=>close(true),{signal});
  this.addEventListener('keydown',e=>{
   if(e.key==='Escape'&&details.open){e.preventDefault();e.stopPropagation();close(true);}
   const links=[...results.querySelectorAll('a')];
   if(e.key==='ArrowDown'&&(e.target===input||links.includes(e.target))){e.preventDefault();links[Math.min(links.indexOf(e.target)+1,links.length-1)]?.focus();}
   if(e.key==='ArrowUp'&&links.includes(e.target)){e.preventDefault();const index=links.indexOf(e.target);(index?links[index-1]:input).focus();}
  },{signal});
  document.addEventListener('click',e=>{if(details.open&&!this.contains(e.target))close(false);},{signal});
  this.addEventListener('focusout',e=>{if(e.relatedTarget&&!this.contains(e.relatedTarget))close(false);},{signal});
 }
 disconnectedCallback(){clearTimeout(this.timer);this.request?.abort();this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initHero = (root) => {
      root.querySelectorAll('[data-sch]:not([data-ready])').forEach((hero) => {
        hero.dataset.ready = 'true';

        const slides = [...hero.querySelectorAll('[data-sch-slide]')];
        const dots = [...hero.querySelectorAll('[data-sch-dot]')];
        const status = hero.querySelector('[data-sch-status]');
        const aborter = new AbortController();
        const signal = aborter.signal;
        const on = (target, event, handler, options = {}) => target?.addEventListener(event, handler, { ...options, signal });

        let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
        let timer = null;
        let visible = !('IntersectionObserver' in window);
        let hovered = false;
        let focused = false;
        let editorPaused = hero.dataset.designMode === 'true';
        let gesture = null;
        let suppressClickUntil = 0;

        const stop = () => {
          if (timer) window.clearTimeout(timer);
          timer = null;
        };

        const canAutoplay = () => (
          slides.length > 1 &&
          hero.dataset.autoplay === 'true' &&
          !reducedMotion.matches &&
          !document.hidden &&
          visible &&
          !hovered &&
          !focused &&
          !gesture &&
          !editorPaused
        );

        const schedule = () => {
          stop();
          if (!canAutoplay()) return;
          const interval = Number(hero.dataset.interval) || 6000;
          timer = window.setTimeout(() => {
            show(current + 1, false);
            schedule();
          }, interval);
        };

        const show = (index, announce = false) => {
          if (!slides.length) return;
          current = (index + slides.length) % slides.length;

          slides.forEach((slide, slideIndex) => {
            const active = slideIndex === current;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
            slide.inert = !active;
          });

          dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === current)));
          if (announce && status) status.textContent = `Slide ${current + 1} of ${slides.length}`;
        };

        on(hero.querySelector('[data-sch-prev]'), 'click', () => { show(current - 1, true); schedule(); });
        on(hero.querySelector('[data-sch-next]'), 'click', () => { show(current + 1, true); schedule(); });
        dots.forEach((dot) => on(dot, 'click', () => { show(Number(dot.dataset.schDot), true); schedule(); }));

        on(hero, 'mouseenter', () => {
          if (hero.dataset.pauseHover !== 'true' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          hovered = true;
          stop();
        });

        on(hero, 'mouseleave', () => {
          if (hero.dataset.pauseHover !== 'true' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          hovered = false;
          schedule();
        });

        on(hero, 'focusin', () => { focused = true; stop(); });
        on(hero, 'focusout', (event) => {
          if (hero.contains(event.relatedTarget)) return;
          focused = false;
          schedule();
        });

        on(hero, 'keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          show(current + (event.key === 'ArrowLeft' ? -1 : 1), true);
          schedule();
        });

        // Reserve horizontal gestures for the carousel; vertical page scrolling
        // and pinch zoom remain native. The benefit rail scrolls independently.
        const swipeSurface = hero.querySelector('.sch__slides');
        if (hero.dataset.swipe === 'true' && swipeSurface) {
          swipeSurface.style.touchAction = 'pan-y pinch-zoom';
          on(swipeSurface, 'pointerdown', (event) => {
            if (event.pointerType === 'mouse' || !event.isPrimary) return;
            gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, axis: null };
            stop();
          });
          on(window, 'pointermove', (event) => {
            if (!gesture || gesture.id !== event.pointerId) return;
            const dx = event.clientX - gesture.x;
            const dy = event.clientY - gesture.y;
            if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 8) {
              gesture.axis = Math.abs(dx) > Math.abs(dy) * 1.15 ? 'x' : 'y';
            }
            gesture.dx = dx;
            if (gesture.axis === 'x' && event.cancelable) event.preventDefault();
          }, { passive: false });
          on(window, 'pointerup', (event) => {
            if (!gesture || gesture.id !== event.pointerId) return;
            const dx = event.clientX - gesture.x;
            const dy = event.clientY - gesture.y;
            const threshold = Math.min(60, Math.max(20, Number(hero.dataset.swipeThreshold) || 35));
            if (gesture.axis !== 'y' && Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.15) {
              suppressClickUntil = Date.now() + 500;
              show(current + (dx < 0 ? 1 : -1), true);
            }
            gesture = null;
            schedule();
          });
          on(window, 'pointercancel', (event) => {
            if (!gesture || gesture.id !== event.pointerId) return;
            gesture = null;
            schedule();
          });
          on(swipeSurface, 'click', (event) => {
            if (Date.now() >= suppressClickUntil) return;
            event.preventDefault();
            event.stopImmediatePropagation();
          }, { capture: true });
          on(swipeSurface, 'dragstart', (event) => event.preventDefault());
        }

        on(document, 'visibilitychange', schedule);
        on(reducedMotion, 'change', schedule);
        on(hero, 'shopify:block:select', (event) => {
          const slide = event.target.closest('[data-sch-slide]');
          if (!slide) return;
          editorPaused = true;
          stop();
          show(Number(slide.dataset.index), false);
        });
        on(hero, 'shopify:block:deselect', () => { editorPaused = hero.dataset.designMode === 'true'; schedule(); });

        let observer = null;
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              visible = entry.isIntersecting;
              if (visible) hero.classList.add('is-in-view');
              schedule();
            });
          }, { threshold: 0.12 });
          observer.observe(hero);
        } else {
          hero.classList.add('is-in-view');
        }

        hero.schDestroy = () => {
          stop();
          observer?.disconnect();
          aborter.abort();
          delete hero.schDestroy;
        };

        show(current, false);
        schedule();
      });
    };

    initHero(document);
    document.addEventListener('shopify:section:load', (event) => initHero(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-sch]').forEach((hero) => hero.schDestroy?.());
    });
  })();

  (()=>{
    const init=root=>root.querySelectorAll('.sch__benefits:not([data-loop-ready])').forEach(rail=>{
      if(rail.dataset.mobileAuto==='false')return;
      const items=[...rail.children];if(items.length<2)return;
      rail.dataset.loopReady='true';
      const ctrl=new AbortController(),signal=ctrl.signal;
      const mobile=matchMedia('(max-width:749px)'),reduce=matchMedia('(prefers-reduced-motion:reduce)');
      const clones=[];
      const copy=()=>items.map(item=>{const c=item.cloneNode(true);c.dataset.schBenefitClone='';c.setAttribute('aria-hidden','true');c.removeAttribute('data-shopify-editor-block');c.removeAttribute('id');c.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));c.querySelectorAll('a,button,[tabindex]').forEach(n=>n.tabIndex=-1);clones.push(c);return c;});
      const a=copy(),b=copy(),c=copy(),d=copy();rail.prepend(...a,...b);rail.append(...c,...d);
      let active=false,period=0,origin=0,pos=0,last=0,raf=0,seen=false,touch=false,manual=false,until=0,width=-1,focused=false;
      const speed=Number(rail.dataset.mobileSpeed)||28;
      const layout=()=>{
        const next=mobile.matches&&!reduce.matches;
        const w=rail.clientWidth;if(w===width&&next===active)return;
        const fraction=period?((rail.scrollLeft-origin)%period+period)%period/period:0;
        width=w;active=next;rail.classList.toggle('sch-benefits-loop',active);
        if(active&&w){period=items[0].offsetLeft-b[0].offsetLeft;origin=2*period;pos=origin+fraction*period;rail.scrollLeft=pos;}else{period=0;rail.scrollLeft=0;}
        last=0;
      };
      rail.addEventListener('touchstart',()=>{touch=true;manual=true;pos=rail.scrollLeft;},{signal,passive:true});
      const release=e=>{if(e.touches?.length)return;touch=false;until=performance.now()+900;};
      rail.addEventListener('touchend',release,{signal,passive:true});rail.addEventListener('touchcancel',release,{signal,passive:true});
      rail.addEventListener('scroll',()=>{if(manual){pos=rail.scrollLeft;until=performance.now()+900;}},{signal,passive:true});
      rail.addEventListener('wheel',()=>{manual=true;until=performance.now()+900;},{signal,passive:true});
      rail.addEventListener('focusin',()=>{focused=true;},{signal});rail.addEventListener('focusout',e=>{if(!rail.contains(e.relatedTarget))focused=false;},{signal});
      rail.addEventListener('shopify:block:select',()=>{focused=true;},{signal});rail.addEventListener('shopify:block:deselect',()=>{focused=false;},{signal});
      const ro=new ResizeObserver(layout);ro.observe(rail);
      mobile.addEventListener('change',layout,{signal});reduce.addEventListener('change',layout,{signal});
      const io='IntersectionObserver'in window?new IntersectionObserver(entries=>{seen=entries[0].isIntersecting;last=0;},{threshold:.05}):null;
      if(io)io.observe(rail);else seen=true;
      const tick=time=>{
        const dt=last?Math.min(time-last,40)/1000:0;last=time;
        if(active&&period&&seen&&!document.hidden&&!touch&&!focused&&time>=until){
          if(manual){pos=rail.scrollLeft;manual=false;}
          pos=origin+((pos-origin+speed*dt)%period+period)%period;rail.scrollLeft=pos;
        }
        raf=requestAnimationFrame(tick);
      };
      layout();raf=requestAnimationFrame(tick);
      document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(rail)){ctrl.abort();ro.disconnect();io?.disconnect();cancelAnimationFrame(raf);clones.forEach(n=>n.remove());delete rail.dataset.loopReady;}},{signal});
    });
    init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-layer-explorer-firm"] && !Shopify.designMode) return;
  try {
    
(() => {
  const NAME = 'sleepy-mattress-layers';
  // Each section file registers its own variant data, then whichever loads
  // first defines the element. Both firmnesses can therefore share a page.
  const REG = (window.__sleepyLayerVariants ||= {});
  REG['firm'] = (root, DIAGRAM_URL, FABRIC_URL, NS) => {
    const ns = id => NS + id;
    const variant = 'firm';

const MAT = {
  cover: 'Knitted bamboo', quilt: 'Quilted fibre', memory: 'Memory foam',
  response: 'Response foam', support: 'Support foam', felt: 'Cotton felt',
  spring: 'Pocket springs', base: 'Quilted base'
};

const D_COVER = "A luxuriously soft knitted bamboo cover creating a smooth, breathable, cool feeling surface against the skin. Moisture-managing properties disperse warmth and humidity for a fresher, drier sleep environment. Naturally antibacterial and hypoallergenic \u2014 ideal for sensitive sleepers.";
const D_QUILT = "A lightly cushioned quilted layer giving immediate comfort from the moment you lie down, softening initial contact and reducing pressure around the shoulders and hips without losing supportive character.";
const D_FELT_U = "A dense cotton felt layer above the pocket springs that spreads pressure evenly, stops coils pressing into the foams above, and protects the mattress's internal structure and long-term durability.";
const D_FELT_L = "A second cotton felt layer beneath the springs that anchors the core, eliminates internal shifting, reduces friction and noise, and lets the spring system move smoothly and independently.";
const D_BASE = "A quilted polyester foundation with light foam padding that protects and encloses the mattress underside, reducing abrasion and wear while giving a clean, premium finish.";

// x/y are fractions of the diagram image, matching each slab's numbered marker
const DATA={"firm":{"id":"firm","label":"Medium Firm","img":"assets/mattress-layers-firm.png","layers":[{"title":"BlissBreathe™ Bamboo Cover","benefit":"Cooling, Antibacterial and Hypoallergenic","dim":"","short":"Bamboo Cover","mat":"cover","x":88.9,"y":12.8,"desc":"A luxuriously soft knitted bamboo cover creating a smooth, breathable, cool feeling surface against the skin. Moisture-managing properties disperse warmth and humidity for a fresher, drier sleep environment. Naturally antibacterial and hypoallergenic — ideal for sensitive sleepers."},{"title":"BlissNest™ Quilted Comfort Layer","benefit":"Instant Comfort","dim":"","short":"Quilted Comfort","mat":"quilt","x":88.9,"y":24.3,"desc":"A lightly cushioned quilted layer giving immediate comfort from the moment you lie down, softening initial contact and reducing pressure around the shoulders and hips without losing supportive character."},{"title":"RippleFlex™ Response Foam","benefit":"Responsive Comfort, Airflow and Movement Control","dim":"","short":"Response Foam","mat":"response","x":88.9,"y":34.7,"desc":"A wave-profiled foam that compresses and responds quickly as you move, creating airflow channels through the comfort system and cushioning movement before it reaches the spring core."},{"title":"BalanceCore™ Support Foam","benefit":"Orthopaedic Support and Spinal Alignment","dim":"","short":"Support Foam","mat":"support","x":88.9,"y":43.4,"desc":"The structural bridge between comfort layers and the spring core, distributing weight evenly, preventing excess sinking, and encouraging natural spinal alignment."},{"title":"CottonLock™ Stabilising Layer (Upper)","benefit":"Load Distribution and Durability","dim":"","short":"Cotton Felt (Upper)","mat":"felt","x":88.9,"y":51.6,"desc":"A dense cotton felt layer above the pocket springs that spreads pressure evenly, stops coils pressing into the foams above, and protects the mattress's internal structure and long-term durability."},{"title":"BodySync 7™ FirmTune Pocket Spring Core","benefit":"Firm Orthopaedic Support","dim":"","short":"FirmTune Spring Core","mat":"spring","x":88.9,"y":62.9,"desc":"The primary orthopaedic support and partner-disturbance system. Individually pocketed springs compress independently across seven targeted support zones (head, shoulders, lower back, hips, thighs, knees, feet), delivering firm support with next-to-no partner disturbance."},{"title":"CottonLock™ Stabilising Layer (Lower)","benefit":"Core Security and Noise Control","dim":"","short":"Cotton Felt (Lower)","mat":"felt","x":88.9,"y":72.9,"desc":"A second cotton felt layer beneath the springs that anchors the core, eliminates internal shifting, reduces friction and noise, and lets the spring system move smoothly and independently."},{"title":"BaseGuard™ Quilted Foundation","benefit":"Protective Durability","dim":"","short":"Quilted Base","mat":"base","x":88.9,"y":87,"desc":"A quilted polyester foundation with light foam padding that protects and encloses the mattress underside, reducing abrasion and wear while giving a clean, premium finish."}]}};


const IMAGES={"firm":DIAGRAM_URL};
// Masks follow the existing photographed layers. Each layer keeps its proportions;
// only its vertical position changes. There is no selected-layer duplicate.
const BASE_REFERENCE=FABRIC_URL;
const GEO={"firm":{"rest":[190,140,95,55,25,0,-20,-40],"bounds":[[[244,17],[1097,17],[1233,122],[1234,139],[24,139],[24,124]],[[123,140],[1166,140],[1233,191],[1233,207],[1220,213],[38,214],[25,209],[26,191]],[[120,214],[1166,214],[1227,266],[1227,289],[29,289],[28,270]],[[95,290],[1182,290],[1225,333],[1225,355],[1214,359],[43,359],[31,355],[31,332]],[[99,360],[1180,360],[1223,399],[1223,409],[35,410],[35,399]],[[120,410],[1155,410],[1215,450],[1215,527],[1180,533],[60,533],[45,526],[44,450]],[[78,534],[1182,534],[1215,561],[1215,570],[43,570],[43,560]],[[95,571],[1162,571],[1222,632],[1223,699],[1209,716],[1160,724],[75,724],[42,711],[36,686],[37,636]]]}};
// The client photograph's charcoal sidewall spans 912 by 113 pixels.
// Use one scale in both axes, then increase the fascia height to fit it.
const BASE_PHOTO={left:43,right:955,top:459,bottom:565};
for(const [name,g] of Object.entries(GEO)){
 const index=g.bounds.length-1;
 const left=name==='firm'?36:32,right=name==='firm'?1223:1233;
 const scale=(right-left)/(BASE_PHOTO.right-BASE_PHOTO.left);
 const bottom=641+(BASE_PHOTO.bottom-BASE_PHOTO.top)*scale;
 const previousBottom=Math.max(...g.bounds[index].map(p=>p[1]));
 const delta=bottom-previousBottom;
 g.basePhoto={left,right,scale,bottom};
 g.bounds[index]=g.bounds[index].map(([x,y])=>[x,y<=641?y:641+(y-641)*(bottom-641)/(previousBottom-641)]);
 // The bottom edge remains fixed while the corrected sidewall grows upwards.
 g.rest[index]-=delta;
}
const SPRING_CONTOURS={"firm":[[44.86,449.85],[45.65,448.28],[46.44,447.49],[47.22,447.49],[48.01,446.71],[48.8,446.71],[49.59,445.92],[50.37,445.92],[51.16,445.92],[51.95,445.14],[52.73,445.14],[53.52,445.14],[54.31,445.14],[55.09,444.35],[55.88,444.35],[56.67,444.35],[57.46,439.63],[58.24,438.06],[59.03,438.06],[59.82,437.27],[60.6,437.27],[61.39,436.48],[62.18,436.48],[62.97,435.7],[63.75,435.7],[64.54,435.7],[65.33,435.7],[66.11,434.91],[66.9,434.91],[67.69,434.91],[68.47,434.91],[69.26,430.19],[70.05,429.41],[70.84,429.41],[71.62,428.62],[72.41,428.62],[73.2,427.83],[73.98,427.83],[74.77,427.83],[75.56,427.05],[76.35,427.05],[77.13,427.05],[77.92,427.05],[78.71,426.26],[79.49,422.33],[80.28,421.54],[81.07,420.76],[81.85,420.76],[82.64,419.97],[83.43,419.97],[84.22,419.97],[85,419.18],[85.79,419.18],[86.58,419.18],[87.36,419.18],[88.15,419.18],[88.94,418.4],[89.73,414.46],[90.51,413.68],[91.3,412.89],[92.09,412.89],[92.87,412.89],[93.66,412.1],[94.45,412.1],[95.23,412.1],[96.02,411.32],[96.81,411.32],[97.6,411.32],[98.38,411.32],[99.17,411.32],[99.96,411.32],[100.74,409.74],[101.53,409.74],[102.32,409.74],[103.11,409.74],[103.89,409.74],[104.68,409.74],[105.47,409.74],[106.25,409.74],[107.04,409.74],[107.83,409.74],[108.62,409.74],[109.4,409.74],[110.19,409.74],[110.98,409.74],[111.76,409.74],[112.55,409.74],[113.34,409.74],[114.12,409.74],[114.91,409.74],[115.7,409.74],[116.49,409.74],[117.27,409.74],[118.06,409.74],[118.85,409.74],[119.63,409.74],[120.42,409.74],[121.21,409.74],[122,409.74],[122.78,409.74],[123.57,409.74],[124.36,409.74],[125.14,409.74],[125.93,409.74],[126.72,409.74],[127.5,409.74],[128.29,409.74],[129.08,409.74],[129.87,409.74],[130.65,409.74],[131.44,409.74],[132.23,409.74],[133.01,409.74],[133.8,409.74],[134.59,409.74],[135.38,409.74],[136.16,409.74],[136.95,409.74],[137.74,409.74],[138.52,409.74],[139.31,409.74],[140.1,409.74],[140.88,409.74],[141.67,409.74],[142.46,409.74],[143.25,409.74],[144.03,409.74],[144.82,409.74],[145.61,409.74],[146.39,409.74],[147.18,409.74],[147.97,409.74],[148.76,409.74],[149.54,409.74],[150.33,409.74],[151.12,409.74],[151.9,409.74],[152.69,409.74],[153.48,409.74],[154.26,409.74],[155.05,409.74],[155.84,409.74],[156.63,409.74],[157.41,409.74],[158.2,409.74],[158.99,409.74],[159.77,409.74],[160.56,409.74],[161.35,409.74],[162.14,409.74],[162.92,409.74],[163.71,409.74],[164.5,409.74],[165.28,409.74],[166.07,409.74],[166.86,409.74],[167.64,409.74],[168.43,409.74],[169.22,409.74],[170.01,409.74],[170.79,409.74],[171.58,411.32],[172.37,411.32],[173.15,411.32],[173.94,411.32],[174.73,411.32],[175.52,411.32],[176.3,411.32],[177.09,410.53],[177.88,410.53],[178.66,409.74],[179.45,409.74],[180.24,409.74],[181.03,409.74],[181.81,409.74],[182.6,409.74],[183.39,409.74],[184.17,409.74],[184.96,409.74],[185.75,409.74],[186.53,409.74],[187.32,409.74],[188.11,409.74],[188.9,409.74],[189.68,409.74],[190.47,409.74],[191.26,409.74],[192.04,409.74],[192.83,409.74],[193.62,409.74],[194.41,409.74],[195.19,409.74],[195.98,409.74],[196.77,409.74],[197.55,409.74],[198.34,409.74],[199.13,409.74],[199.91,409.74],[200.7,409.74],[201.49,409.74],[202.28,409.74],[203.06,409.74],[203.85,409.74],[204.64,409.74],[205.42,409.74],[206.21,409.74],[207,409.74],[207.79,412.1],[208.57,409.74],[209.36,411.32],[210.15,411.32],[210.93,411.32],[211.72,411.32],[212.51,411.32],[213.29,411.32],[214.08,410.53],[214.87,410.53],[215.66,410.53],[216.44,410.53],[217.23,409.74],[218.02,409.74],[218.8,409.74],[219.59,409.74],[220.38,409.74],[221.17,409.74],[221.95,409.74],[222.74,409.74],[223.53,409.74],[224.31,409.74],[225.1,409.74],[225.89,409.74],[226.67,409.74],[227.46,409.74],[228.25,409.74],[229.04,409.74],[229.82,409.74],[230.61,409.74],[231.4,409.74],[232.18,409.74],[232.97,409.74],[233.76,409.74],[234.55,409.74],[235.33,409.74],[236.12,409.74],[236.91,409.74],[237.69,409.74],[238.48,410.53],[239.27,411.32],[240.05,409.74],[240.84,409.74],[241.63,409.74],[242.42,409.74],[243.2,412.1],[243.99,412.1],[244.78,412.1],[245.56,411.32],[246.35,411.32],[247.14,411.32],[247.93,411.32],[248.71,411.32],[249.5,411.32],[250.29,410.53],[251.07,409.74],[251.86,409.74],[252.65,409.74],[253.44,409.74],[254.22,409.74],[255.01,409.74],[255.8,409.74],[256.58,409.74],[257.37,409.74],[258.16,409.74],[258.94,409.74],[259.73,409.74],[260.52,409.74],[261.31,409.74],[262.09,409.74],[262.88,409.74],[263.67,409.74],[264.45,409.74],[265.24,409.74],[266.03,409.74],[266.82,409.74],[267.6,409.74],[268.39,409.74],[269.18,409.74],[269.96,409.74],[270.75,409.74],[271.54,409.74],[272.32,409.74],[273.11,409.74],[273.9,409.74],[274.69,409.74],[275.47,409.74],[276.26,409.74],[277.05,409.74],[277.83,409.74],[278.62,409.74],[279.41,409.74],[280.2,412.1],[280.98,412.1],[281.77,411.32],[282.56,411.32],[283.34,411.32],[284.13,411.32],[284.92,411.32],[285.7,411.32],[286.49,410.53],[287.28,410.53],[288.07,410.53],[288.85,409.74],[289.64,409.74],[290.43,409.74],[291.21,409.74],[292,409.74],[292.79,409.74],[293.58,409.74],[294.36,409.74],[295.15,409.74],[295.94,409.74],[296.72,409.74],[297.51,409.74],[298.3,409.74],[299.08,409.74],[299.87,409.74],[300.66,409.74],[301.45,409.74],[302.23,409.74],[303.02,409.74],[303.81,409.74],[304.59,409.74],[305.38,409.74],[306.17,409.74],[306.96,409.74],[307.74,409.74],[308.53,409.74],[309.32,409.74],[310.1,409.74],[310.89,409.74],[311.68,409.74],[312.46,409.74],[313.25,409.74],[314.04,409.74],[314.83,409.74],[315.61,412.1],[316.4,411.32],[317.19,411.32],[317.97,411.32],[318.76,411.32],[319.55,411.32],[320.34,409.74],[321.12,409.74],[321.91,409.74],[322.7,409.74],[323.48,409.74],[324.27,409.74],[325.06,409.74],[325.85,409.74],[326.63,409.74],[327.42,409.74],[328.21,409.74],[328.99,409.74],[329.78,409.74],[330.57,409.74],[331.35,409.74],[332.14,409.74],[332.93,409.74],[333.72,409.74],[334.5,409.74],[335.29,409.74],[336.08,409.74],[336.86,409.74],[337.65,409.74],[338.44,409.74],[339.23,409.74],[340.01,409.74],[340.8,409.74],[341.59,409.74],[342.37,409.74],[343.16,409.74],[343.95,409.74],[344.73,410.53],[345.52,410.53],[346.31,411.32],[347.1,412.1],[347.88,409.74],[348.67,409.74],[349.46,409.74],[350.24,412.1],[351.03,412.1],[351.82,411.32],[352.61,411.32],[353.39,411.32],[354.18,411.32],[354.97,411.32],[355.75,411.32],[356.54,410.53],[357.33,410.53],[358.11,410.53],[358.9,409.74],[359.69,409.74],[360.48,409.74],[361.26,409.74],[362.05,409.74],[362.84,409.74],[363.62,409.74],[364.41,409.74],[365.2,409.74],[365.99,409.74],[366.77,409.74],[367.56,409.74],[368.35,409.74],[369.13,409.74],[369.92,409.74],[370.71,409.74],[371.49,409.74],[372.28,409.74],[373.07,409.74],[373.86,409.74],[374.64,409.74],[375.43,409.74],[376.22,409.74],[377,409.74],[377.79,409.74],[378.58,409.74],[379.37,409.74],[380.15,409.74],[380.94,409.74],[381.73,410.53],[382.51,409.74],[383.3,409.74],[384.09,409.74],[384.87,412.1],[385.66,412.1],[386.45,412.1],[387.24,411.32],[388.02,411.32],[388.81,411.32],[389.6,411.32],[390.38,411.32],[391.17,411.32],[391.96,410.53],[392.75,410.53],[393.53,409.74],[394.32,409.74],[395.11,409.74],[395.89,409.74],[396.68,409.74],[397.47,409.74],[398.26,409.74],[399.04,409.74],[399.83,409.74],[400.62,409.74],[401.4,409.74],[402.19,409.74],[402.98,409.74],[403.76,409.74],[404.55,409.74],[405.34,409.74],[406.13,409.74],[406.91,409.74],[407.7,409.74],[408.49,409.74],[409.27,409.74],[410.06,409.74],[410.85,409.74],[411.64,409.74],[412.42,409.74],[413.21,409.74],[414,409.74],[414.78,409.74],[415.57,409.74],[416.36,409.74],[417.14,409.74],[417.93,410.53],[418.72,411.32],[419.51,413.68],[420.29,409.74],[421.08,409.74],[421.87,409.74],[422.65,412.1],[423.44,412.1],[424.23,411.32],[425.02,411.32],[425.8,411.32],[426.59,411.32],[427.38,411.32],[428.16,411.32],[428.95,410.53],[429.74,409.74],[430.52,409.74],[431.31,409.74],[432.1,409.74],[432.89,409.74],[433.67,409.74],[434.46,409.74],[435.25,409.74],[436.03,409.74],[436.82,409.74],[437.61,409.74],[438.4,409.74],[439.18,409.74],[439.97,409.74],[440.76,409.74],[441.54,409.74],[442.33,409.74],[443.12,409.74],[443.9,409.74],[444.69,409.74],[445.48,409.74],[446.27,409.74],[447.05,409.74],[447.84,409.74],[448.63,409.74],[449.41,409.74],[450.2,409.74],[450.99,409.74],[451.78,409.74],[452.56,409.74],[453.35,409.74],[454.14,409.74],[454.92,412.89],[455.71,409.74],[456.5,412.89],[457.28,412.1],[458.07,412.1],[458.86,412.1],[459.65,411.32],[460.43,411.32],[461.22,411.32],[462.01,411.32],[462.79,411.32],[463.58,411.32],[464.37,410.53],[465.16,410.53],[465.94,410.53],[466.73,410.53],[467.52,409.74],[468.3,409.74],[469.09,409.74],[469.88,409.74],[470.67,409.74],[471.45,409.74],[472.24,409.74],[473.03,409.74],[473.81,409.74],[474.6,409.74],[475.39,409.74],[476.17,409.74],[476.96,409.74],[477.75,409.74],[478.54,409.74],[479.32,409.74],[480.11,409.74],[480.9,409.74],[481.68,409.74],[482.47,409.74],[483.26,409.74],[484.05,409.74],[484.83,409.74],[485.62,409.74],[486.41,409.74],[487.19,410.53],[487.98,410.53],[488.77,410.53],[489.55,410.53],[490.34,411.32],[491.13,413.68],[491.92,412.89],[492.7,412.89],[493.49,412.1],[494.28,412.1],[495.06,411.32],[495.85,411.32],[496.64,411.32],[497.43,411.32],[498.21,411.32],[499,411.32],[499.79,411.32],[500.57,410.53],[501.36,410.53],[502.15,409.74],[502.93,409.74],[503.72,409.74],[504.51,409.74],[505.3,409.74],[506.08,409.74],[506.87,409.74],[507.66,409.74],[508.44,409.74],[509.23,409.74],[510.02,409.74],[510.81,409.74],[511.59,409.74],[512.38,409.74],[513.17,409.74],[513.95,409.74],[514.74,409.74],[515.53,409.74],[516.31,409.74],[517.1,409.74],[517.89,409.74],[518.68,409.74],[519.46,409.74],[520.25,409.74],[521.04,409.74],[521.82,409.74],[522.61,409.74],[523.4,409.74],[524.19,409.74],[524.97,409.74],[525.76,409.74],[526.55,409.74],[527.33,409.74],[528.12,412.1],[528.91,412.1],[529.69,412.1],[530.48,411.32],[531.27,411.32],[532.06,411.32],[532.84,409.74],[533.63,409.74],[534.42,409.74],[535.2,409.74],[535.99,409.74],[536.78,409.74],[537.57,409.74],[538.35,409.74],[539.14,409.74],[539.93,409.74],[540.71,409.74],[541.5,409.74],[542.29,409.74],[543.08,409.74],[543.86,409.74],[544.65,409.74],[545.44,409.74],[546.22,409.74],[547.01,409.74],[547.8,409.74],[548.58,409.74],[549.37,409.74],[550.16,409.74],[550.95,409.74],[551.73,409.74],[552.52,409.74],[553.31,409.74],[554.09,409.74],[554.88,409.74],[555.67,409.74],[556.46,409.74],[557.24,410.53],[558.03,410.53],[558.82,411.32],[559.6,411.32],[560.39,412.89],[561.18,415.25],[561.96,412.89],[562.75,412.89],[563.54,412.1],[564.33,411.32],[565.11,411.32],[565.9,411.32],[566.69,411.32],[567.47,411.32],[568.26,411.32],[569.05,411.32],[569.84,411.32],[570.62,410.53],[571.41,409.74],[572.2,409.74],[572.98,409.74],[573.77,409.74],[574.56,409.74],[575.34,409.74],[576.13,409.74],[576.92,409.74],[577.71,409.74],[578.49,409.74],[579.28,409.74],[580.07,409.74],[580.85,409.74],[581.64,409.74],[582.43,409.74],[583.22,409.74],[584,409.74],[584.79,409.74],[585.58,409.74],[586.36,409.74],[587.15,409.74],[587.94,409.74],[588.72,409.74],[589.51,409.74],[590.3,410.53],[591.09,410.53],[591.87,410.53],[592.66,409.74],[593.45,409.74],[594.23,409.74],[595.02,409.74],[595.81,409.74],[596.6,412.89],[597.38,412.1],[598.17,412.1],[598.96,411.32],[599.74,411.32],[600.53,411.32],[601.32,411.32],[602.1,410.53],[602.89,410.53],[603.68,410.53],[604.47,410.53],[605.25,409.74],[606.04,409.74],[606.83,409.74],[607.61,409.74],[608.4,409.74],[609.19,409.74],[609.98,409.74],[610.76,409.74],[611.55,409.74],[612.34,409.74],[613.12,409.74],[613.91,409.74],[614.7,409.74],[615.49,409.74],[616.27,409.74],[617.06,409.74],[617.85,409.74],[618.63,409.74],[619.42,409.74],[620.21,409.74],[620.99,409.74],[621.78,409.74],[622.57,409.74],[623.36,409.74],[624.14,409.74],[624.93,409.74],[625.72,409.74],[626.5,409.74],[627.29,409.74],[628.08,409.74],[628.87,412.1],[629.65,412.89],[630.44,412.89],[631.23,412.89],[632.01,412.1],[632.8,411.32],[633.59,411.32],[634.37,411.32],[635.16,411.32],[635.95,411.32],[636.74,410.53],[637.52,409.74],[638.31,409.74],[639.1,409.74],[639.88,409.74],[640.67,409.74],[641.46,409.74],[642.25,409.74],[643.03,409.74],[643.82,409.74],[644.61,409.74],[645.39,409.74],[646.18,409.74],[646.97,409.74],[647.75,409.74],[648.54,409.74],[649.33,409.74],[650.12,409.74],[650.9,409.74],[651.69,409.74],[652.48,409.74],[653.26,409.74],[654.05,409.74],[654.84,409.74],[655.63,409.74],[656.41,409.74],[657.2,409.74],[657.99,410.53],[658.77,410.53],[659.56,410.53],[660.35,411.32],[661.13,411.32],[661.92,411.32],[662.71,412.1],[663.5,412.89],[664.28,412.89],[665.07,412.89],[665.86,412.1],[666.64,411.32],[667.43,411.32],[668.22,411.32],[669.01,411.32],[669.79,411.32],[670.58,409.74],[671.37,409.74],[672.15,409.74],[672.94,409.74],[673.73,409.74],[674.51,409.74],[675.3,409.74],[676.09,409.74],[676.88,409.74],[677.66,409.74],[678.45,409.74],[679.24,409.74],[680.02,409.74],[680.81,409.74],[681.6,409.74],[682.39,409.74],[683.17,409.74],[683.96,409.74],[684.75,409.74],[685.53,409.74],[686.32,409.74],[687.11,409.74],[687.9,409.74],[688.68,409.74],[689.47,409.74],[690.26,409.74],[691.04,409.74],[691.83,409.74],[692.62,411.32],[693.4,411.32],[694.19,411.32],[694.98,412.1],[695.77,413.68],[696.55,412.89],[697.34,412.1],[698.13,411.32],[698.91,409.74],[699.7,409.74],[700.49,409.74],[701.28,409.74],[702.06,409.74],[702.85,409.74],[703.64,409.74],[704.42,409.74],[705.21,409.74],[706,409.74],[706.78,409.74],[707.57,409.74],[708.36,409.74],[709.15,409.74],[709.93,409.74],[710.72,409.74],[711.51,409.74],[712.29,409.74],[713.08,409.74],[713.87,409.74],[714.66,409.74],[715.44,409.74],[716.23,409.74],[717.02,409.74],[717.8,409.74],[718.59,409.74],[719.38,409.74],[720.16,409.74],[720.95,409.74],[721.74,409.74],[722.53,409.74],[723.31,409.74],[724.1,410.53],[724.89,410.53],[725.67,411.32],[726.46,411.32],[727.25,411.32],[728.04,412.1],[728.82,412.89],[729.61,421.54],[730.4,412.89],[731.18,412.1],[731.97,412.1],[732.76,411.32],[733.54,409.74],[734.33,409.74],[735.12,409.74],[735.91,409.74],[736.69,409.74],[737.48,409.74],[738.27,409.74],[739.05,409.74],[739.84,409.74],[740.63,409.74],[741.42,409.74],[742.2,409.74],[742.99,409.74],[743.78,409.74],[744.56,409.74],[745.35,409.74],[746.14,409.74],[746.92,409.74],[747.71,409.74],[748.5,409.74],[749.29,409.74],[750.07,409.74],[750.86,409.74],[751.65,409.74],[752.43,409.74],[753.22,409.74],[754.01,409.74],[754.8,409.74],[755.58,409.74],[756.37,409.74],[757.16,409.74],[757.94,409.74],[758.73,409.74],[759.52,410.53],[760.31,410.53],[761.09,411.32],[761.88,411.32],[762.67,412.1],[763.45,412.89],[764.24,418.4],[765.03,412.1],[765.81,412.1],[766.6,412.1],[767.39,411.32],[768.18,411.32],[768.96,411.32],[769.75,411.32],[770.54,411.32],[771.32,411.32],[772.11,410.53],[772.9,410.53],[773.69,409.74],[774.47,409.74],[775.26,409.74],[776.05,409.74],[776.83,409.74],[777.62,409.74],[778.41,409.74],[779.19,409.74],[779.98,409.74],[780.77,409.74],[781.56,409.74],[782.34,409.74],[783.13,409.74],[783.92,409.74],[784.7,409.74],[785.49,409.74],[786.28,409.74],[787.07,409.74],[787.85,409.74],[788.64,409.74],[789.43,409.74],[790.21,409.74],[791,409.74],[791.79,409.74],[792.57,409.74],[793.36,410.53],[794.15,410.53],[794.94,410.53],[795.72,411.32],[796.51,411.32],[797.3,411.32],[798.08,412.1],[798.87,409.74],[799.66,409.74],[800.45,409.74],[801.23,409.74],[802.02,409.74],[802.81,409.74],[803.59,409.74],[804.38,409.74],[805.17,409.74],[805.95,409.74],[806.74,409.74],[807.53,409.74],[808.32,409.74],[809.1,409.74],[809.89,409.74],[810.68,409.74],[811.46,409.74],[812.25,409.74],[813.04,409.74],[813.83,409.74],[814.61,409.74],[815.4,409.74],[816.19,409.74],[816.97,409.74],[817.76,409.74],[818.55,409.74],[819.33,409.74],[820.12,409.74],[820.91,409.74],[821.7,409.74],[822.48,409.74],[823.27,409.74],[824.06,409.74],[824.84,409.74],[825.63,410.53],[826.42,410.53],[827.21,411.32],[827.99,411.32],[828.78,411.32],[829.57,411.32],[830.35,412.1],[831.14,412.1],[831.93,412.89],[832.72,413.68],[833.5,417.61],[834.29,412.89],[835.08,412.1],[835.86,411.32],[836.65,411.32],[837.44,411.32],[838.22,411.32],[839.01,411.32],[839.8,411.32],[840.59,410.53],[841.37,410.53],[842.16,410.53],[842.95,409.74],[843.73,409.74],[844.52,409.74],[845.31,409.74],[846.1,409.74],[846.88,409.74],[847.67,409.74],[848.46,409.74],[849.24,409.74],[850.03,409.74],[850.82,409.74],[851.6,409.74],[852.39,409.74],[853.18,409.74],[853.97,409.74],[854.75,409.74],[855.54,409.74],[856.33,409.74],[857.11,409.74],[857.9,409.74],[858.69,409.74],[859.48,409.74],[860.26,409.74],[861.05,409.74],[861.84,409.74],[862.62,409.74],[863.41,409.74],[864.2,409.74],[864.98,411.32],[865.77,412.1],[866.56,412.89],[867.35,413.68],[868.13,409.74],[868.92,409.74],[869.71,409.74],[870.49,411.32],[871.28,411.32],[872.07,409.74],[872.86,409.74],[873.64,409.74],[874.43,409.74],[875.22,409.74],[876,409.74],[876.79,409.74],[877.58,409.74],[878.36,409.74],[879.15,409.74],[879.94,409.74],[880.73,409.74],[881.51,409.74],[882.3,409.74],[883.09,409.74],[883.87,409.74],[884.66,409.74],[885.45,409.74],[886.24,409.74],[887.02,409.74],[887.81,409.74],[888.6,409.74],[889.38,409.74],[890.17,409.74],[890.96,409.74],[891.74,409.74],[892.53,409.74],[893.32,409.74],[894.11,410.53],[894.89,410.53],[895.68,410.53],[896.47,410.53],[897.25,411.32],[898.04,411.32],[898.83,411.32],[899.62,411.32],[900.4,412.1],[901.19,412.89],[901.98,413.68],[902.76,409.74],[903.55,412.1],[904.34,409.74],[905.13,411.32],[905.91,411.32],[906.7,410.53],[907.49,409.74],[908.27,409.74],[909.06,409.74],[909.85,409.74],[910.63,409.74],[911.42,409.74],[912.21,409.74],[913,409.74],[913.78,409.74],[914.57,409.74],[915.36,409.74],[916.14,409.74],[916.93,409.74],[917.72,409.74],[918.51,409.74],[919.29,409.74],[920.08,409.74],[920.87,409.74],[921.65,409.74],[922.44,409.74],[923.23,409.74],[924.01,409.74],[924.8,409.74],[925.59,409.74],[926.38,409.74],[927.16,409.74],[927.95,409.74],[928.74,409.74],[929.52,409.74],[930.31,410.53],[931.1,411.32],[931.89,411.32],[932.67,411.32],[933.46,411.32],[934.25,411.32],[935.03,412.1],[935.82,412.89],[936.61,412.89],[937.39,419.18],[938.18,412.89],[938.97,409.74],[939.76,409.74],[940.54,411.32],[941.33,411.32],[942.12,409.74],[942.9,409.74],[943.69,409.74],[944.48,409.74],[945.27,409.74],[946.05,409.74],[946.84,409.74],[947.63,409.74],[948.41,409.74],[949.2,409.74],[949.99,409.74],[950.77,409.74],[951.56,409.74],[952.35,409.74],[953.14,409.74],[953.92,409.74],[954.71,409.74],[955.5,409.74],[956.28,409.74],[957.07,409.74],[957.86,409.74],[958.65,409.74],[959.43,409.74],[960.22,409.74],[961.01,409.74],[961.79,409.74],[962.58,409.74],[963.37,409.74],[964.15,409.74],[964.94,409.74],[965.73,409.74],[966.52,409.74],[967.3,411.32],[968.09,411.32],[968.88,411.32],[969.66,411.32],[970.45,411.32],[971.24,412.1],[972.03,409.74],[972.81,409.74],[973.6,409.74],[974.39,409.74],[975.17,409.74],[975.96,409.74],[976.75,409.74],[977.54,409.74],[978.32,409.74],[979.11,409.74],[979.9,409.74],[980.68,409.74],[981.47,409.74],[982.26,409.74],[983.04,409.74],[983.83,409.74],[984.62,409.74],[985.41,409.74],[986.19,409.74],[986.98,409.74],[987.77,409.74],[988.55,409.74],[989.34,409.74],[990.13,409.74],[990.92,409.74],[991.7,409.74],[992.49,409.74],[993.28,409.74],[994.06,409.74],[994.85,409.74],[995.64,409.74],[996.42,409.74],[997.21,409.74],[998,409.74],[998.79,409.74],[999.57,410.53],[1000.36,410.53],[1001.15,410.53],[1001.93,411.32],[1002.72,411.32],[1003.51,411.32],[1004.3,411.32],[1005.08,411.32],[1005.87,412.1],[1006.66,412.89],[1007.44,413.68],[1008.23,411.32],[1009.02,411.32],[1009.8,409.74],[1010.59,410.53],[1011.38,409.74],[1012.17,409.74],[1012.95,409.74],[1013.74,409.74],[1014.53,409.74],[1015.31,409.74],[1016.1,409.74],[1016.89,409.74],[1017.68,409.74],[1018.46,409.74],[1019.25,409.74],[1020.04,409.74],[1020.82,409.74],[1021.61,409.74],[1022.4,409.74],[1023.18,409.74],[1023.97,409.74],[1024.76,409.74],[1025.55,409.74],[1026.33,409.74],[1027.12,409.74],[1027.91,409.74],[1028.69,409.74],[1029.48,409.74],[1030.27,409.74],[1031.06,409.74],[1031.84,409.74],[1032.63,409.74],[1033.42,409.74],[1034.2,410.53],[1034.99,410.53],[1035.78,410.53],[1036.56,411.32],[1037.35,411.32],[1038.14,411.32],[1038.93,411.32],[1039.71,412.1],[1040.5,411.32],[1041.29,409.74],[1042.07,409.74],[1042.86,409.74],[1043.65,409.74],[1044.44,409.74],[1045.22,409.74],[1046.01,409.74],[1046.8,409.74],[1047.58,409.74],[1048.37,409.74],[1049.16,409.74],[1049.95,409.74],[1050.73,409.74],[1051.52,409.74],[1052.31,409.74],[1053.09,409.74],[1053.88,409.74],[1054.67,409.74],[1055.45,409.74],[1056.24,409.74],[1057.03,409.74],[1057.82,409.74],[1058.6,409.74],[1059.39,409.74],[1060.18,409.74],[1060.96,409.74],[1061.75,409.74],[1062.54,409.74],[1063.33,409.74],[1064.11,409.74],[1064.9,409.74],[1065.69,409.74],[1066.47,409.74],[1067.26,409.74],[1068.05,410.53],[1068.83,410.53],[1069.62,411.32],[1070.41,411.32],[1071.2,411.32],[1071.98,411.32],[1072.77,411.32],[1073.56,411.32],[1074.34,412.1],[1075.13,412.89],[1075.92,412.1],[1076.71,411.32],[1077.49,409.74],[1078.28,409.74],[1079.07,409.74],[1079.85,409.74],[1080.64,409.74],[1081.43,409.74],[1082.21,409.74],[1083,409.74],[1083.79,409.74],[1084.58,409.74],[1085.36,409.74],[1086.15,409.74],[1086.94,409.74],[1087.72,409.74],[1088.51,409.74],[1089.3,409.74],[1090.09,409.74],[1090.87,409.74],[1091.66,409.74],[1092.45,409.74],[1093.23,409.74],[1094.02,409.74],[1094.81,409.74],[1095.59,409.74],[1096.38,409.74],[1097.17,409.74],[1097.96,409.74],[1098.74,409.74],[1099.53,409.74],[1100.32,409.74],[1101.1,409.74],[1101.89,409.74],[1102.68,409.74],[1103.47,409.74],[1104.25,410.53],[1105.04,410.53],[1105.83,411.32],[1106.61,411.32],[1107.4,411.32],[1108.19,411.32],[1108.97,411.32],[1109.76,412.1],[1110.55,412.1],[1111.34,409.74],[1112.12,412.1],[1112.91,409.74],[1113.7,409.74],[1114.48,409.74],[1115.27,409.74],[1116.06,409.74],[1116.85,409.74],[1117.63,409.74],[1118.42,409.74],[1119.21,409.74],[1119.99,409.74],[1120.78,409.74],[1121.57,409.74],[1122.36,409.74],[1123.14,409.74],[1123.93,409.74],[1124.72,409.74],[1125.5,409.74],[1126.29,409.74],[1127.08,409.74],[1127.86,409.74],[1128.65,409.74],[1129.44,409.74],[1130.23,409.74],[1131.01,409.74],[1131.8,409.74],[1132.59,409.74],[1133.37,409.74],[1134.16,409.74],[1134.95,409.74],[1135.74,409.74],[1136.52,409.74],[1137.31,409.74],[1138.1,409.74],[1138.88,409.74],[1139.67,409.74],[1140.46,409.74],[1141.24,409.74],[1142.03,410.53],[1142.82,410.53],[1143.61,410.53],[1144.39,410.53],[1145.18,410.53],[1145.97,410.53],[1146.75,409.74],[1147.54,409.74],[1148.33,409.74],[1149.12,409.74],[1149.9,409.74],[1150.69,409.74],[1151.48,409.74],[1152.26,409.74],[1153.05,409.74],[1153.84,409.74],[1154.62,409.74],[1155.41,409.74],[1156.2,409.74],[1156.99,409.74],[1157.77,409.74],[1158.56,409.74],[1159.35,409.74],[1160.13,409.74],[1160.92,409.74],[1161.71,409.74],[1162.5,409.74],[1163.28,409.74],[1164.07,409.74],[1164.86,409.74],[1165.64,409.74],[1166.43,409.74],[1167.22,409.74],[1168,409.74],[1168.79,409.74],[1169.58,409.74],[1170.37,409.74],[1171.15,409.74],[1171.94,409.74],[1172.73,409.74],[1173.51,409.74],[1174.3,409.74],[1175.09,409.74],[1175.88,409.74],[1176.66,409.74],[1177.45,409.74],[1178.24,410.53],[1179.02,410.53],[1179.81,410.53],[1180.6,411.32],[1181.38,411.32],[1182.17,411.32],[1182.96,411.32],[1183.75,412.1],[1184.53,412.1],[1185.32,412.89],[1186.11,414.46],[1186.89,419.18],[1187.68,419.18],[1188.47,419.18],[1189.26,419.18],[1190.04,419.97],[1190.83,419.97],[1191.62,420.76],[1192.4,421.54],[1193.19,427.05],[1193.98,427.05],[1194.77,427.05],[1195.55,427.83],[1196.34,427.83],[1197.13,427.83],[1197.91,428.62],[1198.7,428.62],[1199.49,429.41],[1200.27,430.19],[1201.06,435.7],[1201.85,435.7],[1202.64,435.7],[1203.42,435.7],[1204.21,436.48],[1205,436.48],[1205.78,437.27],[1206.57,437.27],[1207.36,438.06],[1208.15,444.35],[1208.93,444.35],[1209.72,444.35],[1210.51,444.35],[1211.29,445.14],[1212.08,445.14],[1212.87,445.14],[1213.65,445.92],[1214.44,445.92],[1215.23,446.71],[1216.02,447.49],[1216.8,448.28],[1216.8,449.3],[1216.02,468.18],[1215.23,487.84],[1214.44,520.08],[1213.65,521.66],[1212.87,522.44],[1212.08,523.23],[1211.29,523.23],[1210.51,524.02],[1209.72,524.02],[1208.93,524.02],[1208.15,524.8],[1207.36,524.8],[1206.57,524.8],[1205.78,524.8],[1205,525.59],[1204.21,525.59],[1203.42,525.59],[1202.64,525.59],[1201.85,525.59],[1201.06,525.59],[1200.27,525.59],[1199.49,525.59],[1198.7,525.59],[1197.91,525.59],[1197.13,525.59],[1196.34,525.59],[1195.55,525.59],[1194.77,525.59],[1193.98,525.59],[1193.19,525.59],[1192.4,525.59],[1191.62,525.59],[1190.83,525.59],[1190.04,525.59],[1189.26,525.59],[1188.47,525.59],[1187.68,525.59],[1186.89,525.59],[1186.11,525.59],[1185.32,524.8],[1184.53,524.8],[1183.75,524.8],[1182.96,524.8],[1182.17,524.8],[1181.38,524.02],[1180.6,524.02],[1179.81,524.02],[1179.02,523.23],[1178.24,523.23],[1177.45,523.23],[1176.66,522.44],[1175.88,522.44],[1175.09,521.66],[1174.3,520.87],[1173.51,522.44],[1172.73,523.23],[1171.94,523.23],[1171.15,524.02],[1170.37,524.02],[1169.58,524.8],[1168.79,524.8],[1168,524.8],[1167.22,524.8],[1166.43,525.59],[1165.64,525.59],[1164.86,525.59],[1164.07,525.59],[1163.28,525.59],[1162.5,525.59],[1161.71,525.59],[1160.92,525.59],[1160.13,525.59],[1159.35,525.59],[1158.56,526.38],[1157.77,526.38],[1156.99,526.38],[1156.2,526.38],[1155.41,526.38],[1154.62,526.38],[1153.84,526.38],[1153.05,526.38],[1152.26,525.59],[1151.48,525.59],[1150.69,525.59],[1149.9,525.59],[1149.12,525.59],[1148.33,525.59],[1147.54,525.59],[1146.75,524.8],[1145.97,524.8],[1145.18,524.8],[1144.39,524.8],[1143.61,524.8],[1142.82,524.8],[1142.03,524.02],[1141.24,524.02],[1140.46,524.02],[1139.67,523.23],[1138.88,523.23],[1138.1,523.23],[1137.31,522.44],[1136.52,521.66],[1135.74,521.66],[1134.95,521.66],[1134.16,522.44],[1133.37,523.23],[1132.59,524.02],[1131.8,524.02],[1131.01,524.8],[1130.23,524.8],[1129.44,524.8],[1128.65,524.8],[1127.86,525.59],[1127.08,525.59],[1126.29,525.59],[1125.5,525.59],[1124.72,525.59],[1123.93,525.59],[1123.14,525.59],[1122.36,525.59],[1121.57,525.59],[1120.78,526.38],[1119.99,526.38],[1119.21,526.38],[1118.42,526.38],[1117.63,526.38],[1116.85,526.38],[1116.06,526.38],[1115.27,526.38],[1114.48,526.38],[1113.7,526.38],[1112.91,525.59],[1112.12,525.59],[1111.34,525.59],[1110.55,525.59],[1109.76,525.59],[1108.97,525.59],[1108.19,525.59],[1107.4,524.8],[1106.61,524.8],[1105.83,524.8],[1105.04,524.8],[1104.25,524.8],[1103.47,524.02],[1102.68,524.02],[1101.89,524.02],[1101.1,523.23],[1100.32,523.23],[1099.53,522.44],[1098.74,522.44],[1097.96,521.66],[1097.17,521.66],[1096.38,522.44],[1095.59,523.23],[1094.81,524.02],[1094.02,524.02],[1093.23,524.02],[1092.45,524.8],[1091.66,524.8],[1090.87,524.8],[1090.09,524.8],[1089.3,525.59],[1088.51,525.59],[1087.72,525.59],[1086.94,525.59],[1086.15,525.59],[1085.36,525.59],[1084.58,525.59],[1083.79,525.59],[1083,525.59],[1082.21,526.38],[1081.43,526.38],[1080.64,526.38],[1079.85,526.38],[1079.07,526.38],[1078.28,526.38],[1077.49,526.38],[1076.71,526.38],[1075.92,525.59],[1075.13,525.59],[1074.34,525.59],[1073.56,525.59],[1072.77,525.59],[1071.98,525.59],[1071.2,525.59],[1070.41,525.59],[1069.62,524.8],[1068.83,524.8],[1068.05,524.8],[1067.26,524.8],[1066.47,524.02],[1065.69,524.02],[1064.9,524.02],[1064.11,523.23],[1063.33,523.23],[1062.54,522.44],[1061.75,522.44],[1060.96,521.66],[1060.18,521.66],[1059.39,522.44],[1058.6,523.23],[1057.82,524.02],[1057.03,524.02],[1056.24,524.8],[1055.45,524.8],[1054.67,524.8],[1053.88,524.8],[1053.09,525.59],[1052.31,525.59],[1051.52,525.59],[1050.73,525.59],[1049.95,525.59],[1049.16,525.59],[1048.37,525.59],[1047.58,525.59],[1046.8,526.38],[1046.01,526.38],[1045.22,526.38],[1044.44,526.38],[1043.65,526.38],[1042.86,526.38],[1042.07,526.38],[1041.29,526.38],[1040.5,526.38],[1039.71,526.38],[1038.93,526.38],[1038.14,525.59],[1037.35,525.59],[1036.56,525.59],[1035.78,525.59],[1034.99,525.59],[1034.2,525.59],[1033.42,525.59],[1032.63,524.8],[1031.84,524.8],[1031.06,524.8],[1030.27,524.8],[1029.48,524.02],[1028.69,524.02],[1027.91,523.23],[1027.12,523.23],[1026.33,522.44],[1025.55,521.66],[1024.76,520.87],[1023.97,521.66],[1023.18,522.44],[1022.4,523.23],[1021.61,524.02],[1020.82,524.02],[1020.04,524.02],[1019.25,524.8],[1018.46,524.8],[1017.68,524.8],[1016.89,524.8],[1016.1,525.59],[1015.31,525.59],[1014.53,525.59],[1013.74,525.59],[1012.95,525.59],[1012.17,525.59],[1011.38,525.59],[1010.59,525.59],[1009.8,525.59],[1009.02,526.38],[1008.23,526.38],[1007.44,526.38],[1006.66,526.38],[1005.87,526.38],[1005.08,526.38],[1004.3,526.38],[1003.51,526.38],[1002.72,525.59],[1001.93,525.59],[1001.15,525.59],[1000.36,525.59],[999.57,525.59],[998.79,525.59],[998,525.59],[997.21,525.59],[996.42,524.8],[995.64,524.8],[994.85,524.8],[994.06,524.8],[993.28,524.02],[992.49,524.02],[991.7,524.02],[990.92,524.02],[990.13,523.23],[989.34,523.23],[988.55,522.44],[987.77,521.66],[986.98,521.66],[986.19,522.44],[985.41,523.23],[984.62,523.23],[983.83,524.02],[983.04,524.02],[982.26,524.8],[981.47,524.8],[980.68,524.8],[979.9,524.8],[979.11,525.59],[978.32,525.59],[977.54,525.59],[976.75,525.59],[975.96,525.59],[975.17,525.59],[974.39,525.59],[973.6,526.38],[972.81,526.38],[972.03,526.38],[971.24,526.38],[970.45,526.38],[969.66,526.38],[968.88,526.38],[968.09,526.38],[967.3,526.38],[966.52,526.38],[965.73,526.38],[964.94,526.38],[964.15,526.38],[963.37,525.59],[962.58,525.59],[961.79,525.59],[961.01,525.59],[960.22,525.59],[959.43,525.59],[958.65,525.59],[957.86,524.8],[957.07,524.8],[956.28,524.8],[955.5,524.8],[954.71,524.02],[953.92,524.02],[953.14,524.02],[952.35,523.23],[951.56,522.44],[950.77,522.44],[949.99,521.66],[949.2,522.44],[948.41,523.23],[947.63,523.23],[946.84,524.02],[946.05,524.02],[945.27,524.8],[944.48,524.8],[943.69,524.8],[942.9,525.59],[942.12,525.59],[941.33,525.59],[940.54,525.59],[939.76,525.59],[938.97,525.59],[938.18,525.59],[937.39,525.59],[936.61,525.59],[935.82,526.38],[935.03,526.38],[934.25,526.38],[933.46,526.38],[932.67,526.38],[931.89,526.38],[931.1,526.38],[930.31,526.38],[929.52,526.38],[928.74,526.38],[927.95,526.38],[927.16,525.59],[926.38,525.59],[925.59,525.59],[924.8,525.59],[924.01,525.59],[923.23,525.59],[922.44,525.59],[921.65,524.8],[920.87,524.8],[920.08,524.8],[919.29,524.8],[918.51,524.02],[917.72,524.02],[916.93,524.02],[916.14,523.23],[915.36,523.23],[914.57,522.44],[913.78,521.66],[913,520.87],[912.21,521.66],[911.42,523.23],[910.63,524.02],[909.85,524.02],[909.06,524.02],[908.27,524.8],[907.49,524.8],[906.7,524.8],[905.91,524.8],[905.13,524.8],[904.34,525.59],[903.55,525.59],[902.76,525.59],[901.98,525.59],[901.19,525.59],[900.4,525.59],[899.62,525.59],[898.83,525.59],[898.04,526.38],[897.25,526.38],[896.47,526.38],[895.68,526.38],[894.89,526.38],[894.11,526.38],[893.32,526.38],[892.53,526.38],[891.74,525.59],[890.96,525.59],[890.17,525.59],[889.38,525.59],[888.6,525.59],[887.81,525.59],[887.02,525.59],[886.24,525.59],[885.45,525.59],[884.66,524.8],[883.87,524.8],[883.09,524.8],[882.3,524.8],[881.51,524.02],[880.73,524.02],[879.94,524.02],[879.15,523.23],[878.36,523.23],[877.58,522.44],[876.79,521.66],[876,521.66],[875.22,522.44],[874.43,523.23],[873.64,524.02],[872.86,524.02],[872.07,524.02],[871.28,524.8],[870.49,524.8],[869.71,524.8],[868.92,524.8],[868.13,525.59],[867.35,525.59],[866.56,525.59],[865.77,525.59],[864.98,525.59],[864.2,525.59],[863.41,525.59],[862.62,526.38],[861.84,526.38],[861.05,526.38],[860.26,526.38],[859.48,526.38],[858.69,526.38],[857.9,526.38],[857.11,526.38],[856.33,526.38],[855.54,526.38],[854.75,526.38],[853.97,526.38],[853.18,525.59],[852.39,525.59],[851.6,525.59],[850.82,525.59],[850.03,525.59],[849.24,525.59],[848.46,525.59],[847.67,525.59],[846.88,524.8],[846.1,524.8],[845.31,524.8],[844.52,524.02],[843.73,524.02],[842.95,524.02],[842.16,523.23],[841.37,523.23],[840.59,522.44],[839.8,521.66],[839.01,506.72],[838.22,522.44],[837.44,523.23],[836.65,524.02],[835.86,524.02],[835.08,524.02],[834.29,524.8],[833.5,524.8],[832.72,524.8],[831.93,524.8],[831.14,525.59],[830.35,525.59],[829.57,525.59],[828.78,525.59],[827.99,525.59],[827.21,525.59],[826.42,525.59],[825.63,526.38],[824.84,526.38],[824.06,526.38],[823.27,526.38],[822.48,526.38],[821.7,526.38],[820.91,526.38],[820.12,526.38],[819.33,526.38],[818.55,526.38],[817.76,526.38],[816.97,525.59],[816.19,525.59],[815.4,525.59],[814.61,525.59],[813.83,525.59],[813.04,525.59],[812.25,525.59],[811.46,525.59],[810.68,524.8],[809.89,524.8],[809.1,524.8],[808.32,524.8],[807.53,524.02],[806.74,524.02],[805.95,524.02],[805.17,523.23],[804.38,523.23],[803.59,522.44],[802.81,521.66],[802.02,520.87],[801.23,522.44],[800.45,523.23],[799.66,524.02],[798.87,524.02],[798.08,524.02],[797.3,524.8],[796.51,524.8],[795.72,524.8],[794.94,524.8],[794.15,525.59],[793.36,525.59],[792.57,525.59],[791.79,525.59],[791,525.59],[790.21,525.59],[789.43,526.38],[788.64,526.38],[787.85,526.38],[787.07,526.38],[786.28,526.38],[785.49,526.38],[784.7,526.38],[783.92,526.38],[783.13,526.38],[782.34,526.38],[781.56,526.38],[780.77,526.38],[779.98,526.38],[779.19,525.59],[778.41,525.59],[777.62,525.59],[776.83,525.59],[776.05,525.59],[775.26,525.59],[774.47,524.8],[773.69,524.8],[772.9,524.8],[772.11,524.8],[771.32,524.8],[770.54,524.02],[769.75,524.02],[768.96,524.02],[768.18,523.23],[767.39,522.44],[766.6,522.44],[765.81,520.87],[765.03,521.66],[764.24,522.44],[763.45,523.23],[762.67,524.02],[761.88,524.02],[761.09,524.8],[760.31,524.8],[759.52,524.8],[758.73,524.8],[757.94,524.8],[757.16,525.59],[756.37,525.59],[755.58,525.59],[754.8,525.59],[754.01,525.59],[753.22,525.59],[752.43,526.38],[751.65,526.38],[750.86,526.38],[750.07,526.38],[749.29,526.38],[748.5,526.38],[747.71,526.38],[746.92,526.38],[746.14,526.38],[745.35,526.38],[744.56,526.38],[743.78,526.38],[742.99,526.38],[742.2,526.38],[741.42,525.59],[740.63,525.59],[739.84,525.59],[739.05,525.59],[738.27,525.59],[737.48,525.59],[736.69,524.8],[735.91,524.8],[735.12,524.8],[734.33,524.8],[733.54,524.02],[732.76,524.02],[731.97,524.02],[731.18,523.23],[730.4,522.44],[729.61,522.44],[728.82,505.14],[728.04,521.66],[727.25,523.23],[726.46,523.23],[725.67,524.02],[724.89,524.02],[724.1,524.8],[723.31,524.8],[722.53,524.8],[721.74,524.8],[720.95,525.59],[720.16,525.59],[719.38,525.59],[718.59,525.59],[717.8,525.59],[717.02,525.59],[716.23,526.38],[715.44,526.38],[714.66,526.38],[713.87,526.38],[713.08,526.38],[712.29,526.38],[711.51,526.38],[710.72,526.38],[709.93,526.38],[709.15,526.38],[708.36,526.38],[707.57,526.38],[706.78,526.38],[706,525.59],[705.21,525.59],[704.42,525.59],[703.64,525.59],[702.85,525.59],[702.06,525.59],[701.28,524.8],[700.49,524.8],[699.7,524.8],[698.91,524.8],[698.13,524.02],[697.34,524.02],[696.55,523.23],[695.77,523.23],[694.98,522.44],[694.19,521.66],[693.4,521.66],[692.62,522.44],[691.83,523.23],[691.04,524.02],[690.26,524.02],[689.47,524.02],[688.68,524.8],[687.9,524.8],[687.11,524.8],[686.32,525.59],[685.53,525.59],[684.75,525.59],[683.96,525.59],[683.17,525.59],[682.39,525.59],[681.6,526.38],[680.81,526.38],[680.02,526.38],[679.24,526.38],[678.45,526.38],[677.66,526.38],[676.88,526.38],[676.09,526.38],[675.3,526.38],[674.51,526.38],[673.73,526.38],[672.94,526.38],[672.15,526.38],[671.37,526.38],[670.58,525.59],[669.79,525.59],[669.01,525.59],[668.22,525.59],[667.43,525.59],[666.64,524.8],[665.86,524.8],[665.07,524.8],[664.28,524.8],[663.5,524.02],[662.71,524.02],[661.92,524.02],[661.13,523.23],[660.35,522.44],[659.56,520.87],[658.77,521.66],[657.99,522.44],[657.2,523.23],[656.41,524.02],[655.63,524.02],[654.84,524.02],[654.05,524.8],[653.26,524.8],[652.48,524.8],[651.69,524.8],[650.9,525.59],[650.12,525.59],[649.33,525.59],[648.54,525.59],[647.75,525.59],[646.97,525.59],[646.18,525.59],[645.39,526.38],[644.61,526.38],[643.82,526.38],[643.03,526.38],[642.25,526.38],[641.46,526.38],[640.67,526.38],[639.88,526.38],[639.1,526.38],[638.31,526.38],[637.52,526.38],[636.74,526.38],[635.95,525.59],[635.16,525.59],[634.37,525.59],[633.59,525.59],[632.8,525.59],[632.01,525.59],[631.23,525.59],[630.44,524.8],[629.65,524.8],[628.87,524.8],[628.08,524.8],[627.29,524.02],[626.5,524.02],[625.72,523.23],[624.93,523.23],[624.14,522.44],[623.36,520.87],[622.57,521.66],[621.78,522.44],[620.99,523.23],[620.21,524.02],[619.42,524.02],[618.63,524.02],[617.85,524.8],[617.06,524.8],[616.27,524.8],[615.49,524.8],[614.7,525.59],[613.91,525.59],[613.12,525.59],[612.34,525.59],[611.55,525.59],[610.76,525.59],[609.98,525.59],[609.19,526.38],[608.4,526.38],[607.61,526.38],[606.83,526.38],[606.04,526.38],[605.25,526.38],[604.47,526.38],[603.68,526.38],[602.89,526.38],[602.1,526.38],[601.32,526.38],[600.53,526.38],[599.74,525.59],[598.96,525.59],[598.17,525.59],[597.38,525.59],[596.6,525.59],[595.81,525.59],[595.02,525.59],[594.23,524.8],[593.45,524.8],[592.66,524.8],[591.87,524.8],[591.09,524.02],[590.3,524.02],[589.51,523.23],[588.72,523.23],[587.94,522.44],[587.15,514.58],[586.36,521.66],[585.58,522.44],[584.79,523.23],[584,523.23],[583.22,524.02],[582.43,524.02],[581.64,524.02],[580.85,524.8],[580.07,524.8],[579.28,524.8],[578.49,524.8],[577.71,525.59],[576.92,525.59],[576.13,525.59],[575.34,525.59],[574.56,525.59],[573.77,525.59],[572.98,525.59],[572.2,526.38],[571.41,526.38],[570.62,526.38],[569.84,526.38],[569.05,526.38],[568.26,526.38],[567.47,526.38],[566.69,526.38],[565.9,526.38],[565.11,526.38],[564.33,526.38],[563.54,525.59],[562.75,525.59],[561.96,525.59],[561.18,525.59],[560.39,525.59],[559.6,525.59],[558.82,525.59],[558.03,525.59],[557.24,525.59],[556.46,524.8],[555.67,524.8],[554.88,524.8],[554.09,524.8],[553.31,524.02],[552.52,524.02],[551.73,523.23],[550.95,522.44],[550.16,520.87],[549.37,521.66],[548.58,522.44],[547.8,522.44],[547.01,523.23],[546.22,524.02],[545.44,524.02],[544.65,524.8],[543.86,524.8],[543.08,524.8],[542.29,524.8],[541.5,524.8],[540.71,525.59],[539.93,525.59],[539.14,525.59],[538.35,525.59],[537.57,525.59],[536.78,525.59],[535.99,525.59],[535.2,526.38],[534.42,526.38],[533.63,526.38],[532.84,526.38],[532.06,526.38],[531.27,526.38],[530.48,526.38],[529.69,526.38],[528.91,526.38],[528.12,526.38],[527.33,526.38],[526.55,526.38],[525.76,526.38],[524.97,526.38],[524.19,525.59],[523.4,525.59],[522.61,525.59],[521.82,525.59],[521.04,525.59],[520.25,525.59],[519.46,524.8],[518.68,524.8],[517.89,524.8],[517.1,524.8],[516.31,524.02],[515.53,524.02],[514.74,523.23],[513.95,522.44],[513.17,520.87],[512.38,520.87],[511.59,521.66],[510.81,522.44],[510.02,523.23],[509.23,524.02],[508.44,524.02],[507.66,524.02],[506.87,524.8],[506.08,524.8],[505.3,524.8],[504.51,524.8],[503.72,524.8],[502.93,525.59],[502.15,525.59],[501.36,525.59],[500.57,525.59],[499.79,525.59],[499,525.59],[498.21,525.59],[497.43,526.38],[496.64,526.38],[495.85,526.38],[495.06,526.38],[494.28,526.38],[493.49,526.38],[492.7,526.38],[491.92,526.38],[491.13,526.38],[490.34,526.38],[489.55,526.38],[488.77,526.38],[487.98,525.59],[487.19,525.59],[486.41,525.59],[485.62,525.59],[484.83,525.59],[484.05,525.59],[483.26,525.59],[482.47,524.8],[481.68,524.8],[480.9,524.8],[480.11,524.8],[479.32,524.02],[478.54,524.02],[477.75,523.23],[476.96,523.23],[476.17,521.66],[475.39,515.37],[474.6,521.66],[473.81,522.44],[473.03,523.23],[472.24,523.23],[471.45,524.02],[470.67,524.02],[469.88,524.02],[469.09,524.8],[468.3,524.8],[467.52,524.8],[466.73,524.8],[465.94,525.59],[465.16,525.59],[464.37,525.59],[463.58,525.59],[462.79,525.59],[462.01,525.59],[461.22,525.59],[460.43,526.38],[459.65,526.38],[458.86,526.38],[458.07,526.38],[457.28,526.38],[456.5,526.38],[455.71,526.38],[454.92,526.38],[454.14,526.38],[453.35,526.38],[452.56,526.38],[451.78,526.38],[450.99,526.38],[450.2,526.38],[449.41,525.59],[448.63,525.59],[447.84,525.59],[447.05,525.59],[446.27,525.59],[445.48,525.59],[444.69,525.59],[443.9,524.8],[443.12,524.8],[442.33,524.8],[441.54,524.02],[440.76,524.02],[439.97,524.02],[439.18,523.23],[438.4,523.23],[437.61,521.66],[436.82,521.66],[436.03,521.66],[435.25,522.44],[434.46,523.23],[433.67,523.23],[432.89,524.02],[432.1,524.02],[431.31,524.02],[430.52,524.8],[429.74,524.8],[428.95,524.8],[428.16,524.8],[427.38,525.59],[426.59,525.59],[425.8,525.59],[425.02,525.59],[424.23,525.59],[423.44,525.59],[422.65,525.59],[421.87,525.59],[421.08,525.59],[420.29,525.59],[419.51,526.38],[418.72,526.38],[417.93,526.38],[417.14,526.38],[416.36,526.38],[415.57,526.38],[414.78,526.38],[414,526.38],[413.21,526.38],[412.42,525.59],[411.64,525.59],[410.85,525.59],[410.06,525.59],[409.27,525.59],[408.49,525.59],[407.7,525.59],[406.91,525.59],[406.13,524.8],[405.34,524.8],[404.55,524.8],[403.76,524.8],[402.98,524.02],[402.19,524.02],[401.4,524.02],[400.62,523.23],[399.83,522.44],[399.04,516.94],[398.26,520.87],[397.47,521.66],[396.68,522.44],[395.89,523.23],[395.11,523.23],[394.32,524.02],[393.53,524.02],[392.75,524.02],[391.96,524.8],[391.17,524.8],[390.38,524.8],[389.6,524.8],[388.81,524.8],[388.02,525.59],[387.24,525.59],[386.45,525.59],[385.66,525.59],[384.87,525.59],[384.09,525.59],[383.3,525.59],[382.51,525.59],[381.73,526.38],[380.94,526.38],[380.15,526.38],[379.37,526.38],[378.58,526.38],[377.79,526.38],[377,526.38],[376.22,526.38],[375.43,526.38],[374.64,526.38],[373.86,526.38],[373.07,526.38],[372.28,526.38],[371.49,525.59],[370.71,525.59],[369.92,525.59],[369.13,525.59],[368.35,525.59],[367.56,525.59],[366.77,525.59],[365.99,524.8],[365.2,524.8],[364.41,524.8],[363.62,524.02],[362.84,524.02],[362.05,523.23],[361.26,522.44],[360.48,521.66],[359.69,521.66],[358.9,522.44],[358.11,523.23],[357.33,523.23],[356.54,524.02],[355.75,524.02],[354.97,524.02],[354.18,524.02],[353.39,524.8],[352.61,524.8],[351.82,524.8],[351.03,524.8],[350.24,524.8],[349.46,525.59],[348.67,525.59],[347.88,525.59],[347.1,525.59],[346.31,525.59],[345.52,525.59],[344.73,526.38],[343.95,526.38],[343.16,526.38],[342.37,526.38],[341.59,526.38],[340.8,526.38],[340.01,526.38],[339.23,526.38],[338.44,526.38],[337.65,526.38],[336.86,526.38],[336.08,526.38],[335.29,525.59],[334.5,525.59],[333.72,525.59],[332.93,525.59],[332.14,525.59],[331.35,525.59],[330.57,525.59],[329.78,525.59],[328.99,524.8],[328.21,524.8],[327.42,524.8],[326.63,524.8],[325.85,524.02],[325.06,524.02],[324.27,523.23],[323.48,521.66],[322.7,520.87],[321.91,521.66],[321.12,522.44],[320.34,523.23],[319.55,523.23],[318.76,524.02],[317.97,524.02],[317.19,524.02],[316.4,524.8],[315.61,524.8],[314.83,524.8],[314.04,524.8],[313.25,524.8],[312.46,525.59],[311.68,525.59],[310.89,525.59],[310.1,525.59],[309.32,525.59],[308.53,525.59],[307.74,526.38],[306.96,526.38],[306.17,526.38],[305.38,526.38],[304.59,526.38],[303.81,526.38],[303.02,526.38],[302.23,526.38],[301.45,526.38],[300.66,526.38],[299.87,526.38],[299.08,526.38],[298.3,525.59],[297.51,525.59],[296.72,525.59],[295.94,525.59],[295.15,525.59],[294.36,525.59],[293.58,525.59],[292.79,525.59],[292,524.8],[291.21,524.8],[290.43,524.8],[289.64,524.8],[288.85,524.02],[288.07,524.02],[287.28,523.23],[286.49,522.44],[285.7,517.73],[284.92,521.66],[284.13,522.44],[283.34,522.44],[282.56,523.23],[281.77,523.23],[280.98,524.02],[280.2,524.02],[279.41,524.02],[278.62,524.8],[277.83,524.8],[277.05,524.8],[276.26,524.8],[275.47,524.8],[274.69,524.8],[273.9,525.59],[273.11,525.59],[272.32,525.59],[271.54,525.59],[270.75,525.59],[269.96,525.59],[269.18,526.38],[268.39,526.38],[267.6,526.38],[266.82,526.38],[266.03,526.38],[265.24,526.38],[264.45,526.38],[263.67,526.38],[262.88,526.38],[262.09,526.38],[261.31,526.38],[260.52,526.38],[259.73,525.59],[258.94,525.59],[258.16,525.59],[257.37,525.59],[256.58,525.59],[255.8,525.59],[255.01,525.59],[254.22,525.59],[253.44,524.8],[252.65,524.8],[251.86,524.8],[251.07,524.8],[250.29,524.02],[249.5,524.02],[248.71,523.23],[247.93,515.37],[247.14,520.87],[246.35,522.44],[245.56,522.44],[244.78,523.23],[243.99,523.23],[243.2,524.02],[242.42,524.02],[241.63,524.02],[240.84,524.8],[240.05,524.8],[239.27,524.8],[238.48,524.8],[237.69,524.8],[236.91,524.8],[236.12,525.59],[235.33,525.59],[234.55,525.59],[233.76,525.59],[232.97,525.59],[232.18,525.59],[231.4,526.38],[230.61,526.38],[229.82,526.38],[229.04,526.38],[228.25,526.38],[227.46,526.38],[226.67,526.38],[225.89,526.38],[225.1,526.38],[224.31,526.38],[223.53,526.38],[222.74,526.38],[221.95,526.38],[221.17,526.38],[220.38,525.59],[219.59,525.59],[218.8,525.59],[218.02,525.59],[217.23,525.59],[216.44,525.59],[215.66,525.59],[214.87,524.8],[214.08,524.8],[213.29,524.8],[212.51,524.02],[211.72,524.02],[210.93,523.23],[210.15,522.44],[209.36,520.87],[208.57,521.66],[207.79,521.66],[207,522.44],[206.21,522.44],[205.42,523.23],[204.64,523.23],[203.85,524.02],[203.06,524.02],[202.28,524.02],[201.49,524.8],[200.7,524.8],[199.91,524.8],[199.13,524.8],[198.34,524.8],[197.55,525.59],[196.77,525.59],[195.98,525.59],[195.19,525.59],[194.41,525.59],[193.62,525.59],[192.83,525.59],[192.04,526.38],[191.26,526.38],[190.47,526.38],[189.68,526.38],[188.9,526.38],[188.11,526.38],[187.32,526.38],[186.53,526.38],[185.75,526.38],[184.96,526.38],[184.17,526.38],[183.39,526.38],[182.6,526.38],[181.81,526.38],[181.03,525.59],[180.24,525.59],[179.45,525.59],[178.66,525.59],[177.88,525.59],[177.09,525.59],[176.3,525.59],[175.52,524.8],[174.73,524.8],[173.94,524.8],[173.15,524.8],[172.37,524.02],[171.58,524.02],[170.79,523.23],[170.01,522.44],[169.22,521.66],[168.43,521.66],[167.64,522.44],[166.86,523.23],[166.07,523.23],[165.28,523.23],[164.5,524.02],[163.71,524.02],[162.92,524.02],[162.14,524.8],[161.35,524.8],[160.56,524.8],[159.77,524.8],[158.99,524.8],[158.2,525.59],[157.41,525.59],[156.63,525.59],[155.84,525.59],[155.05,525.59],[154.26,525.59],[153.48,525.59],[152.69,526.38],[151.9,526.38],[151.12,526.38],[150.33,526.38],[149.54,526.38],[148.76,526.38],[147.97,526.38],[147.18,526.38],[146.39,526.38],[145.61,526.38],[144.82,526.38],[144.03,526.38],[143.25,526.38],[142.46,526.38],[141.67,526.38],[140.88,526.38],[140.1,526.38],[139.31,525.59],[138.52,525.59],[137.74,525.59],[136.95,525.59],[136.16,525.59],[135.38,525.59],[134.59,524.8],[133.8,524.8],[133.01,524.8],[132.23,524.02],[131.44,524.02],[130.65,523.23],[129.87,521.66],[129.08,521.66],[128.29,522.44],[127.5,522.44],[126.72,523.23],[125.93,523.23],[125.14,524.02],[124.36,524.02],[123.57,524.02],[122.78,524.02],[122,524.8],[121.21,524.8],[120.42,524.8],[119.63,524.8],[118.85,524.8],[118.06,525.59],[117.27,525.59],[116.49,525.59],[115.7,525.59],[114.91,525.59],[114.12,525.59],[113.34,525.59],[112.55,525.59],[111.76,526.38],[110.98,526.38],[110.19,526.38],[109.4,526.38],[108.62,526.38],[107.83,526.38],[107.04,526.38],[106.25,526.38],[105.47,526.38],[104.68,526.38],[103.89,526.38],[103.11,526.38],[102.32,526.38],[101.53,526.38],[100.74,526.38],[99.96,526.38],[99.17,525.59],[98.38,525.59],[97.6,525.59],[96.81,525.59],[96.02,525.59],[95.23,525.59],[94.45,524.8],[93.66,524.8],[92.87,524.8],[92.09,524.02],[91.3,524.02],[90.51,523.23],[89.73,520.87],[88.94,521.66],[88.15,522.44],[87.36,522.44],[86.58,523.23],[85.79,523.23],[85,524.02],[84.22,524.02],[83.43,524.02],[82.64,524.02],[81.85,524.8],[81.07,524.8],[80.28,524.8],[79.49,524.8],[78.71,524.8],[77.92,524.8],[77.13,525.59],[76.35,525.59],[75.56,525.59],[74.77,525.59],[73.98,525.59],[73.2,525.59],[72.41,525.59],[71.62,526.38],[70.84,526.38],[70.05,526.38],[69.26,526.38],[68.47,526.38],[67.69,526.38],[66.9,526.38],[66.11,526.38],[65.33,526.38],[64.54,526.38],[63.75,526.38],[62.97,526.38],[62.18,526.38],[61.39,526.38],[60.6,526.38],[59.82,526.38],[59.03,525.59],[58.24,525.59],[57.46,525.59],[56.67,525.59],[55.88,525.59],[55.09,525.59],[54.31,524.8],[53.52,524.8],[52.73,524.8],[51.95,524.02],[51.16,524.02],[50.37,523.23],[49.59,522.44],[48.8,521.66],[48.01,506.72],[47.22,488.63],[46.44,470.54],[45.65,468.18],[44.86,450.09]]};

// Client revision: both constructions now include two nested encasements.
MAT.edge='Reinforced pocket springs';MAT.foundationFoam='Aerated foam';
const CLIENT_COPY={"firm": [{"title": "BlissBreathe™ Bamboo Cover", "benefit": "Cooling, Antibacterial & Hypoallergenic", "desc": "A luxuriously soft 400 GSM knitted bamboo cover, chosen for its premium weight, breathability and exceptionally smooth feel against the skin. Naturally cool to the touch, its moisture-managing properties help disperse warmth and humidity, creating a fresher, drier sleep environment. Naturally antibacterial and hypoallergenic, it helps maintain a cleaner, more comfortable sleep surface—ideal for sensitive sleepers. Its substantial 400 GSM construction delivers a noticeably more luxurious, high-end feel while remaining beautifully soft and breathable. While other brands won’t share their GSM, we confidently will!"}, {"title": "BlissNest™ Quilted Comfort Layer", "benefit": "Immediate Comfort with a Supportive Feel", "desc": "A gently cushioned quilted layer designed to provide immediate comfort from the moment you lie down. It softens initial contact with the mattress and relieves pressure around sensitive areas such as the shoulders and hips, without creating an overly plush or deeply sunken feeling. Carefully quilted to keep its cushioning evenly distributed, BlissNest™ provides surface comfort while allowing the orthopaedic support system beneath to hold your body securely. It creates the perfect balance of welcoming comfort and responsive support, giving the Medium Firm mattress a refined, premium feel without compromising its stronger supportive character."}, {"title": "RippleFlex™ Response Foam", "benefit": "Extra-Thick Responsive Comfort & Airflow", "desc": "An extra-thick, specially profiled response foam that compresses and recovers quickly as you change sleeping positions. Unlike mattresses that rely on a thin token layer of foam, RippleFlex™ provides substantial cushioning and support without the slow, deeply sunken feeling of traditional memory foam. Its ripple-shaped surface creates airflow channels through the comfort system, helping warmth move away from the body. By cushioning pressure points, controlling movement and working with the orthopaedic spring system beneath, it creates a cooler, more responsive sleep surface that remains comfortably supportive throughout the night."}, {"title": "BalanceCore™ Support Foam", "benefit": "Extra-Thick Orthopaedic Support & Alignment", "desc": "A generously thick support foam that forms the essential structural bridge between RippleFlex™ and the pocket-spring system beneath. Rather than using a thin transitional layer, BalanceCore™ provides a substantial level of support that distributes body weight more evenly and helps prevent excessive sinking. It reinforces heavier areas such as the hips and torso, helping maintain a naturally aligned sleeping position throughout the night. Working together with the seven-zone spring system, this premium foam strengthens the mattress’s overall orthopaedic performance—delivering controlled cushioning, greater stability and the dependable support expected from a high-quality Medium Firm mattress."}, {"title": "CottonLock™ Upper Stabilising Layer", "benefit": "Orthopaedic Load Distribution & Durability", "desc": "A dense cotton-felt stabilising layer positioned directly above the pocket springs to strengthen and protect the mattress internally. CottonLock™ spreads pressure more evenly across the seven-zone spring system, allowing its targeted orthopaedic support to be transferred smoothly through the substantial foam layers above. It also helps prevent individual coils from pressing directly into the premium foams, reducing unnecessary internal wear over time. Strong, durable and naturally breathable, this protective barrier helps every support zone perform consistently while preserving the mattress’s shape, stability and supportive Medium Firm character throughout years of regular use."}, {"title": "BodySync 7™ FirmTune Pocket-Spring Core", "benefit": "Seven Zones of Targeted Orthopaedic Support", "desc": "The primary orthopaedic support system at the heart of our Medium Firm mattress. The difference extends beyond the comfort foams above: FirmTune uses a deliberately stronger spring system that provides greater resistance and a more stable, lifted feeling than the softer SoftTune core inside our Medium Soft mattress. Individually pocketed springs are arranged across seven targeted zones supporting the head and neck, shoulders, lower back, hips, thighs, knees and feet. More responsive areas comfortably accommodate the shoulders, while stronger support through the lumbar and hip regions helps prevent excessive sinking and maintain natural spinal alignment. Each spring moves independently to closely follow your body and minimise partner disturbance—delivering precise orthopaedic support without feeling uncomfortably rigid."}, {"title": "Reinforced Pocket-Spring Encasement", "benefit": "Edge-to-Edge Orthopaedic Support", "desc": "A reinforced perimeter of stronger, higher-density pocket springs surrounds the BodySync 7™ orthopaedic support system on all four sides. This strengthened encasement helps prevent the mattress edges from collapsing or sagging when you sit down, get out of bed or sleep closer to the side. By continuing dependable support across the mattress perimeter, it reduces the sensation of rolling off and allows you to comfortably use more of the total sleeping surface. Unlike basic foam edging, the individually pocketed perimeter springs remain supportive, responsive and breathable while working seamlessly with the seven-zone spring core inside."}, {"title": "CottonLock™ Lower Stabilising Layer", "benefit": "Core Stability & Consistent Orthopaedic Performance", "desc": "A second dense cotton-felt layer positioned beneath the pocket springs to secure, stabilise and protect the entire orthopaedic support system from below. CottonLock™ helps keep the spring core correctly positioned, ensuring all seven targeted zones remain properly aligned as the mattress responds to your body and changing sleeping positions. It also creates a protective barrier between the springs and foundation, helping minimise friction, vibration and unnecessary noise. By supporting the pocket springs from underneath while allowing them to continue moving independently, this layer contributes to quieter movement, lasting stability and consistently reliable orthopaedic support."}, {"title": "Aerated Foam Encasement", "benefit": "Cushioned Side Comfort & Heat Release", "desc": "A protective foam layer positioned beneath the quilted exterior, creating a softer, more premium feel around the sides of the mattress. It cushions the direct feel of the pocket-spring structure without disguising the strong, supportive construction underneath. Specially aerated throughout, the foam provides additional pathways for warm air to move outward and escape through the mattress sides, supporting a cooler and more breathable sleep environment. It also forms a protective buffer around the internal spring system, adding refinement, cushioning and durability while giving the Bamboo Bliss a smoother, higher-quality finish from every angle."}, {"title": "BaseGuard™ Quilted Foundation", "benefit": "Premium Protection, Strength & Finishing", "desc": "Durable quilted panels wrap around the sides and underside of the mattress, protecting its substantial internal construction while giving the Bamboo Bliss its distinctive luxury finish. The carefully stitched exterior adds strength and structure around the perimeter, helping the mattress retain its shape through regular use, movement and handling. Underneath, BaseGuard™ helps shield the internal components from friction, abrasion and everyday contact with the bed base. Lightly padded and finished with elegant detailing and SleepyCo branding, it creates a clean, refined exterior that looks premium from every angle while helping preserve the mattress’s long-term structure and performance."}]};
for(const [name,v] of Object.entries(DATA)){
 const g=GEO[name],core=v.layers.findIndex(l=>l.mat==='spring');
 v.layers.splice(core+1,0,{short:'Reinforced Spring Encasement',mat:'edge',dim:''});
 g.bounds.splice(core+1,0,g.bounds[core].map(p=>p.slice()));g.rest.splice(core+1,0,0);
 const base=v.layers.length-1;
 v.layers.splice(base,0,{short:'Aerated Foam Encasement',mat:'foundationFoam',dim:''});
 g.bounds.splice(base,0,[[140,600],[1119,600],[g.basePhoto.right-12,640],[g.basePhoto.right-12,g.basePhoto.bottom-8],[g.basePhoto.left+12,g.basePhoto.bottom-8],[g.basePhoto.left+12,640]]);
 g.rest.splice(base,0,0);
 // BaseGuard is an exterior shell; the foam liner fits inside it.
 g.bounds[base+1]=[[128,600],[1131,600],[g.basePhoto.right,641],[g.basePhoto.right,g.basePhoto.bottom],[g.basePhoto.left,g.basePhoto.bottom],[g.basePhoto.left,641]];
 v.layers.forEach((l,i)=>Object.assign(l,CLIENT_COPY[name][i]));
 Object.assign(v.layers[0],{dim:'Premium 400 GSM Knitted Bamboo',hideMaterial:true});
 v.core=core;v.edge=core+1;v.foam=base;v.base=base+1;v.mainLayers=name==='firm'?8:9;
}
const WIDTH=1290,HEIGHT=885,TOP=150;
let selected=0;
let expanded=false;
let renderNodes=null,copyFrame=0,copyFrame2=0,renderVersion=0;
const setAttr=(el,name,value)=>{if(el.getAttribute(name)!==value)el.setAttribute(name,value);};
const setStyle=(el,name,value)=>{if(el.style[name]!==value)el.style[name]=value;};
const stage=root.querySelector('[data-stage]'),nav=root.querySelector('[data-nav]');
const svgNS='http://www.w3.org/2000/svg';
function svgEl(name,attrs={}){const e=document.createElementNS(svgNS,name);for(const [k,v]of Object.entries(attrs))e.setAttribute(k,v);return e;}
const FRONT={firm:[124,191,266,333,399,450,450,561,640,641],soft:[124,192,245,306,368,435,474,474,574,640,641]};
const springRow=()=>variant==='firm'?{backL:120,backR:1155,frontL:44,frontR:1215,top:410,front:450,bottom:534}:{backL:91,backR:1184,frontL:40,frontR:1227,top:447,front:474,bottom:544};
function build(){
 stage.replaceChildren();nav.replaceChildren();
 nav.setAttribute('aria-label','Choose a mattress component');
 const v=DATA[variant],layers=v.layers,geo=GEO[variant],row=springRow();
 const svg=svgEl('svg',{viewBox:`0 0 ${WIDTH} ${HEIGHT}`,'aria-hidden':'true'}),defs=svgEl('defs');svg.append(defs);
 defs.append(svgEl('image',{id:ns('photograph'),href:IMAGES[variant],width:WIDTH,height:755,preserveAspectRatio:'none'}));
 defs.append(svgEl('image',{id:ns('base-reference'),href:BASE_REFERENCE,width:1000,height:667}));
 for(const [id,values] of [['white-pocket-cloth','0 0 .74 0 .30  0 0 .74 0 .30  0 0 .74 0 .30  0 0 0 1 0'],['navy-pocket-cloth','0 0 .13 0 .012  0 0 .20 0 .02  0 0 .32 0 .035  0 0 0 1 0']]){
  const f=svgEl('filter',{id:ns(id),x:0,y:0,width:'100%',height:'100%','color-interpolation-filters':'sRGB'});
  f.append(svgEl('feColorMatrix',{type:'matrix',values}));defs.append(f);
 }
 function clip(id,child){const c=svgEl('clipPath',{id:ns(id)});c.append(child);defs.append(c);return `url(#${ns(id)})`;}
 const polygon=points=>svgEl('polygon',{points:points.map(p=>p.join(',')).join(' ')});
 const photo=()=>svgEl('use',{href:'#'+ns('photograph')});
 const springClip=clip('spring-outline',polygon(SPRING_CONTOURS[variant]));
 const whiteZones=svgEl('clipPath',{id:ns('white-spring-zones')});
 const boundaries=variant==='firm'?[44,208,397,549,728,876,1060,1215]:[40,207,362,552,734,883,1072,1227];
 for(const zone of [1,3,5]){
  const a=(boundaries[zone]-row.frontL)/(row.frontR-row.frontL),b=(boundaries[zone+1]-row.frontL)/(row.frontR-row.frontL);
  const bl=row.backL+(row.backR-row.backL)*a,br=row.backL+(row.backR-row.backL)*b;
  whiteZones.append(polygon([[bl,row.top],[br,row.top],[boundaries[zone+1],row.front],[boundaries[zone+1],row.bottom],[boundaries[zone],row.bottom],[boundaries[zone],row.front]]));
 }defs.append(whiteZones);
 const left=geo.basePhoto.left,right=geo.basePhoto.right;
 // All joined faces share these rounded plan-view contours.
 function roundedPlan(bl,br,fl,fr,back,front,r=16,ry=5){
  return `M${bl+r} ${back} H${br-r} Q${br} ${back} ${br+r*.45} ${back+ry} L${fr-r*.45} ${front-ry} Q${fr} ${front} ${fr-r} ${front} H${fl+r} Q${fl} ${front} ${fl+r*.45} ${front-ry} L${bl-r*.45} ${back+ry} Q${bl} ${back} ${bl+r} ${back} Z`;
 }
 // The surround and core use the same photographic texture and perspective.
 const openingTop=row.top+(row.front-row.top)*.2,innerBackL=row.backL+39,innerBackR=row.backR-41,innerFrontL=row.frontL+36,innerFrontR=row.frontR-37;
 const ring=svgEl('mask',{id:ns('spring-ring'),maskUnits:'userSpaceOnUse',x:0,y:0,width:WIDTH,height:755});
 const openingFront=row.front-(row.front-row.top)*.12;
 const springOpening=roundedPlan(innerBackL,innerBackR,innerFrontL,innerFrontR,openingTop,openingFront,12,3);
 ring.append(svgEl('rect',{width:WIDTH,height:755,fill:'white'}),svgEl('path',{d:springOpening,fill:'black',stroke:'white','stroke-width':'.8'}));defs.append(ring);
 const springInnerClip=clip('spring-inner-wall',svgEl('path',{d:springOpening}));
 // Round the outer turn so the side rows meet the front without jagged steps.
 const smoothOutline=clip('spring-rounded-turn',svgEl('path',{d:`M${row.backL+16} ${row.top} H${row.backR-16} Q${row.backR} ${row.top} ${row.backR+8} ${row.top+5} L${row.frontR-7} ${row.front-7} Q${row.frontR} ${row.front-2} ${row.frontR} ${row.front+8} V${row.bottom-9} Q${row.frontR} ${row.bottom} ${row.frontR-14} ${row.bottom} H${row.frontL+14} Q${row.frontL} ${row.bottom} ${row.frontL} ${row.bottom-9} V${row.front+8} Q${row.frontL} ${row.front-2} ${row.frontL+7} ${row.front-7} L${row.backL-8} ${row.top+5} Q${row.backL} ${row.top} ${row.backL+16} ${row.top} Z`}));
 // All rear and top-side surfaces belong behind the coloured core.
 // Only the near vertical row can occlude it. Splitting at openingTop instead
 // painted the left corner and the opening's horizontal border over the core.
 const rearClip=clip('spring-rear',svgEl('rect',{x:0,y:row.top-1,width:WIDTH,height:row.front-row.top+1}));
 const frontClip=clip('spring-front',svgEl('rect',{x:0,y:row.front-.4,width:WIDTH,height:row.bottom-row.front+1.4}));
 function align(group,a,b,inset=0){
  const sx=(right-left-2*inset)/(b-a),wrap=svgEl('g',{transform:`translate(${left+inset-a*sx} 0) scale(${sx} 1)`});
  while(group.firstChild)wrap.append(group.firstChild);group.append(wrap);
 }
 function perimeter(part){
  const group=svgEl('g',{'class':'slice','data-index':v.edge,'data-part':part});
  const cut=svgEl('g',{'clip-path':part==='rear'?rearClip:frontClip});
  const silhouette=svgEl('g');
  const cloth=svgEl('g',{mask:`url(#${ns('spring-ring')})`,filter:`url(#${ns('navy-pocket-cloth')})`});cloth.append(photo());silhouette.append(cloth);
  const rounded=svgEl('g',{'clip-path':smoothOutline});rounded.append(silhouette);cut.append(rounded);
  const lining=svgEl('g',{'clip-path':springInnerClip,'class':'spring-inner-lining'});
  lining.style.transition='opacity 180ms ease';
  lining.append(svgEl('path',{d:springOpening+' '+roundedPlan(innerBackL,innerBackR,innerFrontL,innerFrontR,openingTop+6,openingFront+6,12,3),'fill-rule':'evenodd',fill:'#172d45'}));
  cut.append(lining);group.append(cut);align(group,row.frontL,row.frontR);return group;
 }
 for(let i=layers.length-1;i>=0;i--){
  const material=layers[i].mat,group=svgEl('g',{'class':'slice','data-index':i,'data-material':material});
  if(material==='edge')continue;
  if(material==='spring'){
   const cut=svgEl('g',{'clip-path':springClip});cut.append(photo());
   const zones=svgEl('g',{'clip-path':`url(#${ns('white-spring-zones')})`}),white=photo();white.setAttribute('filter',`url(#${ns('white-pocket-cloth')})`);zones.append(white);cut.append(zones);
   // Remove the sub-pixel white cutout fringe where the original cloth meets navy.
   const trim=svgEl('filter',{id:ns('core-edge-trim'),x:'-1%',y:'-1%',width:'102%',height:'102%'});
   trim.append(svgEl('feMorphology',{in:'SourceAlpha',operator:'erode',radius:'.7',result:'cleanAlpha'}),svgEl('feComposite',{in:'SourceGraphic',in2:'cleanAlpha',operator:'in'}));defs.append(trim);
   const clean=svgEl('g',{filter:`url(#${ns('core-edge-trim')})`});clean.append(cut);group.append(clean);
   align(group,row.frontL,row.frontR,24);
  }else if(material==='foundationFoam'){
   // Full four-sided aerated liner. The opening makes its enclosing shape explicit.
   const top=600,front=640,bottom=geo.basePhoto.bottom-8,fl=left+12,fr=right-12;
   clip('nested-foam-visible-edge',svgEl('rect',{x:left,y:front-2,width:right-left,height:bottom-front+3}));
   const gradient=svgEl('linearGradient',{id:ns('foam-face'),x1:'0%',y1:'0%',x2:'0%',y2:'100%'});
   gradient.append(svgEl('stop',{offset:0,'stop-color':'#e7decc'}),svgEl('stop',{offset:1,'stop-color':'#cfbea0'}));defs.append(gradient);
   // Parallel inset edges in the same perspective as the outer shell.
   const centre=(fl+fr)/2,backLeft=centre-489.5,backRight=centre+489.5;
   const innerBack=top+10,innerFront=front-18,wall=20;
   const edgeAt=(backX,frontX,y)=>backX+(frontX-backX)*(y-top)/(front-top);
   const ibl=edgeAt(backLeft,fl,innerBack)+wall,ibr=edgeAt(backRight,fr,innerBack)-wall;
   const ifl=edgeAt(backLeft,fl,innerFront)+wall,ifr=edgeAt(backRight,fr,innerFront)-wall;
   const outer=roundedPlan(backLeft,backRight,fl,fr,top,front,20,6);
   const inner=roundedPlan(ibl,ibr,ifl,ifr,innerBack,innerFront,12,4);
   // A continuous front curve replaces the square face and projecting inner corners.
   const face=svgEl('path',{d:`M${fl+9} ${front-6} Q${fl} ${front-1} ${fl} ${front+8} V${bottom-11} Q${fl} ${bottom} ${fl+13} ${bottom} H${fr-13} Q${fr} ${bottom} ${fr} ${bottom-11} V${front+8} Q${fr} ${front-1} ${fr-9} ${front-6} Q${fr} ${front} ${fr-20} ${front} H${fl+20} Q${fl} ${front} ${fl+9} ${front-6} Z`,fill:`url(#${ns('foam-face')})`});group.append(face);
   const cavityClip=clip('foam-inner-wall',svgEl('path',{d:inner}));
   const inside=svgEl('g',{'clip-path':cavityClip});
   const innerShade=svgEl('linearGradient',{id:ns('foam-inner-shade'),x1:'0%',y1:'0%',x2:'0%',y2:'100%'});innerShade.append(svgEl('stop',{offset:0,'stop-color':'#c2b296'}),svgEl('stop',{offset:1,'stop-color':'#d1c2a8'}));defs.append(innerShade);
   inside.append(svgEl('path',{d:inner+' '+roundedPlan(ibl,ibr,ifl,ifr,innerBack+8,innerFront+8,12,4),'fill-rule':'evenodd',fill:`url(#${ns('foam-inner-shade')})`}));
   group.append(inside);
   group.append(svgEl('path',{d:outer+' '+inner,'fill-rule':'evenodd',fill:'#eee6d5'}));
   const pores=svgEl('g',{fill:'#b6a487',opacity:'.55','data-aeration':'true'});
   for(let y=front+18;y<bottom-9;y+=23)for(let x=fl+20;x<fr-14;x+=28)pores.append(svgEl('ellipse',{cx:x+(Math.round((y-front)/23)%2)*8,cy:y,rx:2.3,ry:1.8}));
   group.append(pores);
  }else if(material==='base'){
   // Open quilted exterior with the actual client-photo fascia and logo proportions.
   const baseShade=svgEl('linearGradient',{id:ns('baseguard-charcoal'),x1:'0%',y1:'0%',x2:'0%',y2:'100%'});
   baseShade.append(svgEl('stop',{offset:'0%','stop-color':'#3c3d39'}),svgEl('stop',{offset:'100%','stop-color':'#292b28'}));defs.append(baseShade);
   const baseCentre=(left+right)/2;
   const rim=roundedPlan(baseCentre-501.5,baseCentre+501.5,left,right,600,641,16,5)+' '+roundedPlan(baseCentre-480,baseCentre+480,left+40,right-40,610,632,12,3);
   group.append(svgEl('path',{'data-baseguard-rim':'true',d:rim,'fill-rule':'evenodd',fill:`url(#${ns('baseguard-charcoal')})`}));
   const weave=svgEl('pattern',{id:ns('baseguard-weave'),width:5,height:5,patternUnits:'userSpaceOnUse'});
   weave.append(svgEl('path',{d:'M0 1H5 M1 0V5',stroke:'#a1a29b','stroke-width':'.35',opacity:'.17'}));defs.append(weave);
   group.append(svgEl('path',{d:rim,'fill-rule':'evenodd',fill:`url(#${ns('baseguard-weave')})`}));
   const face=clip('base-real-photo-face',svgEl('path',{d:'M47 459 C280 450 706 458 951 455 Q955 458 954 469 L952 537 Q952 549 948 553 Q955 556 952 560 Q950 561 942 561 C726 562 249 562 56 561 Q45 561 47 558 Q48 556 51 555 Q45 552 44 540 Q41 500 44 473 Q45 463 47 459 Z'}));
   const scale=geo.basePhoto.scale,placement=svgEl('g',{transform:`translate(${left-BASE_PHOTO.left*scale} ${641-BASE_PHOTO.top*scale}) scale(${scale})`}),fabric=svgEl('g',{'clip-path':face});
   fabric.append(svgEl('use',{href:'#'+ns('base-reference')}));placement.append(fabric);group.append(placement);
  }else{
   const cut=svgEl('g',{'clip-path':clip(`layer-mask-${i}`,polygon(geo.bounds[i]))});cut.append(photo());group.append(cut);
   const xs=geo.bounds[i].map(p=>p[0]);align(group,Math.min(...xs),Math.max(...xs));
  }
  svg.append(group);
 }
 const core=svg.querySelector(`[data-index="${v.core}"]`);
 core.before(perimeter('rear'));core.after(perimeter('front'));
 // The outer shell obscures the nested liner's lower face until it is lifted out.
 const base=svg.querySelector(`[data-index="${v.base}"]`),foam=svg.querySelector(`[data-index="${v.foam}"]`);foam.after(base);
 // The fabric's back and side rim sit behind the liner; its real front fascia
 // stays in front. This is one nested assembly rather than two stacked frames.
 const casingRear=svgEl('g',{'class':'slice','data-index':v.base,'data-part':'rear'});
 casingRear.append(base.children[0]);casingRear.append(base.children[0]);
 foam.before(casingRear);

 stage.append(svg);
 svg.classList.add('sml__desktop-diagram');
 // Separate HTML compositor surfaces avoid repainting the entire filtered SVG
 // for every frame of a mobile layer transition. Reuse the exact artwork.
 if(window.matchMedia('(max-width:900px)').matches){
  [...svg.children].filter(el=>el.classList.contains('slice')).forEach((source,index)=>{
   const surface=document.createElement('div');surface.className='sml__mobile-surface';
   const localPrefix=NS+'mobile-'+index+'-';
   const picture=svgEl('svg',{viewBox:`0 0 ${WIDTH} ${HEIGHT}`,'aria-hidden':'true'});
   const localDefs=defs.cloneNode(true),layer=source.cloneNode(true);
   picture.append(localDefs,layer);
   // Every SVG owns unique IDs so masks, clips and gradients resolve locally.
   picture.querySelectorAll('*').forEach(el=>{
    [...el.attributes].forEach(attr=>{
     if(attr.value.includes(NS))el.setAttribute(attr.name,attr.value.split(NS).join(localPrefix));
    });
   });
   surface.dataset.prefix=localPrefix;
   surface.append(picture);stage.append(surface);
  });
  stage.classList.add('sml__stage--composited');
 }

 for(let i=0;i<layers.length;i++){
  const label=`Component ${i+1}: ${layers[i].title}`;
  for(const hotspot of [true,false]){
   const b=document.createElement('button');b.type='button';b.textContent=i+1;b.dataset.index=i;b.dataset.layer=i+1;b.setAttribute('aria-label',label);b.setAttribute('aria-controls',`${NS}layer-image-${i}`);b.onclick=()=>pick(i);
   if(hotspot){
    b.className='sml__hotspot';
    if(stage.classList.contains('sml__stage--composited')){
     const anchor=document.createElement('div');anchor.className='sml__hotspot-anchor';anchor.append(b);stage.append(anchor);
    }else stage.append(b);
   }else nav.append(b);
  }
 }
 update();
}
function pick(i){expanded=i!==selected||!expanded;selected=i;update();}
function compactPositions(v,g){
 const pos=new Array(v.layers.length);pos[v.base]=TOP+g.rest[v.base];
 for(let i=v.base-1;i>=0;i--){
  if(i===v.foam){pos[i]=pos[v.base]-5;continue;}
  if(i===v.core){pos[i]=pos[v.edge]-10;continue;}
  const bottom=Math.max(...g.bounds[i].map(p=>p[1]));
  const nextFront=FRONT[v.id][i+1];
  pos[i]=pos[i+1]+nextFront-bottom-1;
 }
 return pos;
}
function positions(v,g){
 const pos=compactPositions(v,g);
 if(!expanded)return pos;
 const top=i=>Math.min(...g.bounds[i].map(p=>p[1]));
 const bottom=i=>Math.max(...g.bounds[i].map(p=>p[1]));
 // Upper components retain their compact arrangement; only the selected part floats.
 const upperShift=40-(top(0)+pos[0]);
 if(selected===0){pos[0]+=upperShift;return pos;}
 const upperEnd=selected===v.base?v.foam:selected;
 for(let i=0;i<upperEnd;i++)pos[i]+=upperShift;
 if(selected===v.base)return pos; // Keep the foam liner nested in the fixed foundation.
 const upperBottom=Math.max(...pos.slice(0,selected).map((y,i)=>y+bottom(i)));
 const lowerTop=Math.min(...pos.slice(selected+1).map((y,j)=>y+top(j+selected+1)));
 pos[selected]=(upperBottom+lowerTop-top(selected)-bottom(selected))/2;
 return pos;
}
function update(){
 const mobile=stage.classList.contains('sml__stage--composited');
 if(!renderNodes){
  const visible=el=>!mobile||!!el.closest('.sml__mobile-surface');
  renderNodes={
   linings:[...stage.querySelectorAll('.spring-inner-lining')].filter(visible),
   foam:[...stage.querySelectorAll('[data-material=foundationFoam]')].filter(visible),
   slices:[...stage.querySelectorAll('.slice')].filter(visible).map(el=>({el,i:Number(el.dataset.index),surface:el.closest('.sml__mobile-surface')})),
   hotspots:[...stage.querySelectorAll('.sml__hotspot')],
   buttons:[...nav.querySelectorAll('button')]
  };
 }

 const v=DATA[variant],g=GEO[variant],l=v.layers[selected],pos=positions(v,g),n=v.layers.length;
 stage.dataset.expanded=String(expanded);stage.dataset.variant=variant;stage.dataset.selectedLayer=String(selected+1);
 // The inner rear wall is occluded by the core while the spring pair is nested.
 const nestedSprings=Math.abs(pos[v.core]-pos[v.edge]+10)<.5;
 renderNodes.linings.forEach(el=>setAttr(el,'opacity',nestedSprings?'0':'1'));
 const nestedFoundation=Math.abs(pos[v.foam]-pos[v.base]+5)<.5;
 renderNodes.foam.forEach(foamShell=>{
  const prefix=foamShell.closest('.sml__mobile-surface')?.dataset.prefix||NS;
  if(nestedFoundation)setAttr(foamShell,'clip-path',`url(#${prefix}nested-foam-visible-edge)`);else if(foamShell.hasAttribute('clip-path'))foamShell.removeAttribute('clip-path');
 });
 renderNodes.slices.forEach(({el,i,surface})=>{
  if(surface){setStyle(surface,'transform',`translate3d(0,${pos[i]/HEIGHT*100}%,0)`);}
  else{el.style.transform=`translateY(${pos[i]}px)`;el.id=`${NS}layer-image-${i}${el.dataset.part==='rear'?'-rear':''}`;}
 });
 const row=springRow();
 renderNodes.hotspots.forEach(b=>{
  const i=Number(b.dataset.index),layer=v.layers[i];let y,x;
  if(i===v.core){x=89;y=row.front-3;}
  else if(i===v.edge){x=76;y=row.front+38;}
  else if(i===v.foam){x=58;y=expanded&&selected===i?686:638;}
  else if(i===v.base){x=89;y=641+(g.basePhoto.bottom-641)*.5;}
  else {x=i===v.edge+1?42:[89,74,59,44,29,16][i];y=layer.y/100*755;}
  setStyle(b,'left',x+'%');
  const anchor=b.closest('.sml__hotspot-anchor');
  if(anchor){anchor.style.transform=`translate3d(0,${(y+pos[i])/HEIGHT*100}%,0)`;}
  else b.style.top=(y+pos[i])/HEIGHT*100+'%';b.setAttribute('aria-pressed',String(selected===i));b.setAttribute('aria-expanded',String(expanded&&selected===i));
 });
 renderNodes.buttons.forEach(b=>{b.setAttribute('aria-pressed',String(selected===Number(b.dataset.index)));b.setAttribute('aria-expanded',String(expanded&&selected===Number(b.dataset.index)));});
 const version=++renderVersion;
 cancelAnimationFrame(copyFrame);cancelAnimationFrame(copyFrame2);
 const selectedForCopy=selected;
 const writeCopy=()=>{
 if(version!==renderVersion||!root.isConnected)return;
 const selected=selectedForCopy;
 root.querySelector('[data-layer-label]').textContent=`Component ${selected+1} of ${n}`;
 root.querySelector('[data-title]').textContent=l.title;
 root.querySelector('[data-dimension]').textContent=l.dim;root.querySelector('[data-dimension]').hidden=!l.dim;
 root.querySelector('[data-material-name]').hidden=!!l.hideMaterial;root.querySelector('[data-material-name]').textContent=MAT[l.mat];
 root.querySelector('[data-benefit]').textContent=l.benefit;root.querySelector('[data-description]').textContent=l.desc;
 root.querySelector('[data-count]').textContent=`${v.mainLayers} Layers`;root.querySelector('[data-count-label]').textContent=`${n} Components`;
 root.querySelector('[data-hint]').textContent=selected===v.core||selected===v.edge?'The seven-zone core fits inside the reinforced spring perimeter. Select either component to lift it apart.':selected===v.foam||selected===v.base?'The aerated foam fits beneath the BaseGuard exterior. Select either component to see them separately.':'Click a component to explore it separately. Click again to close. The base stays in place.';
 };
 // Give the compositor a frame before reflowing the long mobile description.
 if(mobile && renderVersion>1){
  copyFrame=requestAnimationFrame(()=>{copyFrame2=requestAnimationFrame(writeCopy);});
 }else writeCopy();
} 
function step(d){
 const n=DATA[variant].layers.length;
 pick((selected+d+n)%n);
}
root.querySelector('[data-prev]').onclick=()=>step(-1);root.querySelector('[data-next]').onclick=()=>step(1);
root.addEventListener('keydown',e=>{if(e.key==='Escape'&&expanded){expanded=false;update();}});

build();
  };

  if (customElements.get(NAME)) return;
  let counter = 0;
  customElements.define(NAME, class extends HTMLElement {
    connectedCallback() {
      // Deferred by a tick: with both firmness sections on one page, whichever
      // script runs first defines this element and upgrades BOTH instances. The
      // second variant's data may not be registered yet, so booting synchronously
      // would leave that instance permanently blank.
      if (this.__queued) return;
      this.__queued = true;
      setTimeout(() => { this.__queued = false; this.boot(); }, 0);
    }

    boot() {
      if (this.__booted) return;
      const variant = this.dataset.variant;
      const boot = (window.__sleepyLayerVariants || {})[variant];
      const diagram = this.dataset.diagram;
      // No diagram means the merchant has not picked an image yet; the section
      // already renders a setup note in that case.
      if (!boot || !diagram) return;
      this.__booted = true;
      const uid = (this.dataset.uid || 'sml') + '-' + (++counter) + '-';
      if (this.dataset.motion) this.style.setProperty('--sml-move', this.dataset.motion + 'ms');
      try {
        boot(this, diagram, this.dataset.fabric || '', uid);
      } catch (err) {
        this.__booted = false;
        console.error('[sleepy-mattress-layers] ' + variant + ' failed to build', err);
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-layer-explorer-soft"] && !Shopify.designMode) return;
  try {
    
(() => {
  const NAME = 'sleepy-mattress-layers';
  // Each section file registers its own variant data, then whichever loads
  // first defines the element. Both firmnesses can therefore share a page.
  const REG = (window.__sleepyLayerVariants ||= {});
  REG['soft'] = (root, DIAGRAM_URL, FABRIC_URL, NS) => {
    const ns = id => NS + id;
    const variant = 'soft';

const MAT = {
  cover: 'Knitted bamboo', quilt: 'Quilted fibre', memory: 'Memory foam',
  response: 'Response foam', support: 'Support foam', felt: 'Cotton felt',
  spring: 'Pocket springs', base: 'Quilted base'
};

const D_COVER = "A luxuriously soft knitted bamboo cover creating a smooth, breathable, cool feeling surface against the skin. Moisture-managing properties disperse warmth and humidity for a fresher, drier sleep environment. Naturally antibacterial and hypoallergenic \u2014 ideal for sensitive sleepers.";
const D_QUILT = "A lightly cushioned quilted layer giving immediate comfort from the moment you lie down, softening initial contact and reducing pressure around the shoulders and hips without losing supportive character.";
const D_FELT_U = "A dense cotton felt layer above the pocket springs that spreads pressure evenly, stops coils pressing into the foams above, and protects the mattress's internal structure and long-term durability.";
const D_FELT_L = "A second cotton felt layer beneath the springs that anchors the core, eliminates internal shifting, reduces friction and noise, and lets the spring system move smoothly and independently.";
const D_BASE = "A quilted polyester foundation with light foam padding that protects and encloses the mattress underside, reducing abrasion and wear while giving a clean, premium finish.";

// x/y are fractions of the diagram image, matching each slab's numbered marker
const DATA={"soft":{"id":"soft","label":"Medium Soft","img":"assets/mattress-layers-soft.png","layers":[{"title":"BlissBreathe™ Bamboo Cover","benefit":"Cooling, Antibacterial and Hypoallergenic","dim":"","short":"Bamboo Cover","mat":"cover","x":89.6,"y":13,"desc":"A luxuriously soft knitted bamboo cover creating a smooth, breathable, cool feeling surface against the skin. Moisture-managing properties disperse warmth and humidity for a fresher, drier sleep environment. Naturally antibacterial and hypoallergenic — ideal for sensitive sleepers."},{"title":"BlissNest™ Quilted Comfort Layer","benefit":"Instant Comfort","dim":"","short":"Quilted Comfort","mat":"quilt","x":89.6,"y":23.7,"desc":"A lightly cushioned quilted layer giving immediate comfort from the moment you lie down, softening initial contact and reducing pressure around the shoulders and hips without losing supportive character."},{"title":"BlissAdapt™ Memory Foam","benefit":"Cloud-Like Comfort, Pressure Relief and Motion Absorption","dim":"","short":"Memory Foam","mat":"memory","x":89.6,"y":32.1,"desc":"Gently moulds around your body for a plush, pillow-soft feel, cushioning the shoulders, hips and lower back while relieving pressure and absorbing motion so partner movement is less noticeable."},{"title":"RippleFlex™ Response Foam","benefit":"Responsive Transition and Airflow","dim":"","short":"Response Foam","mat":"response","x":89.6,"y":40.4,"desc":"Creates a smooth, responsive transition between the memory foam above and the supportive foam below, aiding airflow and easy movement."},{"title":"BalanceCore™ Support Foam","benefit":"Deeper Support, Softer Feel","dim":"","short":"Support Foam","mat":"support","x":89.6,"y":48.5,"desc":"A deeper support layer bridging the comfort system and spring core, distributing weight and maintaining spinal alignment with a softer feel."},{"title":"CottonLock™ Stabilising Layer (Upper)","benefit":"Load Distribution and Durability","dim":"","short":"Cotton Felt (Upper)","mat":"felt","x":89.6,"y":56.8,"desc":"A dense cotton felt layer above the pocket springs that spreads pressure evenly, stops coils pressing into the foams above, and protects the mattress's internal structure and long-term durability."},{"title":"BodySync 7™ SoftTune Pocket Spring Core","benefit":"Gentle Orthopaedic Support","dim":"","short":"SoftTune Spring Core","mat":"spring","x":89.6,"y":65.8,"desc":"Individually pocketed springs that adapt separately to body weight and movement, contouring gently across seven support zones while keeping next-to-no partner disturbance and dependable support underneath."},{"title":"CottonLock™ Stabilising Layer (Lower)","benefit":"Core Security and Noise Control","dim":"","short":"Cotton Felt (Lower)","mat":"felt","x":89.6,"y":74.8,"desc":"A second cotton felt layer beneath the springs that anchors the core, eliminates internal shifting, reduces friction and noise, and lets the spring system move smoothly and independently."},{"title":"BaseGuard™ Quilted Foundation","benefit":"Protective Durability","dim":"","short":"Quilted Base","mat":"base","x":89.6,"y":82.8,"desc":"A quilted polyester foundation with light foam padding that protects and encloses the mattress underside, reducing abrasion and wear while giving a clean, premium finish."}]}};


const IMAGES={"soft":DIAGRAM_URL};
// Masks follow the existing photographed layers. Each layer keeps its proportions;
// only its vertical position changes. There is no selected-layer duplicate.
const BASE_REFERENCE=FABRIC_URL;
const GEO={"soft":{"rest":[200,155,125,90,60,32,8,-16,-42],"bounds":[[[244,17],[1100,17],[1245,121],[1246,139],[24,139],[24,124]],[[125,140],[1176,140],[1242,190],[1242,201],[1224,208],[38,208],[25,202],[25,192]],[[101,209],[1181,209],[1238,246],[1238,265],[1227,270],[42,270],[28,266],[28,245]],[[82,271],[1190,271],[1237,306],[1237,329],[28,329],[28,304]],[[95,330],[1190,330],[1237,367],[1237,392],[1226,398],[43,398],[29,392],[29,368]],[[96,399],[1190,399],[1235,433],[1235,445],[31,446],[32,435]],[[91,447],[1184,447],[1227,471],[1227,537],[1208,543],[62,543],[42,537],[40,474]],[[73,544],[1189,544],[1228,574],[1228,584],[38,584],[37,574]],[[87,585],[1180,585],[1233,632],[1232,695],[1220,713],[1180,723],[65,723],[39,711],[32,687],[32,636]]]}};
// The client photograph's charcoal sidewall spans 912 by 113 pixels.
// Use one scale in both axes, then increase the fascia height to fit it.
const BASE_PHOTO={left:43,right:955,top:459,bottom:565};
for(const [name,g] of Object.entries(GEO)){
 const index=g.bounds.length-1;
 const left=name==='firm'?36:32,right=name==='firm'?1223:1233;
 const scale=(right-left)/(BASE_PHOTO.right-BASE_PHOTO.left);
 const bottom=641+(BASE_PHOTO.bottom-BASE_PHOTO.top)*scale;
 const previousBottom=Math.max(...g.bounds[index].map(p=>p[1]));
 const delta=bottom-previousBottom;
 g.basePhoto={left,right,scale,bottom};
 g.bounds[index]=g.bounds[index].map(([x,y])=>[x,y<=641?y:641+(y-641)*(bottom-641)/(previousBottom-641)]);
 // The bottom edge remains fixed while the corrected sidewall grows upwards.
 g.rest[index]-=delta;
}
const SPRING_CONTOURS={"soft":[[40.14,470.79],[40.93,470.01],[41.71,470.01],[42.5,469.22],[43.29,469.22],[44.08,469.22],[44.86,468.43],[45.65,468.43],[46.44,468.43],[47.22,468.43],[48.01,468.43],[48.8,468.43],[49.59,467.64],[50.37,467.64],[51.16,467.64],[51.95,467.64],[52.73,463.71],[53.52,462.92],[54.31,462.13],[55.09,461.35],[55.88,461.35],[56.67,461.35],[57.46,460.56],[58.24,460.56],[59.03,460.56],[59.82,459.77],[60.6,459.77],[61.39,459.77],[62.18,459.77],[62.97,459.77],[63.75,456.62],[64.54,455.05],[65.33,455.05],[66.11,454.26],[66.9,454.26],[67.69,453.47],[68.47,453.47],[69.26,453.47],[70.05,453.47],[70.84,452.69],[71.62,452.69],[72.41,452.69],[73.2,452.69],[73.98,452.69],[74.77,448.75],[75.56,447.96],[76.35,447.96],[77.13,447.17],[77.92,447.17],[78.71,447.17],[79.49,446.39],[80.28,446.39],[81.07,446.39],[81.85,446.39],[82.64,446.39],[83.43,446.39],[84.22,446.39],[85,446.39],[85.79,446.39],[86.58,446.39],[87.36,446.39],[88.15,446.39],[88.94,446.39],[89.73,446.39],[90.51,446.39],[91.3,446.39],[92.09,446.39],[92.87,446.39],[93.66,446.39],[94.45,446.39],[95.23,446.39],[96.02,446.39],[96.81,446.39],[97.6,446.39],[98.38,446.39],[99.17,446.39],[99.96,446.39],[100.74,446.39],[101.53,446.39],[102.32,446.39],[103.11,446.39],[103.89,446.39],[104.68,446.39],[105.47,446.39],[106.25,446.39],[107.04,446.39],[107.83,446.39],[108.62,446.39],[109.4,446.39],[110.19,446.39],[110.98,446.39],[111.76,446.39],[112.55,446.39],[113.34,446.39],[114.12,447.17],[114.91,448.75],[115.7,447.96],[116.49,447.96],[117.27,447.96],[118.06,447.17],[118.85,447.17],[119.63,447.17],[120.42,446.39],[121.21,446.39],[122,446.39],[122.78,446.39],[123.57,446.39],[124.36,446.39],[125.14,446.39],[125.93,446.39],[126.72,446.39],[127.5,446.39],[128.29,446.39],[129.08,446.39],[129.87,446.39],[130.65,446.39],[131.44,446.39],[132.23,446.39],[133.01,446.39],[133.8,446.39],[134.59,446.39],[135.38,446.39],[136.16,446.39],[136.95,446.39],[137.74,446.39],[138.52,446.39],[139.31,446.39],[140.1,446.39],[140.88,446.39],[141.67,446.39],[142.46,446.39],[143.25,446.39],[144.03,446.39],[144.82,446.39],[145.61,446.39],[146.39,446.39],[147.18,446.39],[147.97,446.39],[148.76,446.39],[149.54,446.39],[150.33,446.39],[151.12,446.39],[151.9,446.39],[152.69,447.17],[153.48,447.96],[154.26,447.96],[155.05,447.96],[155.84,447.96],[156.63,447.96],[157.41,447.17],[158.2,446.39],[158.99,446.39],[159.77,446.39],[160.56,446.39],[161.35,446.39],[162.14,446.39],[162.92,446.39],[163.71,446.39],[164.5,446.39],[165.28,446.39],[166.07,446.39],[166.86,446.39],[167.64,446.39],[168.43,446.39],[169.22,446.39],[170.01,446.39],[170.79,446.39],[171.58,446.39],[172.37,446.39],[173.15,446.39],[173.94,446.39],[174.73,446.39],[175.52,446.39],[176.3,446.39],[177.09,446.39],[177.88,446.39],[178.66,446.39],[179.45,446.39],[180.24,446.39],[181.03,446.39],[181.81,446.39],[182.6,446.39],[183.39,446.39],[184.17,446.39],[184.96,446.39],[185.75,446.39],[186.53,446.39],[187.32,446.39],[188.11,447.17],[188.9,447.17],[189.68,447.17],[190.47,447.17],[191.26,447.17],[192.04,447.17],[192.83,447.96],[193.62,447.96],[194.41,447.96],[195.19,447.96],[195.98,447.96],[196.77,447.17],[197.55,447.17],[198.34,447.17],[199.13,447.17],[199.91,447.17],[200.7,446.39],[201.49,446.39],[202.28,446.39],[203.06,446.39],[203.85,446.39],[204.64,446.39],[205.42,446.39],[206.21,446.39],[207,446.39],[207.79,446.39],[208.57,446.39],[209.36,446.39],[210.15,446.39],[210.93,446.39],[211.72,446.39],[212.51,446.39],[213.29,446.39],[214.08,446.39],[214.87,446.39],[215.66,446.39],[216.44,446.39],[217.23,446.39],[218.02,446.39],[218.8,446.39],[219.59,446.39],[220.38,446.39],[221.17,446.39],[221.95,446.39],[222.74,446.39],[223.53,446.39],[224.31,446.39],[225.1,446.39],[225.89,446.39],[226.67,446.39],[227.46,446.39],[228.25,446.39],[229.04,447.17],[229.82,447.17],[230.61,447.96],[231.4,448.75],[232.18,447.96],[232.97,447.96],[233.76,447.96],[234.55,447.17],[235.33,447.17],[236.12,447.17],[236.91,447.17],[237.69,447.17],[238.48,446.39],[239.27,446.39],[240.05,446.39],[240.84,446.39],[241.63,446.39],[242.42,446.39],[243.2,446.39],[243.99,446.39],[244.78,446.39],[245.56,446.39],[246.35,446.39],[247.14,446.39],[247.93,446.39],[248.71,446.39],[249.5,446.39],[250.29,446.39],[251.07,446.39],[251.86,446.39],[252.65,446.39],[253.44,446.39],[254.22,446.39],[255.01,446.39],[255.8,446.39],[256.58,446.39],[257.37,446.39],[258.16,447.17],[258.94,447.17],[259.73,446.39],[260.52,446.39],[261.31,446.39],[262.09,446.39],[262.88,447.17],[263.67,447.17],[264.45,446.39],[265.24,446.39],[266.03,446.39],[266.82,447.17],[267.6,447.17],[268.39,447.96],[269.18,447.96],[269.96,447.96],[270.75,447.96],[271.54,447.96],[272.32,447.17],[273.11,447.17],[273.9,447.17],[274.69,447.17],[275.47,447.17],[276.26,446.39],[277.05,446.39],[277.83,446.39],[278.62,446.39],[279.41,446.39],[280.2,446.39],[280.98,446.39],[281.77,446.39],[282.56,446.39],[283.34,446.39],[284.13,446.39],[284.92,446.39],[285.7,446.39],[286.49,446.39],[287.28,446.39],[288.07,446.39],[288.85,446.39],[289.64,446.39],[290.43,446.39],[291.21,446.39],[292,446.39],[292.79,446.39],[293.58,446.39],[294.36,446.39],[295.15,446.39],[295.94,446.39],[296.72,446.39],[297.51,446.39],[298.3,446.39],[299.08,446.39],[299.87,446.39],[300.66,446.39],[301.45,446.39],[302.23,446.39],[303.02,446.39],[303.81,447.17],[304.59,447.17],[305.38,448.75],[306.17,448.75],[306.96,447.96],[307.74,447.96],[308.53,447.96],[309.32,447.17],[310.1,447.17],[310.89,447.17],[311.68,447.17],[312.46,447.17],[313.25,446.39],[314.04,446.39],[314.83,446.39],[315.61,446.39],[316.4,446.39],[317.19,446.39],[317.97,446.39],[318.76,446.39],[319.55,446.39],[320.34,446.39],[321.12,446.39],[321.91,446.39],[322.7,446.39],[323.48,446.39],[324.27,446.39],[325.06,446.39],[325.85,446.39],[326.63,446.39],[327.42,446.39],[328.21,446.39],[328.99,446.39],[329.78,446.39],[330.57,446.39],[331.35,446.39],[332.14,446.39],[332.93,446.39],[333.72,446.39],[334.5,446.39],[335.29,446.39],[336.08,446.39],[336.86,446.39],[337.65,447.17],[338.44,447.17],[339.23,447.17],[340.01,447.17],[340.8,447.17],[341.59,447.96],[342.37,449.54],[343.16,448.75],[343.95,447.96],[344.73,447.96],[345.52,447.96],[346.31,447.17],[347.1,447.17],[347.88,447.17],[348.67,447.17],[349.46,447.17],[350.24,447.17],[351.03,447.17],[351.82,446.39],[352.61,446.39],[353.39,446.39],[354.18,446.39],[354.97,446.39],[355.75,446.39],[356.54,446.39],[357.33,446.39],[358.11,446.39],[358.9,446.39],[359.69,446.39],[360.48,446.39],[361.26,446.39],[362.05,446.39],[362.84,446.39],[363.62,446.39],[364.41,446.39],[365.2,446.39],[365.99,446.39],[366.77,446.39],[367.56,446.39],[368.35,446.39],[369.13,446.39],[369.92,446.39],[370.71,446.39],[371.49,446.39],[372.28,446.39],[373.07,446.39],[373.86,446.39],[374.64,446.39],[375.43,446.39],[376.22,447.17],[377,447.96],[377.79,448.75],[378.58,448.75],[379.37,447.96],[380.15,447.96],[380.94,447.96],[381.73,447.17],[382.51,447.17],[383.3,447.17],[384.09,447.17],[384.87,447.17],[385.66,447.17],[386.45,447.17],[387.24,447.17],[388.02,447.17],[388.81,446.39],[389.6,446.39],[390.38,446.39],[391.17,446.39],[391.96,446.39],[392.75,446.39],[393.53,446.39],[394.32,446.39],[395.11,446.39],[395.89,446.39],[396.68,446.39],[397.47,446.39],[398.26,446.39],[399.04,446.39],[399.83,446.39],[400.62,446.39],[401.4,446.39],[402.19,446.39],[402.98,446.39],[403.76,446.39],[404.55,446.39],[405.34,446.39],[406.13,446.39],[406.91,446.39],[407.7,446.39],[408.49,446.39],[409.27,446.39],[410.06,446.39],[410.85,446.39],[411.64,447.17],[412.42,447.17],[413.21,447.17],[414,447.96],[414.78,453.47],[415.57,453.47],[416.36,448.75],[417.14,447.96],[417.93,447.96],[418.72,447.96],[419.51,447.96],[420.29,447.96],[421.08,447.17],[421.87,447.17],[422.65,447.17],[423.44,447.17],[424.23,447.17],[425.02,447.17],[425.8,447.17],[426.59,447.17],[427.38,446.39],[428.16,446.39],[428.95,446.39],[429.74,446.39],[430.52,446.39],[431.31,446.39],[432.1,446.39],[432.89,446.39],[433.67,446.39],[434.46,446.39],[435.25,446.39],[436.03,446.39],[436.82,446.39],[437.61,446.39],[438.4,446.39],[439.18,446.39],[439.97,446.39],[440.76,446.39],[441.54,446.39],[442.33,446.39],[443.12,446.39],[443.9,446.39],[444.69,446.39],[445.48,447.17],[446.27,447.17],[447.05,446.39],[447.84,447.17],[448.63,447.17],[449.41,447.17],[450.2,447.17],[450.99,447.96],[451.78,454.26],[452.56,448.75],[453.35,447.96],[454.14,447.96],[454.92,447.96],[455.71,447.17],[456.5,447.17],[457.28,447.17],[458.07,447.17],[458.86,447.17],[459.65,446.39],[460.43,446.39],[461.22,446.39],[462.01,446.39],[462.79,446.39],[463.58,446.39],[464.37,446.39],[465.16,446.39],[465.94,446.39],[466.73,446.39],[467.52,446.39],[468.3,446.39],[469.09,446.39],[469.88,446.39],[470.67,446.39],[471.45,446.39],[472.24,446.39],[473.03,446.39],[473.81,446.39],[474.6,446.39],[475.39,446.39],[476.17,446.39],[476.96,446.39],[477.75,446.39],[478.54,446.39],[479.32,446.39],[480.11,446.39],[480.9,446.39],[481.68,446.39],[482.47,446.39],[483.26,447.17],[484.05,447.17],[484.83,447.17],[485.62,447.17],[486.41,447.17],[487.19,447.17],[487.98,447.96],[488.77,454.26],[489.55,448.75],[490.34,447.96],[491.13,447.96],[491.92,447.96],[492.7,447.17],[493.49,447.17],[494.28,446.39],[495.06,446.39],[495.85,447.17],[496.64,446.39],[497.43,446.39],[498.21,446.39],[499,446.39],[499.79,446.39],[500.57,446.39],[501.36,446.39],[502.15,446.39],[502.93,446.39],[503.72,446.39],[504.51,446.39],[505.3,446.39],[506.08,446.39],[506.87,446.39],[507.66,446.39],[508.44,446.39],[509.23,446.39],[510.02,446.39],[510.81,446.39],[511.59,446.39],[512.38,446.39],[513.17,446.39],[513.95,446.39],[514.74,446.39],[515.53,446.39],[516.31,446.39],[517.1,446.39],[517.89,446.39],[518.68,446.39],[519.46,446.39],[520.25,446.39],[521.04,447.17],[521.82,447.17],[522.61,447.17],[523.4,447.96],[524.19,454.26],[524.97,448.75],[525.76,447.96],[526.55,447.96],[527.33,447.17],[528.12,447.17],[528.91,447.17],[529.69,447.17],[530.48,447.17],[531.27,447.17],[532.06,447.17],[532.84,446.39],[533.63,446.39],[534.42,446.39],[535.2,446.39],[535.99,446.39],[536.78,446.39],[537.57,446.39],[538.35,446.39],[539.14,446.39],[539.93,446.39],[540.71,446.39],[541.5,446.39],[542.29,446.39],[543.08,446.39],[543.86,446.39],[544.65,446.39],[545.44,446.39],[546.22,446.39],[547.01,446.39],[547.8,446.39],[548.58,446.39],[549.37,446.39],[550.16,446.39],[550.95,446.39],[551.73,446.39],[552.52,446.39],[553.31,446.39],[554.09,447.17],[554.88,446.39],[555.67,447.17],[556.46,447.17],[557.24,447.17],[558.03,447.17],[558.82,447.96],[559.6,448.75],[560.39,454.26],[561.18,448.75],[561.96,447.96],[562.75,447.96],[563.54,447.96],[564.33,447.17],[565.11,447.17],[565.9,447.17],[566.69,447.17],[567.47,446.39],[568.26,446.39],[569.05,446.39],[569.84,446.39],[570.62,446.39],[571.41,446.39],[572.2,446.39],[572.98,446.39],[573.77,446.39],[574.56,446.39],[575.34,446.39],[576.13,446.39],[576.92,446.39],[577.71,446.39],[578.49,446.39],[579.28,446.39],[580.07,446.39],[580.85,446.39],[581.64,446.39],[582.43,446.39],[583.22,446.39],[584,446.39],[584.79,446.39],[585.58,446.39],[586.36,446.39],[587.15,447.17],[587.94,447.17],[588.72,447.17],[589.51,447.17],[590.3,447.17],[591.09,447.17],[591.87,447.17],[592.66,447.17],[593.45,447.17],[594.23,447.17],[595.02,448.75],[595.81,455.05],[596.6,448.75],[597.38,447.96],[598.17,447.96],[598.96,447.96],[599.74,447.96],[600.53,447.17],[601.32,447.17],[602.1,447.17],[602.89,447.17],[603.68,447.17],[604.47,447.17],[605.25,447.17],[606.04,447.17],[606.83,446.39],[607.61,446.39],[608.4,446.39],[609.19,446.39],[609.98,446.39],[610.76,446.39],[611.55,446.39],[612.34,446.39],[613.12,446.39],[613.91,446.39],[614.7,446.39],[615.49,446.39],[616.27,446.39],[617.06,446.39],[617.85,446.39],[618.63,446.39],[619.42,446.39],[620.21,446.39],[620.99,446.39],[621.78,446.39],[622.57,446.39],[623.36,446.39],[624.14,446.39],[624.93,446.39],[625.72,446.39],[626.5,446.39],[627.29,447.17],[628.08,447.17],[628.87,447.17],[629.65,447.17],[630.44,447.96],[631.23,455.05],[632.01,455.05],[632.8,447.96],[633.59,447.96],[634.37,447.17],[635.16,447.17],[635.95,447.17],[636.74,447.17],[637.52,447.17],[638.31,447.17],[639.1,447.17],[639.88,446.39],[640.67,446.39],[641.46,446.39],[642.25,446.39],[643.03,446.39],[643.82,446.39],[644.61,446.39],[645.39,446.39],[646.18,446.39],[646.97,446.39],[647.75,446.39],[648.54,446.39],[649.33,446.39],[650.12,447.17],[650.9,447.17],[651.69,447.17],[652.48,447.17],[653.26,447.17],[654.05,447.17],[654.84,447.17],[655.63,447.17],[656.41,447.17],[657.2,447.17],[657.99,447.17],[658.77,447.17],[659.56,447.17],[660.35,447.17],[661.13,447.17],[661.92,447.17],[662.71,447.17],[663.5,447.96],[664.28,447.96],[665.07,448.75],[665.86,455.83],[666.64,448.75],[667.43,447.96],[668.22,447.96],[669.01,447.96],[669.79,447.17],[670.58,447.17],[671.37,447.17],[672.15,446.39],[672.94,447.17],[673.73,447.17],[674.51,446.39],[675.3,446.39],[676.09,446.39],[676.88,446.39],[677.66,446.39],[678.45,446.39],[679.24,446.39],[680.02,446.39],[680.81,446.39],[681.6,446.39],[682.39,446.39],[683.17,446.39],[683.96,446.39],[684.75,446.39],[685.53,446.39],[686.32,446.39],[687.11,446.39],[687.9,446.39],[688.68,446.39],[689.47,446.39],[690.26,446.39],[691.04,446.39],[691.83,447.17],[692.62,447.17],[693.4,447.17],[694.19,447.17],[694.98,447.17],[695.77,447.17],[696.55,447.17],[697.34,447.96],[698.13,448.75],[698.91,463.71],[699.7,449.54],[700.49,448.75],[701.28,447.96],[702.06,447.96],[702.85,447.17],[703.64,447.17],[704.42,447.17],[705.21,446.39],[706,446.39],[706.78,446.39],[707.57,446.39],[708.36,446.39],[709.15,446.39],[709.93,446.39],[710.72,446.39],[711.51,446.39],[712.29,446.39],[713.08,446.39],[713.87,446.39],[714.66,446.39],[715.44,446.39],[716.23,446.39],[717.02,446.39],[717.8,446.39],[718.59,446.39],[719.38,446.39],[720.16,446.39],[720.95,446.39],[721.74,446.39],[722.53,446.39],[723.31,446.39],[724.1,446.39],[724.89,446.39],[725.67,446.39],[726.46,446.39],[727.25,446.39],[728.04,447.17],[728.82,447.17],[729.61,447.17],[730.4,447.17],[731.18,447.17],[731.97,447.96],[732.76,448.75],[733.54,455.83],[734.33,448.75],[735.12,447.96],[735.91,447.96],[736.69,447.17],[737.48,447.17],[738.27,447.17],[739.05,447.17],[739.84,447.17],[740.63,447.17],[741.42,447.17],[742.2,446.39],[742.99,446.39],[743.78,446.39],[744.56,446.39],[745.35,446.39],[746.14,446.39],[746.92,446.39],[747.71,446.39],[748.5,446.39],[749.29,446.39],[750.07,446.39],[750.86,446.39],[751.65,446.39],[752.43,446.39],[753.22,446.39],[754.01,446.39],[754.8,446.39],[755.58,446.39],[756.37,446.39],[757.16,446.39],[757.94,446.39],[758.73,446.39],[759.52,446.39],[760.31,446.39],[761.09,446.39],[761.88,446.39],[762.67,446.39],[763.45,447.17],[764.24,447.17],[765.03,447.17],[765.81,447.96],[766.6,447.96],[767.39,447.96],[768.18,448.75],[768.96,455.83],[769.75,448.75],[770.54,447.96],[771.32,447.96],[772.11,447.96],[772.9,447.17],[773.69,447.17],[774.47,447.17],[775.26,446.39],[776.05,446.39],[776.83,446.39],[777.62,446.39],[778.41,446.39],[779.19,446.39],[779.98,446.39],[780.77,446.39],[781.56,446.39],[782.34,446.39],[783.13,446.39],[783.92,446.39],[784.7,446.39],[785.49,446.39],[786.28,446.39],[787.07,446.39],[787.85,446.39],[788.64,446.39],[789.43,446.39],[790.21,446.39],[791,446.39],[791.79,446.39],[792.57,446.39],[793.36,446.39],[794.15,446.39],[794.94,446.39],[795.72,446.39],[796.51,446.39],[797.3,446.39],[798.08,446.39],[798.87,447.17],[799.66,447.17],[800.45,447.96],[801.23,447.96],[802.02,447.96],[802.81,448.75],[803.59,455.05],[804.38,448.75],[805.17,447.96],[805.95,447.96],[806.74,447.96],[807.53,447.17],[808.32,447.17],[809.1,446.39],[809.89,446.39],[810.68,446.39],[811.46,446.39],[812.25,446.39],[813.04,446.39],[813.83,446.39],[814.61,446.39],[815.4,446.39],[816.19,446.39],[816.97,446.39],[817.76,446.39],[818.55,446.39],[819.33,446.39],[820.12,446.39],[820.91,446.39],[821.7,446.39],[822.48,446.39],[823.27,446.39],[824.06,446.39],[824.84,446.39],[825.63,446.39],[826.42,446.39],[827.21,446.39],[827.99,446.39],[828.78,446.39],[829.57,446.39],[830.35,446.39],[831.14,446.39],[831.93,446.39],[832.72,447.17],[833.5,447.17],[834.29,447.17],[835.08,447.17],[835.86,447.96],[836.65,447.96],[837.44,447.96],[838.22,448.75],[839.01,449.54],[839.8,455.05],[840.59,447.96],[841.37,447.96],[842.16,447.17],[842.95,447.17],[843.73,446.39],[844.52,446.39],[845.31,446.39],[846.1,446.39],[846.88,446.39],[847.67,446.39],[848.46,446.39],[849.24,446.39],[850.03,446.39],[850.82,446.39],[851.6,446.39],[852.39,446.39],[853.18,446.39],[853.97,446.39],[854.75,446.39],[855.54,446.39],[856.33,446.39],[857.11,446.39],[857.9,446.39],[858.69,446.39],[859.48,446.39],[860.26,446.39],[861.05,446.39],[861.84,446.39],[862.62,446.39],[863.41,446.39],[864.2,446.39],[864.98,446.39],[865.77,446.39],[866.56,446.39],[867.35,446.39],[868.13,446.39],[868.92,447.17],[869.71,447.17],[870.49,447.17],[871.28,447.96],[872.07,447.96],[872.86,447.96],[873.64,448.75],[874.43,454.26],[875.22,454.26],[876,447.96],[876.79,447.96],[877.58,447.96],[878.36,447.17],[879.15,447.17],[879.94,446.39],[880.73,446.39],[881.51,446.39],[882.3,446.39],[883.09,446.39],[883.87,446.39],[884.66,446.39],[885.45,446.39],[886.24,446.39],[887.02,446.39],[887.81,446.39],[888.6,446.39],[889.38,446.39],[890.17,446.39],[890.96,446.39],[891.74,446.39],[892.53,446.39],[893.32,446.39],[894.11,446.39],[894.89,446.39],[895.68,446.39],[896.47,446.39],[897.25,446.39],[898.04,446.39],[898.83,446.39],[899.62,446.39],[900.4,446.39],[901.19,446.39],[901.98,447.17],[902.76,447.17],[903.55,447.17],[904.34,447.17],[905.13,447.17],[905.91,447.17],[906.7,447.17],[907.49,447.17],[908.27,447.96],[909.06,447.96],[909.85,448.75],[910.63,449.54],[911.42,454.26],[912.21,447.96],[913,447.96],[913.78,447.17],[914.57,447.17],[915.36,447.17],[916.14,447.17],[916.93,446.39],[917.72,446.39],[918.51,446.39],[919.29,446.39],[920.08,446.39],[920.87,446.39],[921.65,446.39],[922.44,446.39],[923.23,446.39],[924.01,446.39],[924.8,446.39],[925.59,446.39],[926.38,446.39],[927.16,446.39],[927.95,446.39],[928.74,446.39],[929.52,446.39],[930.31,446.39],[931.1,446.39],[931.89,446.39],[932.67,446.39],[933.46,446.39],[934.25,446.39],[935.03,446.39],[935.82,446.39],[936.61,446.39],[937.39,446.39],[938.18,446.39],[938.97,446.39],[939.76,446.39],[940.54,446.39],[941.33,446.39],[942.12,447.17],[942.9,447.17],[943.69,447.96],[944.48,447.96],[945.27,447.96],[946.05,448.75],[946.84,450.32],[947.63,448.75],[948.41,447.96],[949.2,447.96],[949.99,447.17],[950.77,447.17],[951.56,447.17],[952.35,446.39],[953.14,446.39],[953.92,446.39],[954.71,446.39],[955.5,446.39],[956.28,446.39],[957.07,446.39],[957.86,446.39],[958.65,446.39],[959.43,446.39],[960.22,446.39],[961.01,446.39],[961.79,446.39],[962.58,446.39],[963.37,446.39],[964.15,446.39],[964.94,446.39],[965.73,446.39],[966.52,446.39],[967.3,446.39],[968.09,446.39],[968.88,446.39],[969.66,446.39],[970.45,446.39],[971.24,446.39],[972.03,446.39],[972.81,446.39],[973.6,446.39],[974.39,446.39],[975.17,446.39],[975.96,447.17],[976.75,447.17],[977.54,447.17],[978.32,447.17],[979.11,447.17],[979.9,447.96],[980.68,447.96],[981.47,447.96],[982.26,448.75],[983.04,454.26],[983.83,447.96],[984.62,447.96],[985.41,447.17],[986.19,446.39],[986.98,446.39],[987.77,446.39],[988.55,446.39],[989.34,446.39],[990.13,446.39],[990.92,446.39],[991.7,446.39],[992.49,446.39],[993.28,446.39],[994.06,446.39],[994.85,446.39],[995.64,446.39],[996.42,446.39],[997.21,446.39],[998,446.39],[998.79,446.39],[999.57,446.39],[1000.36,446.39],[1001.15,446.39],[1001.93,446.39],[1002.72,446.39],[1003.51,446.39],[1004.3,446.39],[1005.08,446.39],[1005.87,446.39],[1006.66,446.39],[1007.44,446.39],[1008.23,446.39],[1009.02,446.39],[1009.8,446.39],[1010.59,446.39],[1011.38,446.39],[1012.17,446.39],[1012.95,446.39],[1013.74,446.39],[1014.53,446.39],[1015.31,447.17],[1016.1,447.96],[1016.89,447.96],[1017.68,447.96],[1018.46,448.75],[1019.25,454.26],[1020.04,447.96],[1020.82,447.96],[1021.61,447.17],[1022.4,447.17],[1023.18,446.39],[1023.97,446.39],[1024.76,446.39],[1025.55,446.39],[1026.33,446.39],[1027.12,446.39],[1027.91,446.39],[1028.69,446.39],[1029.48,446.39],[1030.27,446.39],[1031.06,446.39],[1031.84,446.39],[1032.63,446.39],[1033.42,446.39],[1034.2,446.39],[1034.99,446.39],[1035.78,446.39],[1036.56,446.39],[1037.35,446.39],[1038.14,446.39],[1038.93,446.39],[1039.71,446.39],[1040.5,446.39],[1041.29,446.39],[1042.07,446.39],[1042.86,446.39],[1043.65,446.39],[1044.44,446.39],[1045.22,446.39],[1046.01,446.39],[1046.8,446.39],[1047.58,446.39],[1048.37,446.39],[1049.16,446.39],[1049.95,446.39],[1050.73,446.39],[1051.52,447.17],[1052.31,447.17],[1053.09,447.96],[1053.88,447.96],[1054.67,449.54],[1055.45,450.32],[1056.24,453.47],[1057.03,447.96],[1057.82,447.96],[1058.6,447.17],[1059.39,446.39],[1060.18,446.39],[1060.96,446.39],[1061.75,446.39],[1062.54,446.39],[1063.33,446.39],[1064.11,446.39],[1064.9,446.39],[1065.69,446.39],[1066.47,446.39],[1067.26,446.39],[1068.05,446.39],[1068.83,446.39],[1069.62,446.39],[1070.41,446.39],[1071.2,446.39],[1071.98,446.39],[1072.77,446.39],[1073.56,446.39],[1074.34,446.39],[1075.13,446.39],[1075.92,446.39],[1076.71,446.39],[1077.49,446.39],[1078.28,446.39],[1079.07,446.39],[1079.85,446.39],[1080.64,446.39],[1081.43,446.39],[1082.21,446.39],[1083,446.39],[1083.79,446.39],[1084.58,447.17],[1085.36,447.17],[1086.15,447.17],[1086.94,447.17],[1087.72,447.17],[1088.51,447.96],[1089.3,447.96],[1090.09,448.75],[1090.87,449.54],[1091.66,447.96],[1092.45,447.17],[1093.23,447.17],[1094.02,446.39],[1094.81,446.39],[1095.59,446.39],[1096.38,446.39],[1097.17,446.39],[1097.96,446.39],[1098.74,446.39],[1099.53,446.39],[1100.32,446.39],[1101.1,446.39],[1101.89,446.39],[1102.68,446.39],[1103.47,446.39],[1104.25,446.39],[1105.04,446.39],[1105.83,446.39],[1106.61,446.39],[1107.4,446.39],[1108.19,446.39],[1108.97,446.39],[1109.76,446.39],[1110.55,446.39],[1111.34,446.39],[1112.12,446.39],[1112.91,446.39],[1113.7,446.39],[1114.48,446.39],[1115.27,446.39],[1116.06,446.39],[1116.85,446.39],[1117.63,446.39],[1118.42,446.39],[1119.21,446.39],[1119.99,446.39],[1120.78,446.39],[1121.57,446.39],[1122.36,446.39],[1123.14,447.17],[1123.93,447.17],[1124.72,447.17],[1125.5,447.96],[1126.29,447.96],[1127.08,447.96],[1127.86,449.54],[1128.65,447.96],[1129.44,446.39],[1130.23,446.39],[1131.01,446.39],[1131.8,446.39],[1132.59,446.39],[1133.37,446.39],[1134.16,446.39],[1134.95,446.39],[1135.74,446.39],[1136.52,446.39],[1137.31,446.39],[1138.1,446.39],[1138.88,446.39],[1139.67,446.39],[1140.46,446.39],[1141.24,446.39],[1142.03,446.39],[1142.82,446.39],[1143.61,446.39],[1144.39,446.39],[1145.18,446.39],[1145.97,446.39],[1146.75,446.39],[1147.54,446.39],[1148.33,446.39],[1149.12,446.39],[1149.9,446.39],[1150.69,446.39],[1151.48,446.39],[1152.26,446.39],[1153.05,446.39],[1153.84,446.39],[1154.62,446.39],[1155.41,446.39],[1156.2,446.39],[1156.99,446.39],[1157.77,446.39],[1158.56,446.39],[1159.35,446.39],[1160.13,446.39],[1160.92,446.39],[1161.71,446.39],[1162.5,447.17],[1163.28,447.96],[1164.07,447.96],[1164.86,447.17],[1165.64,446.39],[1166.43,446.39],[1167.22,446.39],[1168,446.39],[1168.79,446.39],[1169.58,446.39],[1170.37,446.39],[1171.15,446.39],[1171.94,446.39],[1172.73,446.39],[1173.51,446.39],[1174.3,446.39],[1175.09,446.39],[1175.88,446.39],[1176.66,446.39],[1177.45,446.39],[1178.24,446.39],[1179.02,446.39],[1179.81,446.39],[1180.6,446.39],[1181.38,446.39],[1182.17,446.39],[1182.96,446.39],[1183.75,446.39],[1184.53,446.39],[1185.32,446.39],[1186.11,446.39],[1186.89,446.39],[1187.68,446.39],[1188.47,446.39],[1189.26,446.39],[1190.04,446.39],[1190.83,446.39],[1191.62,446.39],[1192.4,446.39],[1193.19,446.39],[1193.98,447.17],[1194.77,447.17],[1195.55,447.17],[1196.34,447.17],[1197.13,447.17],[1197.91,447.96],[1198.7,447.96],[1199.49,448.75],[1200.27,448.75],[1201.06,449.54],[1201.85,453.47],[1202.64,453.47],[1203.42,454.26],[1204.21,454.26],[1205,454.26],[1205.78,454.26],[1206.57,455.05],[1207.36,455.05],[1208.15,455.83],[1208.93,456.62],[1209.72,460.56],[1210.51,460.56],[1211.29,461.35],[1212.08,461.35],[1212.87,461.35],[1213.65,462.13],[1214.44,462.13],[1215.23,462.13],[1216.02,462.92],[1216.8,463.71],[1217.59,464.49],[1218.38,468.43],[1219.16,469.22],[1219.95,469.22],[1220.74,469.22],[1221.53,469.22],[1222.31,469.22],[1223.1,470.01],[1223.89,470.01],[1224.67,470.01],[1225.46,470.79],[1226.25,470.79],[1227.03,471.58],[1227.82,472.37],[1227.82,474.18],[1227.03,506.46],[1226.25,536.37],[1225.46,537.95],[1224.67,537.95],[1223.89,538.73],[1223.1,538.73],[1222.31,539.52],[1221.53,539.52],[1220.74,539.52],[1219.95,539.52],[1219.16,540.31],[1218.38,540.31],[1217.59,540.31],[1216.8,540.31],[1216.02,540.31],[1215.23,540.31],[1214.44,540.31],[1213.65,540.31],[1212.87,540.31],[1212.08,541.1],[1211.29,541.1],[1210.51,541.1],[1209.72,541.1],[1208.93,541.1],[1208.15,541.1],[1207.36,541.1],[1206.57,541.1],[1205.78,540.31],[1205,540.31],[1204.21,540.31],[1203.42,540.31],[1202.64,540.31],[1201.85,540.31],[1201.06,540.31],[1200.27,540.31],[1199.49,540.31],[1198.7,540.31],[1197.91,540.31],[1197.13,539.52],[1196.34,539.52],[1195.55,539.52],[1194.77,539.52],[1193.98,539.52],[1193.19,539.52],[1192.4,539.52],[1191.62,538.73],[1190.83,538.73],[1190.04,538.73],[1189.26,537.95],[1188.47,537.95],[1187.68,537.16],[1186.89,537.16],[1186.11,535.59],[1185.32,537.16],[1184.53,537.95],[1183.75,538.73],[1182.96,538.73],[1182.17,538.73],[1181.38,539.52],[1180.6,539.52],[1179.81,539.52],[1179.02,540.31],[1178.24,540.31],[1177.45,540.31],[1176.66,540.31],[1175.88,540.31],[1175.09,540.31],[1174.3,540.31],[1173.51,540.31],[1172.73,540.31],[1171.94,540.31],[1171.15,541.1],[1170.37,541.1],[1169.58,542.67],[1168.79,541.1],[1168,541.1],[1167.22,541.1],[1166.43,541.1],[1165.64,540.31],[1164.86,540.31],[1164.07,540.31],[1163.28,540.31],[1162.5,540.31],[1161.71,540.31],[1160.92,540.31],[1160.13,540.31],[1159.35,540.31],[1158.56,540.31],[1157.77,539.52],[1156.99,542.67],[1156.2,539.52],[1155.41,539.52],[1154.62,539.52],[1153.84,538.73],[1153.05,538.73],[1152.26,538.73],[1151.48,538.73],[1150.69,537.95],[1149.9,537.95],[1149.12,537.16],[1148.33,536.37],[1147.54,536.37],[1146.75,537.95],[1145.97,537.95],[1145.18,538.73],[1144.39,538.73],[1143.61,539.52],[1142.82,539.52],[1142.03,539.52],[1141.24,539.52],[1140.46,540.31],[1139.67,540.31],[1138.88,540.31],[1138.1,540.31],[1137.31,540.31],[1136.52,540.31],[1135.74,540.31],[1134.95,540.31],[1134.16,540.31],[1133.37,540.31],[1132.59,541.1],[1131.8,541.1],[1131.01,541.1],[1130.23,541.1],[1129.44,541.1],[1128.65,541.1],[1127.86,540.31],[1127.08,540.31],[1126.29,540.31],[1125.5,540.31],[1124.72,540.31],[1123.93,540.31],[1123.14,540.31],[1122.36,540.31],[1121.57,540.31],[1120.78,539.52],[1119.99,539.52],[1119.21,539.52],[1118.42,539.52],[1117.63,539.52],[1116.85,538.73],[1116.06,538.73],[1115.27,538.73],[1114.48,538.73],[1113.7,537.95],[1112.91,537.95],[1112.12,537.16],[1111.34,537.16],[1110.55,536.37],[1109.76,532.44],[1108.97,537.16],[1108.19,537.95],[1107.4,538.73],[1106.61,538.73],[1105.83,539.52],[1105.04,539.52],[1104.25,539.52],[1103.47,539.52],[1102.68,539.52],[1101.89,540.31],[1101.1,540.31],[1100.32,540.31],[1099.53,540.31],[1098.74,540.31],[1097.96,540.31],[1097.17,540.31],[1096.38,540.31],[1095.59,540.31],[1094.81,541.1],[1094.02,541.1],[1093.23,541.1],[1092.45,541.1],[1091.66,541.1],[1090.87,541.1],[1090.09,541.1],[1089.3,541.1],[1088.51,540.31],[1087.72,540.31],[1086.94,540.31],[1086.15,540.31],[1085.36,540.31],[1084.58,540.31],[1083.79,540.31],[1083,540.31],[1082.21,539.52],[1081.43,539.52],[1080.64,539.52],[1079.85,539.52],[1079.07,539.52],[1078.28,538.73],[1077.49,538.73],[1076.71,538.73],[1075.92,537.95],[1075.13,537.95],[1074.34,537.95],[1073.56,537.16],[1072.77,536.37],[1071.98,536.37],[1071.2,537.95],[1070.41,537.95],[1069.62,538.73],[1068.83,538.73],[1068.05,539.52],[1067.26,539.52],[1066.47,539.52],[1065.69,539.52],[1064.9,539.52],[1064.11,540.31],[1063.33,540.31],[1062.54,540.31],[1061.75,540.31],[1060.96,540.31],[1060.18,540.31],[1059.39,540.31],[1058.6,541.1],[1057.82,541.1],[1057.03,541.1],[1056.24,541.1],[1055.45,541.1],[1054.67,541.1],[1053.88,541.1],[1053.09,541.1],[1052.31,541.1],[1051.52,541.1],[1050.73,540.31],[1049.95,540.31],[1049.16,540.31],[1048.37,540.31],[1047.58,540.31],[1046.8,540.31],[1046.01,540.31],[1045.22,540.31],[1044.44,539.52],[1043.65,539.52],[1042.86,539.52],[1042.07,539.52],[1041.29,539.52],[1040.5,538.73],[1039.71,538.73],[1038.93,538.73],[1038.14,537.95],[1037.35,537.95],[1036.56,537.16],[1035.78,537.16],[1034.99,536.37],[1034.2,532.44],[1033.42,536.37],[1032.63,537.16],[1031.84,537.95],[1031.06,538.73],[1030.27,538.73],[1029.48,538.73],[1028.69,539.52],[1027.91,539.52],[1027.12,539.52],[1026.33,539.52],[1025.55,540.31],[1024.76,540.31],[1023.97,540.31],[1023.18,540.31],[1022.4,540.31],[1021.61,540.31],[1020.82,540.31],[1020.04,540.31],[1019.25,540.31],[1018.46,541.1],[1017.68,541.1],[1016.89,541.1],[1016.1,541.1],[1015.31,541.1],[1014.53,541.1],[1013.74,541.1],[1012.95,541.1],[1012.17,540.31],[1011.38,540.31],[1010.59,540.31],[1009.8,540.31],[1009.02,540.31],[1008.23,540.31],[1007.44,540.31],[1006.66,540.31],[1005.87,539.52],[1005.08,539.52],[1004.3,539.52],[1003.51,539.52],[1002.72,539.52],[1001.93,538.73],[1001.15,538.73],[1000.36,538.73],[999.57,537.95],[998.79,537.95],[998,537.95],[997.21,537.16],[996.42,536.37],[995.64,536.37],[994.85,537.16],[994.06,537.95],[993.28,538.73],[992.49,538.73],[991.7,538.73],[990.92,539.52],[990.13,539.52],[989.34,539.52],[988.55,539.52],[987.77,540.31],[986.98,540.31],[986.19,540.31],[985.41,540.31],[984.62,540.31],[983.83,540.31],[983.04,540.31],[982.26,540.31],[981.47,540.31],[980.68,540.31],[979.9,540.31],[979.11,541.1],[978.32,541.1],[977.54,541.1],[976.75,541.1],[975.96,541.1],[975.17,541.1],[974.39,540.31],[973.6,540.31],[972.81,540.31],[972.03,540.31],[971.24,540.31],[970.45,540.31],[969.66,540.31],[968.88,540.31],[968.09,539.52],[967.3,539.52],[966.52,539.52],[965.73,539.52],[964.94,539.52],[964.15,539.52],[963.37,538.73],[962.58,538.73],[961.79,538.73],[961.01,537.95],[960.22,537.95],[959.43,537.16],[958.65,536.37],[957.86,536.37],[957.07,537.16],[956.28,537.95],[955.5,538.73],[954.71,538.73],[953.92,538.73],[953.14,539.52],[952.35,539.52],[951.56,539.52],[950.77,539.52],[949.99,540.31],[949.2,540.31],[948.41,540.31],[947.63,540.31],[946.84,540.31],[946.05,540.31],[945.27,540.31],[944.48,540.31],[943.69,541.1],[942.9,541.1],[942.12,541.1],[941.33,541.1],[940.54,541.1],[939.76,541.1],[938.97,541.1],[938.18,541.1],[937.39,541.1],[936.61,540.31],[935.82,540.31],[935.03,540.31],[934.25,540.31],[933.46,540.31],[932.67,540.31],[931.89,540.31],[931.1,540.31],[930.31,539.52],[929.52,539.52],[928.74,539.52],[927.95,539.52],[927.16,539.52],[926.38,538.73],[925.59,538.73],[924.8,538.73],[924.01,537.95],[923.23,537.95],[922.44,537.95],[921.65,537.16],[920.87,535.59],[920.08,536.37],[919.29,537.16],[918.51,537.95],[917.72,538.73],[916.93,538.73],[916.14,538.73],[915.36,539.52],[914.57,539.52],[913.78,539.52],[913,539.52],[912.21,540.31],[911.42,540.31],[910.63,540.31],[909.85,540.31],[909.06,540.31],[908.27,540.31],[907.49,540.31],[906.7,540.31],[905.91,541.1],[905.13,541.1],[904.34,541.1],[903.55,541.1],[902.76,541.1],[901.98,541.1],[901.19,541.1],[900.4,541.1],[899.62,541.1],[898.83,541.1],[898.04,540.31],[897.25,540.31],[896.47,540.31],[895.68,540.31],[894.89,540.31],[894.11,540.31],[893.32,540.31],[892.53,539.52],[891.74,539.52],[890.96,539.52],[890.17,539.52],[889.38,539.52],[888.6,538.73],[887.81,538.73],[887.02,538.73],[886.24,537.95],[885.45,537.95],[884.66,537.16],[883.87,536.37],[883.09,535.59],[882.3,537.16],[881.51,537.95],[880.73,537.95],[879.94,538.73],[879.15,538.73],[878.36,539.52],[877.58,539.52],[876.79,539.52],[876,539.52],[875.22,540.31],[874.43,540.31],[873.64,540.31],[872.86,540.31],[872.07,540.31],[871.28,540.31],[870.49,540.31],[869.71,540.31],[868.92,540.31],[868.13,541.1],[867.35,541.1],[866.56,541.1],[865.77,541.1],[864.98,541.1],[864.2,541.1],[863.41,541.1],[862.62,541.1],[861.84,540.31],[861.05,540.31],[860.26,540.31],[859.48,540.31],[858.69,540.31],[857.9,540.31],[857.11,540.31],[856.33,540.31],[855.54,539.52],[854.75,539.52],[853.97,539.52],[853.18,539.52],[852.39,539.52],[851.6,538.73],[850.82,538.73],[850.03,538.73],[849.24,537.95],[848.46,537.95],[847.67,537.16],[846.88,537.16],[846.1,530.86],[845.31,536.37],[844.52,537.16],[843.73,537.95],[842.95,537.95],[842.16,538.73],[841.37,538.73],[840.59,538.73],[839.8,539.52],[839.01,539.52],[838.22,539.52],[837.44,540.31],[836.65,540.31],[835.86,540.31],[835.08,540.31],[834.29,540.31],[833.5,540.31],[832.72,540.31],[831.93,540.31],[831.14,540.31],[830.35,540.31],[829.57,541.1],[828.78,541.1],[827.99,541.1],[827.21,541.1],[826.42,541.1],[825.63,541.1],[824.84,540.31],[824.06,540.31],[823.27,540.31],[822.48,540.31],[821.7,540.31],[820.91,540.31],[820.12,540.31],[819.33,540.31],[818.55,540.31],[817.76,540.31],[816.97,539.52],[816.19,539.52],[815.4,539.52],[814.61,539.52],[813.83,539.52],[813.04,538.73],[812.25,538.73],[811.46,538.73],[810.68,537.95],[809.89,537.95],[809.1,537.16],[808.32,536.37],[807.53,537.16],[806.74,537.95],[805.95,537.95],[805.17,538.73],[804.38,538.73],[803.59,538.73],[802.81,539.52],[802.02,539.52],[801.23,539.52],[800.45,539.52],[799.66,540.31],[798.87,540.31],[798.08,540.31],[797.3,540.31],[796.51,540.31],[795.72,540.31],[794.94,540.31],[794.15,541.1],[793.36,541.1],[792.57,541.1],[791.79,541.1],[791,541.1],[790.21,541.1],[789.43,541.1],[788.64,541.1],[787.85,541.1],[787.07,541.1],[786.28,541.1],[785.49,540.31],[784.7,540.31],[783.92,540.31],[783.13,540.31],[782.34,540.31],[781.56,540.31],[780.77,540.31],[779.98,540.31],[779.19,539.52],[778.41,539.52],[777.62,539.52],[776.83,539.52],[776.05,539.52],[775.26,538.73],[774.47,538.73],[773.69,537.95],[772.9,537.95],[772.11,537.16],[771.32,536.37],[770.54,537.16],[769.75,537.95],[768.96,537.95],[768.18,538.73],[767.39,538.73],[766.6,539.52],[765.81,539.52],[765.03,539.52],[764.24,539.52],[763.45,539.52],[762.67,540.31],[761.88,540.31],[761.09,540.31],[760.31,540.31],[759.52,540.31],[758.73,540.31],[757.94,540.31],[757.16,540.31],[756.37,540.31],[755.58,541.1],[754.8,541.1],[754.01,541.1],[753.22,541.1],[752.43,541.1],[751.65,541.1],[750.86,541.1],[750.07,541.1],[749.29,541.1],[748.5,541.1],[747.71,540.31],[746.92,540.31],[746.14,540.31],[745.35,540.31],[744.56,540.31],[743.78,540.31],[742.99,540.31],[742.2,539.52],[741.42,539.52],[740.63,539.52],[739.84,539.52],[739.05,538.73],[738.27,538.73],[737.48,538.73],[736.69,537.95],[735.91,537.16],[735.12,536.37],[734.33,536.37],[733.54,537.95],[732.76,537.95],[731.97,538.73],[731.18,538.73],[730.4,538.73],[729.61,539.52],[728.82,539.52],[728.04,539.52],[727.25,539.52],[726.46,540.31],[725.67,540.31],[724.89,540.31],[724.1,540.31],[723.31,540.31],[722.53,540.31],[721.74,540.31],[720.95,541.1],[720.16,541.1],[719.38,541.1],[718.59,541.1],[717.8,541.1],[717.02,541.1],[716.23,541.1],[715.44,541.1],[714.66,541.1],[713.87,541.1],[713.08,540.31],[712.29,540.31],[711.51,540.31],[710.72,540.31],[709.93,540.31],[709.15,540.31],[708.36,540.31],[707.57,539.52],[706.78,539.52],[706,539.52],[705.21,539.52],[704.42,539.52],[703.64,538.73],[702.85,538.73],[702.06,538.73],[701.28,537.95],[700.49,537.16],[699.7,536.37],[698.91,536.37],[698.13,537.16],[697.34,537.95],[696.55,538.73],[695.77,538.73],[694.98,538.73],[694.19,539.52],[693.4,539.52],[692.62,539.52],[691.83,539.52],[691.04,540.31],[690.26,540.31],[689.47,540.31],[688.68,540.31],[687.9,540.31],[687.11,540.31],[686.32,540.31],[685.53,540.31],[684.75,540.31],[683.96,541.1],[683.17,541.1],[682.39,541.1],[681.6,541.1],[680.81,541.1],[680.02,541.1],[679.24,541.1],[678.45,540.31],[677.66,540.31],[676.88,540.31],[676.09,540.31],[675.3,540.31],[674.51,540.31],[673.73,540.31],[672.94,540.31],[672.15,540.31],[671.37,539.52],[670.58,539.52],[669.79,539.52],[669.01,539.52],[668.22,538.73],[667.43,538.73],[666.64,538.73],[665.86,537.95],[665.07,537.16],[664.28,535.59],[663.5,537.16],[662.71,537.16],[661.92,537.95],[661.13,538.73],[660.35,538.73],[659.56,538.73],[658.77,539.52],[657.99,539.52],[657.2,539.52],[656.41,539.52],[655.63,540.31],[654.84,540.31],[654.05,540.31],[653.26,540.31],[652.48,540.31],[651.69,540.31],[650.9,540.31],[650.12,540.31],[649.33,540.31],[648.54,541.1],[647.75,541.1],[646.97,541.1],[646.18,541.1],[645.39,541.1],[644.61,541.1],[643.82,541.1],[643.03,541.1],[642.25,541.1],[641.46,541.1],[640.67,540.31],[639.88,540.31],[639.1,540.31],[638.31,540.31],[637.52,540.31],[636.74,540.31],[635.95,540.31],[635.16,539.52],[634.37,539.52],[633.59,539.52],[632.8,539.52],[632.01,538.73],[631.23,538.73],[630.44,538.73],[629.65,537.95],[628.87,537.95],[628.08,536.37],[627.29,480.48],[626.5,536.37],[625.72,537.16],[624.93,537.95],[624.14,538.73],[623.36,538.73],[622.57,538.73],[621.78,539.52],[620.99,539.52],[620.21,539.52],[619.42,539.52],[618.63,539.52],[617.85,540.31],[617.06,540.31],[616.27,540.31],[615.49,540.31],[614.7,540.31],[613.91,540.31],[613.12,540.31],[612.34,540.31],[611.55,541.1],[610.76,541.1],[609.98,541.1],[609.19,541.1],[608.4,541.1],[607.61,541.1],[606.83,541.1],[606.04,541.1],[605.25,541.1],[604.47,541.1],[603.68,541.1],[602.89,540.31],[602.1,540.31],[601.32,540.31],[600.53,540.31],[599.74,540.31],[598.96,540.31],[598.17,539.52],[597.38,539.52],[596.6,539.52],[595.81,539.52],[595.02,539.52],[594.23,538.73],[593.45,538.73],[592.66,537.95],[591.87,537.16],[591.09,536.37],[590.3,481.26],[589.51,537.16],[588.72,537.95],[587.94,537.95],[587.15,538.73],[586.36,538.73],[585.58,538.73],[584.79,539.52],[584,539.52],[583.22,539.52],[582.43,539.52],[581.64,540.31],[580.85,540.31],[580.07,540.31],[579.28,540.31],[578.49,540.31],[577.71,540.31],[576.92,540.31],[576.13,540.31],[575.34,540.31],[574.56,541.1],[573.77,541.1],[572.98,541.1],[572.2,541.1],[571.41,541.1],[570.62,541.1],[569.84,541.1],[569.05,541.1],[568.26,541.1],[567.47,541.1],[566.69,540.31],[565.9,540.31],[565.11,540.31],[564.33,540.31],[563.54,540.31],[562.75,540.31],[561.96,540.31],[561.18,540.31],[560.39,539.52],[559.6,539.52],[558.82,539.52],[558.03,539.52],[557.24,538.73],[556.46,538.73],[555.67,537.95],[554.88,537.95],[554.09,536.37],[553.31,535.59],[552.52,537.16],[551.73,537.95],[550.95,537.95],[550.16,537.95],[549.37,538.73],[548.58,538.73],[547.8,538.73],[547.01,539.52],[546.22,539.52],[545.44,539.52],[544.65,539.52],[543.86,540.31],[543.08,540.31],[542.29,540.31],[541.5,540.31],[540.71,540.31],[539.93,540.31],[539.14,540.31],[538.35,541.1],[537.57,541.1],[536.78,541.1],[535.99,541.1],[535.2,541.1],[534.42,541.1],[533.63,541.1],[532.84,541.1],[532.06,541.1],[531.27,541.1],[530.48,541.1],[529.69,541.1],[528.91,541.1],[528.12,540.31],[527.33,540.31],[526.55,540.31],[525.76,540.31],[524.97,540.31],[524.19,540.31],[523.4,539.52],[522.61,539.52],[521.82,539.52],[521.04,539.52],[520.25,539.52],[519.46,538.73],[518.68,538.73],[517.89,537.95],[517.1,537.16],[516.31,506.46],[515.53,535.59],[514.74,537.16],[513.95,537.95],[513.17,537.95],[512.38,537.95],[511.59,538.73],[510.81,538.73],[510.02,538.73],[509.23,539.52],[508.44,539.52],[507.66,539.52],[506.87,539.52],[506.08,540.31],[505.3,540.31],[504.51,540.31],[503.72,540.31],[502.93,540.31],[502.15,540.31],[501.36,540.31],[500.57,540.31],[499.79,540.31],[499,540.31],[498.21,541.1],[497.43,541.1],[496.64,541.1],[495.85,541.1],[495.06,541.1],[494.28,541.1],[493.49,541.1],[492.7,541.1],[491.92,540.31],[491.13,540.31],[490.34,540.31],[489.55,540.31],[488.77,540.31],[487.98,540.31],[487.19,540.31],[486.41,540.31],[485.62,539.52],[484.83,539.52],[484.05,539.52],[483.26,539.52],[482.47,539.52],[481.68,538.73],[480.9,538.73],[480.11,537.95],[479.32,537.16],[478.54,522.99],[477.75,536.37],[476.96,537.16],[476.17,537.95],[475.39,537.95],[474.6,537.95],[473.81,538.73],[473.03,538.73],[472.24,538.73],[471.45,538.73],[470.67,539.52],[469.88,539.52],[469.09,539.52],[468.3,539.52],[467.52,540.31],[466.73,540.31],[465.94,540.31],[465.16,540.31],[464.37,540.31],[463.58,540.31],[462.79,541.1],[462.01,541.1],[461.22,541.1],[460.43,541.1],[459.65,541.1],[458.86,541.1],[458.07,541.1],[457.28,541.1],[456.5,541.1],[455.71,541.1],[454.92,541.1],[454.14,541.1],[453.35,540.31],[452.56,540.31],[451.78,540.31],[450.99,540.31],[450.2,540.31],[449.41,540.31],[448.63,540.31],[447.84,540.31],[447.05,540.31],[446.27,539.52],[445.48,539.52],[444.69,539.52],[443.9,539.52],[443.12,538.73],[442.33,538.73],[441.54,537.95],[440.76,537.16],[439.97,535.59],[439.18,536.37],[438.4,537.16],[437.61,537.16],[436.82,537.95],[436.03,537.95],[435.25,538.73],[434.46,538.73],[433.67,538.73],[432.89,539.52],[432.1,539.52],[431.31,539.52],[430.52,539.52],[429.74,539.52],[428.95,540.31],[428.16,540.31],[427.38,540.31],[426.59,540.31],[425.8,540.31],[425.02,540.31],[424.23,540.31],[423.44,540.31],[422.65,540.31],[421.87,541.1],[421.08,541.1],[420.29,541.1],[419.51,541.1],[418.72,541.1],[417.93,541.1],[417.14,541.1],[416.36,541.1],[415.57,541.1],[414.78,541.1],[414,541.1],[413.21,540.31],[412.42,540.31],[411.64,540.31],[410.85,540.31],[410.06,540.31],[409.27,540.31],[408.49,540.31],[407.7,539.52],[406.91,539.52],[406.13,539.52],[405.34,539.52],[404.55,538.73],[403.76,538.73],[402.98,537.95],[402.19,537.16],[401.4,530.86],[400.62,536.37],[399.83,537.16],[399.04,537.95],[398.26,537.95],[397.47,537.95],[396.68,538.73],[395.89,538.73],[395.11,538.73],[394.32,539.52],[393.53,539.52],[392.75,539.52],[391.96,539.52],[391.17,540.31],[390.38,540.31],[389.6,540.31],[388.81,540.31],[388.02,540.31],[387.24,540.31],[386.45,540.31],[385.66,540.31],[384.87,540.31],[384.09,540.31],[383.3,540.31],[382.51,541.1],[381.73,541.1],[380.94,541.1],[380.15,541.1],[379.37,541.1],[378.58,541.1],[377.79,541.1],[377,540.31],[376.22,540.31],[375.43,540.31],[374.64,540.31],[373.86,540.31],[373.07,540.31],[372.28,540.31],[371.49,540.31],[370.71,540.31],[369.92,539.52],[369.13,539.52],[368.35,539.52],[367.56,539.52],[366.77,539.52],[365.99,538.73],[365.2,538.73],[364.41,537.95],[363.62,537.16],[362.84,536.37],[362.05,537.16],[361.26,537.16],[360.48,537.95],[359.69,537.95],[358.9,537.95],[358.11,538.73],[357.33,538.73],[356.54,538.73],[355.75,539.52],[354.97,539.52],[354.18,539.52],[353.39,539.52],[352.61,539.52],[351.82,540.31],[351.03,540.31],[350.24,540.31],[349.46,540.31],[348.67,540.31],[347.88,540.31],[347.1,540.31],[346.31,540.31],[345.52,540.31],[344.73,540.31],[343.95,540.31],[343.16,540.31],[342.37,541.1],[341.59,541.1],[340.8,541.1],[340.01,541.1],[339.23,541.1],[338.44,541.1],[337.65,540.31],[336.86,540.31],[336.08,540.31],[335.29,540.31],[334.5,540.31],[333.72,540.31],[332.93,540.31],[332.14,540.31],[331.35,539.52],[330.57,539.52],[329.78,539.52],[328.99,539.52],[328.21,538.73],[327.42,538.73],[326.63,538.73],[325.85,537.95],[325.06,536.37],[324.27,536.37],[323.48,537.16],[322.7,537.95],[321.91,537.95],[321.12,537.95],[320.34,538.73],[319.55,538.73],[318.76,538.73],[317.97,538.73],[317.19,539.52],[316.4,539.52],[315.61,539.52],[314.83,539.52],[314.04,539.52],[313.25,539.52],[312.46,540.31],[311.68,540.31],[310.89,540.31],[310.1,540.31],[309.32,540.31],[308.53,540.31],[307.74,540.31],[306.96,540.31],[306.17,540.31],[305.38,540.31],[304.59,541.1],[303.81,541.1],[303.02,541.1],[302.23,541.1],[301.45,541.1],[300.66,540.31],[299.87,540.31],[299.08,540.31],[298.3,540.31],[297.51,540.31],[296.72,540.31],[295.94,540.31],[295.15,540.31],[294.36,540.31],[293.58,539.52],[292.79,539.52],[292,539.52],[291.21,539.52],[290.43,538.73],[289.64,538.73],[288.85,537.95],[288.07,537.16],[287.28,535.59],[286.49,536.37],[285.7,537.16],[284.92,537.16],[284.13,537.95],[283.34,537.95],[282.56,537.95],[281.77,538.73],[280.98,538.73],[280.2,538.73],[279.41,539.52],[278.62,539.52],[277.83,539.52],[277.05,539.52],[276.26,539.52],[275.47,539.52],[274.69,540.31],[273.9,540.31],[273.11,540.31],[272.32,540.31],[271.54,540.31],[270.75,540.31],[269.96,540.31],[269.18,540.31],[268.39,540.31],[267.6,540.31],[266.82,540.31],[266.03,541.1],[265.24,541.1],[264.45,541.1],[263.67,541.1],[262.88,541.1],[262.09,540.31],[261.31,540.31],[260.52,540.31],[259.73,540.31],[258.94,540.31],[258.16,540.31],[257.37,540.31],[256.58,540.31],[255.8,540.31],[255.01,539.52],[254.22,539.52],[253.44,539.52],[252.65,539.52],[251.86,538.73],[251.07,538.73],[250.29,538.73],[249.5,537.95],[248.71,536.37],[247.93,535.59],[247.14,536.37],[246.35,537.16],[245.56,537.95],[244.78,537.95],[243.99,537.95],[243.2,538.73],[242.42,538.73],[241.63,538.73],[240.84,538.73],[240.05,539.52],[239.27,539.52],[238.48,539.52],[237.69,539.52],[236.91,539.52],[236.12,540.31],[235.33,540.31],[234.55,540.31],[233.76,540.31],[232.97,540.31],[232.18,540.31],[231.4,540.31],[230.61,540.31],[229.82,540.31],[229.04,540.31],[228.25,540.31],[227.46,540.31],[226.67,540.31],[225.89,540.31],[225.1,540.31],[224.31,540.31],[223.53,541.1],[222.74,541.1],[221.95,541.1],[221.17,540.31],[220.38,540.31],[219.59,540.31],[218.8,540.31],[218.02,540.31],[217.23,540.31],[216.44,540.31],[215.66,539.52],[214.87,539.52],[214.08,539.52],[213.29,539.52],[212.51,539.52],[211.72,538.73],[210.93,538.73],[210.15,537.95],[209.36,532.44],[208.57,533.22],[207.79,536.37],[207,537.16],[206.21,537.95],[205.42,537.95],[204.64,537.95],[203.85,537.95],[203.06,538.73],[202.28,538.73],[201.49,538.73],[200.7,538.73],[199.91,539.52],[199.13,539.52],[198.34,539.52],[197.55,539.52],[196.77,539.52],[195.98,539.52],[195.19,540.31],[194.41,540.31],[193.62,540.31],[192.83,540.31],[192.04,540.31],[191.26,540.31],[190.47,540.31],[189.68,540.31],[188.9,540.31],[188.11,540.31],[187.32,541.1],[186.53,541.1],[185.75,541.1],[184.96,541.1],[184.17,540.31],[183.39,541.1],[182.6,540.31],[181.81,540.31],[181.03,540.31],[180.24,540.31],[179.45,540.31],[178.66,540.31],[177.88,540.31],[177.09,540.31],[176.3,540.31],[175.52,540.31],[174.73,539.52],[173.94,539.52],[173.15,539.52],[172.37,539.52],[171.58,538.73],[170.79,538.73],[170.01,538.73],[169.22,537.95],[168.43,531.65],[167.64,536.37],[166.86,537.16],[166.07,537.16],[165.28,537.95],[164.5,537.95],[163.71,537.95],[162.92,538.73],[162.14,538.73],[161.35,538.73],[160.56,538.73],[159.77,539.52],[158.99,539.52],[158.2,539.52],[157.41,539.52],[156.63,539.52],[155.84,539.52],[155.05,540.31],[154.26,540.31],[153.48,540.31],[152.69,540.31],[151.9,540.31],[151.12,540.31],[150.33,540.31],[149.54,540.31],[148.76,540.31],[147.97,540.31],[147.18,540.31],[146.39,541.1],[145.61,541.1],[144.82,541.1],[144.03,540.31],[143.25,540.31],[142.46,540.31],[141.67,540.31],[140.88,540.31],[140.1,540.31],[139.31,540.31],[138.52,540.31],[137.74,540.31],[136.95,540.31],[136.16,540.31],[135.38,540.31],[134.59,540.31],[133.8,540.31],[133.01,539.52],[132.23,539.52],[131.44,539.52],[130.65,539.52],[129.87,539.52],[129.08,538.73],[128.29,538.73],[127.5,537.95],[126.72,534.8],[125.93,536.37],[125.14,536.37],[124.36,537.16],[123.57,537.16],[122.78,537.95],[122,537.95],[121.21,537.95],[120.42,538.73],[119.63,538.73],[118.85,538.73],[118.06,538.73],[117.27,539.52],[116.49,539.52],[115.7,539.52],[114.91,539.52],[114.12,539.52],[113.34,539.52],[112.55,540.31],[111.76,540.31],[110.98,540.31],[110.19,540.31],[109.4,540.31],[108.62,540.31],[107.83,540.31],[107.04,540.31],[106.25,540.31],[105.47,540.31],[104.68,540.31],[103.89,540.31],[103.11,541.1],[102.32,541.1],[101.53,541.1],[100.74,540.31],[99.96,540.31],[99.17,540.31],[98.38,540.31],[97.6,540.31],[96.81,540.31],[96.02,540.31],[95.23,540.31],[94.45,540.31],[93.66,540.31],[92.87,540.31],[92.09,540.31],[91.3,539.52],[90.51,539.52],[89.73,539.52],[88.94,539.52],[88.15,539.52],[87.36,538.73],[86.58,538.73],[85.79,537.95],[85,537.16],[84.22,535.59],[83.43,536.37],[82.64,537.16],[81.85,537.16],[81.07,537.95],[80.28,537.95],[79.49,538.73],[78.71,538.73],[77.92,538.73],[77.13,538.73],[76.35,538.73],[75.56,539.52],[74.77,539.52],[73.98,539.52],[73.2,539.52],[72.41,539.52],[71.62,539.52],[70.84,539.52],[70.05,539.52],[69.26,540.31],[68.47,540.31],[67.69,540.31],[66.9,540.31],[66.11,540.31],[65.33,540.31],[64.54,540.31],[63.75,540.31],[62.97,540.31],[62.18,540.31],[61.39,540.31],[60.6,540.31],[59.82,540.31],[59.03,540.31],[58.24,540.31],[57.46,540.31],[56.67,540.31],[55.88,540.31],[55.09,540.31],[54.31,540.31],[53.52,540.31],[52.73,540.31],[51.95,540.31],[51.16,540.31],[50.37,540.31],[49.59,539.52],[48.8,539.52],[48.01,539.52],[47.22,539.52],[46.44,539.52],[45.65,538.73],[44.86,538.73],[44.08,538.73],[43.29,537.95],[42.5,537.95],[41.71,537.16],[40.93,521.41],[40.14,490.71]]};

// Client revision: both constructions now include two nested encasements.
MAT.edge='Reinforced pocket springs';MAT.foundationFoam='Aerated foam';
const CLIENT_COPY={"soft": [{"title": "BlissBreathe™ Bamboo Cover", "benefit": "Cooling, Antibacterial & Hypoallergenic", "desc": "A luxuriously soft 400 GSM knitted bamboo cover, chosen for its premium weight, breathability and exceptionally smooth feel against the skin. Naturally cool to the touch, its moisture-managing properties help disperse warmth and humidity, creating a fresher, drier sleep environment. Naturally antibacterial and hypoallergenic, it helps maintain a cleaner, more comfortable sleep surface—ideal for sensitive sleepers. Its substantial 400 GSM construction delivers a noticeably more luxurious, high-end feel while remaining beautifully soft and breathable. While other brands won’t share their GSM, we confidently will!"}, {"title": "BlissNest™ Quilted Comfort Layer", "benefit": "Plush Comfort from the First Touch", "desc": "A beautifully quilted comfort layer designed to create an instantly plush, inviting feeling from the moment you lie down. Its soft cushioning gently embraces the body, easing initial pressure around sensitive areas such as the shoulders and hips while introducing the luxurious Medium Soft feel. Carefully quilted to keep its comfort evenly distributed across the entire mattress, BlissNest™ creates a baby-soft surface without separating you from the orthopaedic support system underneath. It is the first step in a deeply cushioned comfort system designed to help your body settle, relax and feel beautifully supported throughout the night."}, {"title": "BlissAdapt™ Memory Foam", "benefit": "Cloud-Like Comfort, Pressure Relief & Motion Absorption", "desc": "A substantial layer of premium memory foam that gently moulds around your body, creating the cloud-like, pillow-soft comfort that defines our Medium Soft mattress. BlissAdapt™ adapts to your shape, weight and sleeping position, cushioning pressure around the shoulders, hips and lower back while helping your entire body relax. It also absorbs movement before it travels across the mattress, making partner movement far less noticeable. As part of our exceptionally thick multi-foam comfort system, it provides meaningful pressure relief rather than a token layer—delivering a soothing, body-hugging feel with dependable orthopaedic support underneath."}, {"title": "RippleFlex™ Response Foam", "benefit": "Responsive Cushioning, Airflow & Effortless Movement", "desc": "A generously layered, specially profiled response foam that creates a smooth transition between the body-contouring memory foam above and deeper orthopaedic support beneath. Its responsive structure compresses and recovers as you move, preventing the softer comfort system from feeling overly slow or difficult to turn on. The ripple-shaped surface also creates airflow channels throughout the foam system, helping warmth move away from the body rather than becoming trapped. RippleFlex™ preserves the plush, baby-soft character of the mattress while adding breathability, movement control and gentle responsiveness—so you feel comfortably cradled without feeling completely swallowed."}, {"title": "BalanceCore™ Support Foam", "benefit": "Extra-Thick Orthopaedic Support with a Softer Feel", "desc": "An extra-thick support foam that forms the essential structural bridge between the plush comfort layers and the pocket-spring system beneath. Rather than relying on a thin transitional layer, BalanceCore™ provides substantial cushioning and support, distributing body weight more evenly while controlling excessive sinking. It allows the shoulders and hips to settle comfortably without letting the body collapse out of alignment. Working together with the seven-zone SoftTune spring system, this premium foam strengthens the mattress’s orthopaedic performance while preserving its luxurious Medium Soft feel—delivering deep comfort, gentle stability and dependable support in perfect balance."}, {"title": "CottonLock™ Upper Stabilising Layer", "benefit": "Orthopaedic Load Distribution & Durability", "desc": "A dense cotton-felt stabilising layer positioned directly above the pocket springs to strengthen and protect the mattress internally. CottonLock™ spreads pressure more evenly across the seven-zone spring system, allowing its targeted orthopaedic support to be transferred smoothly through the exceptionally substantial foam system above. It also helps prevent individual coils from pressing directly into the premium foams, reducing unnecessary internal wear over time. Strong, durable and naturally breathable, this protective barrier helps every support zone perform consistently while preserving the mattress’s shape, stability and beautifully cushioned Medium Soft character throughout years of regular use."}, {"title": "BodySync 7™ SoftTune Pocket-Spring Core", "benefit": "Seven Zones of Softer Orthopaedic Support", "desc": "The primary orthopaedic support system at the heart of our Medium Soft mattress. The difference extends far beyond the comfort foams above: SoftTune uses a deliberately softer spring system that compresses more gently and contours more easily under your body than the stronger FirmTune core inside our Medium Firm mattress. Individually pocketed springs are arranged across seven targeted zones supporting the head and neck, shoulders, lower back, hips, thighs, knees and feet. Softer-response areas allow the shoulders and hips to settle comfortably, while more supportive zones help stabilise the lower back and maintain natural spinal alignment. Each spring moves independently to closely follow your body’s shape and minimise partner disturbance—delivering genuinely softer, adaptive comfort without sacrificing dependable orthopaedic support."}, {"title": "Reinforced Pocket-Spring Encasement", "benefit": "Edge-to-Edge Orthopaedic Support", "desc": "A reinforced perimeter of stronger, higher-density pocket springs surrounds the BodySync 7™ SoftTune support system on all four sides. This strengthened encasement helps prevent the softer mattress edges from collapsing or sagging when you sit down, get out of bed or sleep closer to the side. By continuing dependable orthopaedic support across the perimeter, it reduces the sensation of rolling off and allows you to comfortably enjoy more of the total sleeping surface. Unlike basic foam edging, the individually pocketed perimeter springs remain supportive, responsive and breathable while working seamlessly with the softer seven-zone spring core inside."}, {"title": "CottonLock™ Lower Stabilising Layer", "benefit": "Core Stability & Consistent Orthopaedic Performance", "desc": "A second dense cotton-felt layer positioned beneath the pocket springs to secure, stabilise and protect the entire orthopaedic support system from below. CottonLock™ helps keep the spring core correctly positioned, ensuring all seven targeted zones remain properly aligned as the mattress gently responds to your body and changing sleeping positions. It also creates a protective barrier between the springs and foundation, helping minimise friction, vibration and unnecessary noise. By supporting the pocket springs from underneath while allowing them to continue moving independently, this layer contributes to quieter movement, lasting stability and consistently reliable orthopaedic support."}, {"title": "Aerated Foam Encasement", "benefit": "Cushioned Side Comfort & Heat Release", "desc": "A protective foam layer positioned beneath the quilted exterior, creating a softer, more premium feeling around the sides of the mattress. It cushions the direct feel of the pocket-spring structure without disguising the strong, supportive construction underneath. Specially aerated throughout, the foam provides additional pathways for warm air to move outward and escape through the mattress sides, supporting a cooler and more breathable sleep environment. It also forms a protective buffer around the internal spring system, adding refinement, cushioning and durability while giving the Bamboo Bliss Medium Soft a smoother, more luxurious finish from every angle."}, {"title": "BaseGuard™ Quilted Foundation", "benefit": "Premium Protection, Strength & Finishing", "desc": "Durable quilted panels wrap around the sides and underside of the mattress, protecting its substantial internal construction while giving the Bamboo Bliss its distinctive luxury finish. The carefully stitched exterior adds strength and structure around the perimeter, helping the mattress retain its shape through regular use, movement and handling. Underneath, BaseGuard™ helps shield the internal components from friction, abrasion and everyday contact with the bed base. Lightly padded and finished with elegant detailing and SleepyCo branding, it creates a clean, refined exterior that looks premium from every angle while helping preserve the mattress’s long-term structure and performance."}]};
for(const [name,v] of Object.entries(DATA)){
 const g=GEO[name],core=v.layers.findIndex(l=>l.mat==='spring');
 v.layers.splice(core+1,0,{short:'Reinforced Spring Encasement',mat:'edge',dim:''});
 g.bounds.splice(core+1,0,g.bounds[core].map(p=>p.slice()));g.rest.splice(core+1,0,0);
 const base=v.layers.length-1;
 v.layers.splice(base,0,{short:'Aerated Foam Encasement',mat:'foundationFoam',dim:''});
 g.bounds.splice(base,0,[[140,600],[1119,600],[g.basePhoto.right-12,640],[g.basePhoto.right-12,g.basePhoto.bottom-8],[g.basePhoto.left+12,g.basePhoto.bottom-8],[g.basePhoto.left+12,640]]);
 g.rest.splice(base,0,0);
 // BaseGuard is an exterior shell; the foam liner fits inside it.
 g.bounds[base+1]=[[128,600],[1131,600],[g.basePhoto.right,641],[g.basePhoto.right,g.basePhoto.bottom],[g.basePhoto.left,g.basePhoto.bottom],[g.basePhoto.left,641]];
 v.layers.forEach((l,i)=>Object.assign(l,CLIENT_COPY[name][i]));
 Object.assign(v.layers[0],{dim:'Premium 400 GSM Knitted Bamboo',hideMaterial:true});
 v.core=core;v.edge=core+1;v.foam=base;v.base=base+1;v.mainLayers=name==='firm'?8:9;
}
const WIDTH=1290,HEIGHT=885,TOP=150;
let selected=0;
let expanded=false;
let renderNodes=null,copyFrame=0,copyFrame2=0,renderVersion=0;
const setAttr=(el,name,value)=>{if(el.getAttribute(name)!==value)el.setAttribute(name,value);};
const setStyle=(el,name,value)=>{if(el.style[name]!==value)el.style[name]=value;};
const stage=root.querySelector('[data-stage]'),nav=root.querySelector('[data-nav]');
const svgNS='http://www.w3.org/2000/svg';
function svgEl(name,attrs={}){const e=document.createElementNS(svgNS,name);for(const [k,v]of Object.entries(attrs))e.setAttribute(k,v);return e;}
const FRONT={firm:[124,191,266,333,399,450,450,561,640,641],soft:[124,192,245,306,368,435,474,474,574,640,641]};
const springRow=()=>variant==='firm'?{backL:120,backR:1155,frontL:44,frontR:1215,top:410,front:450,bottom:534}:{backL:91,backR:1184,frontL:40,frontR:1227,top:447,front:474,bottom:544};
function build(){
 stage.replaceChildren();nav.replaceChildren();
 nav.setAttribute('aria-label','Choose a mattress component');
 const v=DATA[variant],layers=v.layers,geo=GEO[variant],row=springRow();
 const svg=svgEl('svg',{viewBox:`0 0 ${WIDTH} ${HEIGHT}`,'aria-hidden':'true'}),defs=svgEl('defs');svg.append(defs);
 defs.append(svgEl('image',{id:ns('photograph'),href:IMAGES[variant],width:WIDTH,height:755,preserveAspectRatio:'none'}));
 defs.append(svgEl('image',{id:ns('base-reference'),href:BASE_REFERENCE,width:1000,height:667}));
 for(const [id,values] of [['white-pocket-cloth','0 0 .74 0 .30  0 0 .74 0 .30  0 0 .74 0 .30  0 0 0 1 0'],['navy-pocket-cloth','0 0 .13 0 .012  0 0 .20 0 .02  0 0 .32 0 .035  0 0 0 1 0']]){
  const f=svgEl('filter',{id:ns(id),x:0,y:0,width:'100%',height:'100%','color-interpolation-filters':'sRGB'});
  f.append(svgEl('feColorMatrix',{type:'matrix',values}));defs.append(f);
 }
 function clip(id,child){const c=svgEl('clipPath',{id:ns(id)});c.append(child);defs.append(c);return `url(#${ns(id)})`;}
 const polygon=points=>svgEl('polygon',{points:points.map(p=>p.join(',')).join(' ')});
 const photo=()=>svgEl('use',{href:'#'+ns('photograph')});
 const springClip=clip('spring-outline',polygon(SPRING_CONTOURS[variant]));
 const whiteZones=svgEl('clipPath',{id:ns('white-spring-zones')});
 const boundaries=variant==='firm'?[44,208,397,549,728,876,1060,1215]:[40,207,362,552,734,883,1072,1227];
 for(const zone of [1,3,5]){
  const a=(boundaries[zone]-row.frontL)/(row.frontR-row.frontL),b=(boundaries[zone+1]-row.frontL)/(row.frontR-row.frontL);
  const bl=row.backL+(row.backR-row.backL)*a,br=row.backL+(row.backR-row.backL)*b;
  whiteZones.append(polygon([[bl,row.top],[br,row.top],[boundaries[zone+1],row.front],[boundaries[zone+1],row.bottom],[boundaries[zone],row.bottom],[boundaries[zone],row.front]]));
 }defs.append(whiteZones);
 const left=geo.basePhoto.left,right=geo.basePhoto.right;
 // All joined faces share these rounded plan-view contours.
 function roundedPlan(bl,br,fl,fr,back,front,r=16,ry=5){
  return `M${bl+r} ${back} H${br-r} Q${br} ${back} ${br+r*.45} ${back+ry} L${fr-r*.45} ${front-ry} Q${fr} ${front} ${fr-r} ${front} H${fl+r} Q${fl} ${front} ${fl+r*.45} ${front-ry} L${bl-r*.45} ${back+ry} Q${bl} ${back} ${bl+r} ${back} Z`;
 }
 // The surround and core use the same photographic texture and perspective.
 const openingTop=row.top+(row.front-row.top)*.2,innerBackL=row.backL+39,innerBackR=row.backR-41,innerFrontL=row.frontL+36,innerFrontR=row.frontR-37;
 const ring=svgEl('mask',{id:ns('spring-ring'),maskUnits:'userSpaceOnUse',x:0,y:0,width:WIDTH,height:755});
 const openingFront=row.front-(row.front-row.top)*.12;
 const springOpening=roundedPlan(innerBackL,innerBackR,innerFrontL,innerFrontR,openingTop,openingFront,12,3);
 ring.append(svgEl('rect',{width:WIDTH,height:755,fill:'white'}),svgEl('path',{d:springOpening,fill:'black',stroke:'white','stroke-width':'.8'}));defs.append(ring);
 const springInnerClip=clip('spring-inner-wall',svgEl('path',{d:springOpening}));
 // Round the outer turn so the side rows meet the front without jagged steps.
 const smoothOutline=clip('spring-rounded-turn',svgEl('path',{d:`M${row.backL+16} ${row.top} H${row.backR-16} Q${row.backR} ${row.top} ${row.backR+8} ${row.top+5} L${row.frontR-7} ${row.front-7} Q${row.frontR} ${row.front-2} ${row.frontR} ${row.front+8} V${row.bottom-9} Q${row.frontR} ${row.bottom} ${row.frontR-14} ${row.bottom} H${row.frontL+14} Q${row.frontL} ${row.bottom} ${row.frontL} ${row.bottom-9} V${row.front+8} Q${row.frontL} ${row.front-2} ${row.frontL+7} ${row.front-7} L${row.backL-8} ${row.top+5} Q${row.backL} ${row.top} ${row.backL+16} ${row.top} Z`}));
 // All rear and top-side surfaces belong behind the coloured core.
 // Only the near vertical row can occlude it. Splitting at openingTop instead
 // painted the left corner and the opening's horizontal border over the core.
 const rearClip=clip('spring-rear',svgEl('rect',{x:0,y:row.top-1,width:WIDTH,height:row.front-row.top+1}));
 const frontClip=clip('spring-front',svgEl('rect',{x:0,y:row.front-.4,width:WIDTH,height:row.bottom-row.front+1.4}));
 function align(group,a,b,inset=0){
  const sx=(right-left-2*inset)/(b-a),wrap=svgEl('g',{transform:`translate(${left+inset-a*sx} 0) scale(${sx} 1)`});
  while(group.firstChild)wrap.append(group.firstChild);group.append(wrap);
 }
 function perimeter(part){
  const group=svgEl('g',{'class':'slice','data-index':v.edge,'data-part':part});
  const cut=svgEl('g',{'clip-path':part==='rear'?rearClip:frontClip});
  const silhouette=svgEl('g');
  const cloth=svgEl('g',{mask:`url(#${ns('spring-ring')})`,filter:`url(#${ns('navy-pocket-cloth')})`});cloth.append(photo());silhouette.append(cloth);
  const rounded=svgEl('g',{'clip-path':smoothOutline});rounded.append(silhouette);cut.append(rounded);
  const lining=svgEl('g',{'clip-path':springInnerClip,'class':'spring-inner-lining'});
  lining.style.transition='opacity 180ms ease';
  lining.append(svgEl('path',{d:springOpening+' '+roundedPlan(innerBackL,innerBackR,innerFrontL,innerFrontR,openingTop+6,openingFront+6,12,3),'fill-rule':'evenodd',fill:'#172d45'}));
  cut.append(lining);group.append(cut);align(group,row.frontL,row.frontR);return group;
 }
 for(let i=layers.length-1;i>=0;i--){
  const material=layers[i].mat,group=svgEl('g',{'class':'slice','data-index':i,'data-material':material});
  if(material==='edge')continue;
  if(material==='spring'){
   const cut=svgEl('g',{'clip-path':springClip});cut.append(photo());
   const zones=svgEl('g',{'clip-path':`url(#${ns('white-spring-zones')})`}),white=photo();white.setAttribute('filter',`url(#${ns('white-pocket-cloth')})`);zones.append(white);cut.append(zones);
   // Remove the sub-pixel white cutout fringe where the original cloth meets navy.
   const trim=svgEl('filter',{id:ns('core-edge-trim'),x:'-1%',y:'-1%',width:'102%',height:'102%'});
   trim.append(svgEl('feMorphology',{in:'SourceAlpha',operator:'erode',radius:'.7',result:'cleanAlpha'}),svgEl('feComposite',{in:'SourceGraphic',in2:'cleanAlpha',operator:'in'}));defs.append(trim);
   const clean=svgEl('g',{filter:`url(#${ns('core-edge-trim')})`});clean.append(cut);group.append(clean);
   align(group,row.frontL,row.frontR,24);
  }else if(material==='foundationFoam'){
   // Full four-sided aerated liner. The opening makes its enclosing shape explicit.
   const top=600,front=640,bottom=geo.basePhoto.bottom-8,fl=left+12,fr=right-12;
   clip('nested-foam-visible-edge',svgEl('rect',{x:left,y:front-2,width:right-left,height:bottom-front+3}));
   const gradient=svgEl('linearGradient',{id:ns('foam-face'),x1:'0%',y1:'0%',x2:'0%',y2:'100%'});
   gradient.append(svgEl('stop',{offset:0,'stop-color':'#e7decc'}),svgEl('stop',{offset:1,'stop-color':'#cfbea0'}));defs.append(gradient);
   // Parallel inset edges in the same perspective as the outer shell.
   const centre=(fl+fr)/2,backLeft=centre-489.5,backRight=centre+489.5;
   const innerBack=top+10,innerFront=front-18,wall=20;
   const edgeAt=(backX,frontX,y)=>backX+(frontX-backX)*(y-top)/(front-top);
   const ibl=edgeAt(backLeft,fl,innerBack)+wall,ibr=edgeAt(backRight,fr,innerBack)-wall;
   const ifl=edgeAt(backLeft,fl,innerFront)+wall,ifr=edgeAt(backRight,fr,innerFront)-wall;
   const outer=roundedPlan(backLeft,backRight,fl,fr,top,front,20,6);
   const inner=roundedPlan(ibl,ibr,ifl,ifr,innerBack,innerFront,12,4);
   // A continuous front curve replaces the square face and projecting inner corners.
   const face=svgEl('path',{d:`M${fl+9} ${front-6} Q${fl} ${front-1} ${fl} ${front+8} V${bottom-11} Q${fl} ${bottom} ${fl+13} ${bottom} H${fr-13} Q${fr} ${bottom} ${fr} ${bottom-11} V${front+8} Q${fr} ${front-1} ${fr-9} ${front-6} Q${fr} ${front} ${fr-20} ${front} H${fl+20} Q${fl} ${front} ${fl+9} ${front-6} Z`,fill:`url(#${ns('foam-face')})`});group.append(face);
   const cavityClip=clip('foam-inner-wall',svgEl('path',{d:inner}));
   const inside=svgEl('g',{'clip-path':cavityClip});
   const innerShade=svgEl('linearGradient',{id:ns('foam-inner-shade'),x1:'0%',y1:'0%',x2:'0%',y2:'100%'});innerShade.append(svgEl('stop',{offset:0,'stop-color':'#c2b296'}),svgEl('stop',{offset:1,'stop-color':'#d1c2a8'}));defs.append(innerShade);
   inside.append(svgEl('path',{d:inner+' '+roundedPlan(ibl,ibr,ifl,ifr,innerBack+8,innerFront+8,12,4),'fill-rule':'evenodd',fill:`url(#${ns('foam-inner-shade')})`}));
   group.append(inside);
   group.append(svgEl('path',{d:outer+' '+inner,'fill-rule':'evenodd',fill:'#eee6d5'}));
   const pores=svgEl('g',{fill:'#b6a487',opacity:'.55','data-aeration':'true'});
   for(let y=front+18;y<bottom-9;y+=23)for(let x=fl+20;x<fr-14;x+=28)pores.append(svgEl('ellipse',{cx:x+(Math.round((y-front)/23)%2)*8,cy:y,rx:2.3,ry:1.8}));
   group.append(pores);
  }else if(material==='base'){
   // Open quilted exterior with the actual client-photo fascia and logo proportions.
   const baseShade=svgEl('linearGradient',{id:ns('baseguard-charcoal'),x1:'0%',y1:'0%',x2:'0%',y2:'100%'});
   baseShade.append(svgEl('stop',{offset:'0%','stop-color':'#3c3d39'}),svgEl('stop',{offset:'100%','stop-color':'#292b28'}));defs.append(baseShade);
   const baseCentre=(left+right)/2;
   const rim=roundedPlan(baseCentre-501.5,baseCentre+501.5,left,right,600,641,16,5)+' '+roundedPlan(baseCentre-480,baseCentre+480,left+40,right-40,610,632,12,3);
   group.append(svgEl('path',{'data-baseguard-rim':'true',d:rim,'fill-rule':'evenodd',fill:`url(#${ns('baseguard-charcoal')})`}));
   const weave=svgEl('pattern',{id:ns('baseguard-weave'),width:5,height:5,patternUnits:'userSpaceOnUse'});
   weave.append(svgEl('path',{d:'M0 1H5 M1 0V5',stroke:'#a1a29b','stroke-width':'.35',opacity:'.17'}));defs.append(weave);
   group.append(svgEl('path',{d:rim,'fill-rule':'evenodd',fill:`url(#${ns('baseguard-weave')})`}));
   const face=clip('base-real-photo-face',svgEl('path',{d:'M47 459 C280 450 706 458 951 455 Q955 458 954 469 L952 537 Q952 549 948 553 Q955 556 952 560 Q950 561 942 561 C726 562 249 562 56 561 Q45 561 47 558 Q48 556 51 555 Q45 552 44 540 Q41 500 44 473 Q45 463 47 459 Z'}));
   const scale=geo.basePhoto.scale,placement=svgEl('g',{transform:`translate(${left-BASE_PHOTO.left*scale} ${641-BASE_PHOTO.top*scale}) scale(${scale})`}),fabric=svgEl('g',{'clip-path':face});
   fabric.append(svgEl('use',{href:'#'+ns('base-reference')}));placement.append(fabric);group.append(placement);
  }else{
   const cut=svgEl('g',{'clip-path':clip(`layer-mask-${i}`,polygon(geo.bounds[i]))});cut.append(photo());group.append(cut);
   const xs=geo.bounds[i].map(p=>p[0]);align(group,Math.min(...xs),Math.max(...xs));
  }
  svg.append(group);
 }
 const core=svg.querySelector(`[data-index="${v.core}"]`);
 core.before(perimeter('rear'));core.after(perimeter('front'));
 // The outer shell obscures the nested liner's lower face until it is lifted out.
 const base=svg.querySelector(`[data-index="${v.base}"]`),foam=svg.querySelector(`[data-index="${v.foam}"]`);foam.after(base);
 // The fabric's back and side rim sit behind the liner; its real front fascia
 // stays in front. This is one nested assembly rather than two stacked frames.
 const casingRear=svgEl('g',{'class':'slice','data-index':v.base,'data-part':'rear'});
 casingRear.append(base.children[0]);casingRear.append(base.children[0]);
 foam.before(casingRear);

 stage.append(svg);
 svg.classList.add('sml__desktop-diagram');
 // Separate HTML compositor surfaces avoid repainting the entire filtered SVG
 // for every frame of a mobile layer transition. Reuse the exact artwork.
 if(window.matchMedia('(max-width:900px)').matches){
  [...svg.children].filter(el=>el.classList.contains('slice')).forEach((source,index)=>{
   const surface=document.createElement('div');surface.className='sml__mobile-surface';
   const localPrefix=NS+'mobile-'+index+'-';
   const picture=svgEl('svg',{viewBox:`0 0 ${WIDTH} ${HEIGHT}`,'aria-hidden':'true'});
   const localDefs=defs.cloneNode(true),layer=source.cloneNode(true);
   picture.append(localDefs,layer);
   // Every SVG owns unique IDs so masks, clips and gradients resolve locally.
   picture.querySelectorAll('*').forEach(el=>{
    [...el.attributes].forEach(attr=>{
     if(attr.value.includes(NS))el.setAttribute(attr.name,attr.value.split(NS).join(localPrefix));
    });
   });
   surface.dataset.prefix=localPrefix;
   surface.append(picture);stage.append(surface);
  });
  stage.classList.add('sml__stage--composited');
 }

 for(let i=0;i<layers.length;i++){
  const label=`Component ${i+1}: ${layers[i].title}`;
  for(const hotspot of [true,false]){
   const b=document.createElement('button');b.type='button';b.textContent=i+1;b.dataset.index=i;b.dataset.layer=i+1;b.setAttribute('aria-label',label);b.setAttribute('aria-controls',`${NS}layer-image-${i}`);b.onclick=()=>pick(i);
   if(hotspot){
    b.className='sml__hotspot';
    if(stage.classList.contains('sml__stage--composited')){
     const anchor=document.createElement('div');anchor.className='sml__hotspot-anchor';anchor.append(b);stage.append(anchor);
    }else stage.append(b);
   }else nav.append(b);
  }
 }
 update();
}
function pick(i){expanded=i!==selected||!expanded;selected=i;update();}
function compactPositions(v,g){
 const pos=new Array(v.layers.length);pos[v.base]=TOP+g.rest[v.base];
 for(let i=v.base-1;i>=0;i--){
  if(i===v.foam){pos[i]=pos[v.base]-5;continue;}
  if(i===v.core){pos[i]=pos[v.edge]-10;continue;}
  const bottom=Math.max(...g.bounds[i].map(p=>p[1]));
  const nextFront=FRONT[v.id][i+1];
  pos[i]=pos[i+1]+nextFront-bottom-1;
 }
 return pos;
}
function positions(v,g){
 const pos=compactPositions(v,g);
 if(!expanded)return pos;
 const top=i=>Math.min(...g.bounds[i].map(p=>p[1]));
 const bottom=i=>Math.max(...g.bounds[i].map(p=>p[1]));
 // Upper components retain their compact arrangement; only the selected part floats.
 const upperShift=40-(top(0)+pos[0]);
 if(selected===0){pos[0]+=upperShift;return pos;}
 const upperEnd=selected===v.base?v.foam:selected;
 for(let i=0;i<upperEnd;i++)pos[i]+=upperShift;
 if(selected===v.base)return pos; // Keep the foam liner nested in the fixed foundation.
 const upperBottom=Math.max(...pos.slice(0,selected).map((y,i)=>y+bottom(i)));
 const lowerTop=Math.min(...pos.slice(selected+1).map((y,j)=>y+top(j+selected+1)));
 pos[selected]=(upperBottom+lowerTop-top(selected)-bottom(selected))/2;
 return pos;
}
function update(){
 const mobile=stage.classList.contains('sml__stage--composited');
 if(!renderNodes){
  const visible=el=>!mobile||!!el.closest('.sml__mobile-surface');
  renderNodes={
   linings:[...stage.querySelectorAll('.spring-inner-lining')].filter(visible),
   foam:[...stage.querySelectorAll('[data-material=foundationFoam]')].filter(visible),
   slices:[...stage.querySelectorAll('.slice')].filter(visible).map(el=>({el,i:Number(el.dataset.index),surface:el.closest('.sml__mobile-surface')})),
   hotspots:[...stage.querySelectorAll('.sml__hotspot')],
   buttons:[...nav.querySelectorAll('button')]
  };
 }

 const v=DATA[variant],g=GEO[variant],l=v.layers[selected],pos=positions(v,g),n=v.layers.length;
 stage.dataset.expanded=String(expanded);stage.dataset.variant=variant;stage.dataset.selectedLayer=String(selected+1);
 // The inner rear wall is occluded by the core while the spring pair is nested.
 const nestedSprings=Math.abs(pos[v.core]-pos[v.edge]+10)<.5;
 renderNodes.linings.forEach(el=>setAttr(el,'opacity',nestedSprings?'0':'1'));
 const nestedFoundation=Math.abs(pos[v.foam]-pos[v.base]+5)<.5;
 renderNodes.foam.forEach(foamShell=>{
  const prefix=foamShell.closest('.sml__mobile-surface')?.dataset.prefix||NS;
  if(nestedFoundation)setAttr(foamShell,'clip-path',`url(#${prefix}nested-foam-visible-edge)`);else if(foamShell.hasAttribute('clip-path'))foamShell.removeAttribute('clip-path');
 });
 renderNodes.slices.forEach(({el,i,surface})=>{
  if(surface){setStyle(surface,'transform',`translate3d(0,${pos[i]/HEIGHT*100}%,0)`);}
  else{el.style.transform=`translateY(${pos[i]}px)`;el.id=`${NS}layer-image-${i}${el.dataset.part==='rear'?'-rear':''}`;}
 });
 const row=springRow();
 renderNodes.hotspots.forEach(b=>{
  const i=Number(b.dataset.index),layer=v.layers[i];let y,x;
  if(i===v.core){x=89;y=row.front-3;}
  else if(i===v.edge){x=76;y=row.front+38;}
  else if(i===v.foam){x=58;y=expanded&&selected===i?686:638;}
  else if(i===v.base){x=89;y=641+(g.basePhoto.bottom-641)*.5;}
  else {x=i===v.edge+1?42:[89,74,59,44,29,16][i];y=layer.y/100*755;}
  setStyle(b,'left',x+'%');
  const anchor=b.closest('.sml__hotspot-anchor');
  if(anchor){anchor.style.transform=`translate3d(0,${(y+pos[i])/HEIGHT*100}%,0)`;}
  else b.style.top=(y+pos[i])/HEIGHT*100+'%';b.setAttribute('aria-pressed',String(selected===i));b.setAttribute('aria-expanded',String(expanded&&selected===i));
 });
 renderNodes.buttons.forEach(b=>{b.setAttribute('aria-pressed',String(selected===Number(b.dataset.index)));b.setAttribute('aria-expanded',String(expanded&&selected===Number(b.dataset.index)));});
 const version=++renderVersion;
 cancelAnimationFrame(copyFrame);cancelAnimationFrame(copyFrame2);
 const selectedForCopy=selected;
 const writeCopy=()=>{
 if(version!==renderVersion||!root.isConnected)return;
 const selected=selectedForCopy;
 root.querySelector('[data-layer-label]').textContent=`Component ${selected+1} of ${n}`;
 root.querySelector('[data-title]').textContent=l.title;
 root.querySelector('[data-dimension]').textContent=l.dim;root.querySelector('[data-dimension]').hidden=!l.dim;
 root.querySelector('[data-material-name]').hidden=!!l.hideMaterial;root.querySelector('[data-material-name]').textContent=MAT[l.mat];
 root.querySelector('[data-benefit]').textContent=l.benefit;root.querySelector('[data-description]').textContent=l.desc;
 root.querySelector('[data-count]').textContent=`${v.mainLayers} Layers`;root.querySelector('[data-count-label]').textContent=`${n} Components`;
 root.querySelector('[data-hint]').textContent=selected===v.core||selected===v.edge?'The seven-zone core fits inside the reinforced spring perimeter. Select either component to lift it apart.':selected===v.foam||selected===v.base?'The aerated foam fits beneath the BaseGuard exterior. Select either component to see them separately.':'Click a component to explore it separately. Click again to close. The base stays in place.';
 };
 // Give the compositor a frame before reflowing the long mobile description.
 if(mobile && renderVersion>1){
  copyFrame=requestAnimationFrame(()=>{copyFrame2=requestAnimationFrame(writeCopy);});
 }else writeCopy();
} 
function step(d){
 const n=DATA[variant].layers.length;
 pick((selected+d+n)%n);
}
root.querySelector('[data-prev]').onclick=()=>step(-1);root.querySelector('[data-next]').onclick=()=>step(1);
root.addEventListener('keydown',e=>{if(e.key==='Escape'&&expanded){expanded=false;update();}});

build();
  };

  if (customElements.get(NAME)) return;
  let counter = 0;
  customElements.define(NAME, class extends HTMLElement {
    connectedCallback() {
      // Deferred by a tick: with both firmness sections on one page, whichever
      // script runs first defines this element and upgrades BOTH instances. The
      // second variant's data may not be registered yet, so booting synchronously
      // would leave that instance permanently blank.
      if (this.__queued) return;
      this.__queued = true;
      setTimeout(() => { this.__queued = false; this.boot(); }, 0);
    }

    boot() {
      if (this.__booted) return;
      const variant = this.dataset.variant;
      const boot = (window.__sleepyLayerVariants || {})[variant];
      const diagram = this.dataset.diagram;
      // No diagram means the merchant has not picked an image yet; the section
      // already renders a setup note in that case.
      if (!boot || !diagram) return;
      this.__booted = true;
      const uid = (this.dataset.uid || 'sml') + '-' + (++counter) + '-';
      if (this.dataset.motion) this.style.setProperty('--sml-move', this.dataset.motion + 'ms');
      try {
        boot(this, diagram, this.dataset.fabric || '', uid);
      } catch (err) {
        this.__booted = false;
        console.error('[sleepy-mattress-layers] ' + variant + ' failed to build', err);
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-layer-explorer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sleepy-layer-explorer'))customElements.define('sleepy-layer-explorer',class extends HTMLElement{
connectedCallback(){if(this._mounted)return;this._mounted=true;const root=this;const uid='sle-'+root.dataset.section+'-';const get=id=>root.querySelector('[data-sle-id="'+id+'"]');

'use strict';
const MAT = {
  cover: 'Knitted bamboo', quilt: 'Quilted fibre', memory: 'Memory foam',
  response: 'Response foam', support: 'Support foam', felt: 'Cotton felt',
  spring: 'Pocket springs', base: 'Quilted base'
};

const D_COVER = "A luxuriously soft knitted bamboo cover creating a smooth, breathable, cool feeling surface against the skin. Moisture-managing properties disperse warmth and humidity for a fresher, drier sleep environment. Naturally antibacterial and hypoallergenic \u2014 ideal for sensitive sleepers.";
const D_QUILT = "A lightly cushioned quilted layer giving immediate comfort from the moment you lie down, softening initial contact and reducing pressure around the shoulders and hips without losing supportive character.";
const D_FELT_U = "A dense cotton felt layer above the pocket springs that spreads pressure evenly, stops coils pressing into the foams above, and protects the mattress's internal structure and long-term durability.";
const D_FELT_L = "A second cotton felt layer beneath the springs that anchors the core, eliminates internal shifting, reduces friction and noise, and lets the spring system move smoothly and independently.";
const D_BASE = "A quilted polyester foundation with light foam padding that protects and encloses the mattress underside, reducing abrasion and wear while giving a clean, premium finish.";

// x/y are fractions of the diagram image, matching each slab's numbered marker
const DATA = {
  firm: {
    id: 'firm', label: 'Medium Firm', img: 'assets/mattress-layers-firm.png',
    layers: [
      { title:'BlissBreathe\u2122 Bamboo Cover', benefit:'Cooling, Antibacterial and Hypoallergenic', dim:'', short:'Bamboo Cover', mat:'cover', x:88.9, y:12.8, desc:D_COVER },
      { title:'BlissNest\u2122 Quilted Comfort Layer', benefit:'Instant Comfort', dim:'1 cm', short:'Quilted Comfort', mat:'quilt', x:88.9, y:24.3, desc:D_QUILT },
      { title:'RippleFlex\u2122 Response Foam', benefit:'Responsive Comfort, Airflow and Movement Control', dim:'3 cm', short:'Response Foam', mat:'response', x:88.9, y:34.7, desc:"A wave-profiled foam that compresses and responds quickly as you move, creating airflow channels through the comfort system and cushioning movement before it reaches the spring core." },
      { title:'BalanceCore\u2122 Support Foam', benefit:'Orthopaedic Support and Spinal Alignment', dim:'2.5 cm', short:'Support Foam', mat:'support', x:88.9, y:43.4, desc:"The structural bridge between comfort layers and the spring core, distributing weight evenly, preventing excess sinking, and encouraging natural spinal alignment." },
      { title:'CottonLock\u2122 Stabilising Layer (Upper)', benefit:'Load Distribution and Durability', dim:'', short:'Cotton Felt (Upper)', mat:'felt', x:88.9, y:51.6, desc:D_FELT_U },
      { title:'BodySync 7\u2122 FirmTune Pocket Spring Core', benefit:'Firm Orthopaedic Support', dim:'24 cm', short:'FirmTune Spring Core', mat:'spring', x:88.9, y:62.9, desc:"The primary orthopaedic support and partner-disturbance system. Individually pocketed springs compress independently across seven targeted support zones (head, shoulders, lower back, hips, thighs, knees, feet), delivering firm support with next-to-no partner disturbance." },
      { title:'CottonLock\u2122 Stabilising Layer (Lower)', benefit:'Core Security and Noise Control', dim:'', short:'Cotton Felt (Lower)', mat:'felt', x:88.9, y:72.9, desc:D_FELT_L },
      { title:'BaseGuard\u2122 Quilted Foundation', benefit:'Protective Durability', dim:'', short:'Quilted Base', mat:'base', x:88.9, y:87.0, desc:D_BASE }
    ]
  },
  soft: {
    id: 'soft', label: 'Medium Soft', img: 'assets/mattress-layers-soft.png',
    layers: [
      { title:'BlissBreathe\u2122 Bamboo Cover', benefit:'Cooling, Antibacterial and Hypoallergenic', dim:'', short:'Bamboo Cover', mat:'cover', x:89.6, y:13.0, desc:D_COVER },
      { title:'BlissNest\u2122 Quilted Comfort Layer', benefit:'Instant Comfort', dim:'1 cm', short:'Quilted Comfort', mat:'quilt', x:89.6, y:23.7, desc:D_QUILT },
      { title:'BlissAdapt\u2122 Memory Foam', benefit:'Cloud-Like Comfort, Pressure Relief and Motion Absorption', dim:'1.5 cm', short:'Memory Foam', mat:'memory', x:89.6, y:32.1, desc:"Gently moulds around your body for a plush, pillow-soft feel, cushioning the shoulders, hips and lower back while relieving pressure and absorbing motion so partner movement is less noticeable." },
      { title:'RippleFlex\u2122 Response Foam', benefit:'Responsive Transition and Airflow', dim:'1.5 cm', short:'Response Foam', mat:'response', x:89.6, y:40.4, desc:"Creates a smooth, responsive transition between the memory foam above and the supportive foam below, aiding airflow and easy movement." },
      { title:'BalanceCore\u2122 Support Foam', benefit:'Deeper Support, Softer Feel', dim:'3.5 cm', short:'Support Foam', mat:'support', x:89.6, y:48.5, desc:"A deeper support layer bridging the comfort system and spring core, distributing weight and maintaining spinal alignment with a softer feel." },
      { title:'CottonLock\u2122 Stabilising Layer (Upper)', benefit:'Load Distribution and Durability', dim:'', short:'Cotton Felt (Upper)', mat:'felt', x:89.6, y:56.8, desc:D_FELT_U },
      { title:'BodySync 7\u2122 SoftTune Pocket Spring Core', benefit:'Gentle Orthopaedic Support', dim:'24 cm', short:'SoftTune Spring Core', mat:'spring', x:89.6, y:65.8, desc:"Individually pocketed springs that adapt separately to body weight and movement, contouring gently across seven support zones while keeping next-to-no partner disturbance and dependable support underneath." },
      { title:'CottonLock\u2122 Stabilising Layer (Lower)', benefit:'Core Security and Noise Control', dim:'', short:'Cotton Felt (Lower)', mat:'felt', x:89.6, y:74.8, desc:D_FELT_L },
      { title:'BaseGuard\u2122 Quilted Foundation', benefit:'Protective Durability', dim:'', short:'Quilted Base', mat:'base', x:89.6, y:82.8, desc:D_BASE }
    ]
  }
};


const IMAGES={firm:root.dataset.firm,soft:root.dataset.soft};
// Masks follow the existing photographed layers. Each layer keeps its proportions;
// only its vertical position changes. There is no selected-layer duplicate.
const GEO={
firm:{rest:[190,140,95,55,25,0,-20,-40],bounds:[
[[244,17],[1097,17],[1233,122],[1234,139],[24,139],[24,124]],
[[123,140],[1166,140],[1233,191],[1233,207],[1220,213],[38,214],[25,209],[26,191]],
[[120,214],[1166,214],[1227,266],[1227,289],[29,289],[28,270]],
[[95,290],[1182,290],[1225,333],[1225,355],[1214,359],[43,359],[31,355],[31,332]],
[[99,360],[1180,360],[1223,399],[1223,409],[35,410],[35,399]],
[[120,410],[1155,410],[1215,450],[1215,527],[1180,533],[60,533],[45,526],[44,450]],
[[78,534],[1182,534],[1215,561],[1215,570],[43,570],[43,560]],
[[95,571],[1162,571],[1222,632],[1223,699],[1209,716],[1160,724],[75,724],[42,711],[36,686],[37,636]]]},
soft:{rest:[200,155,125,90,60,32,8,-16,-42],bounds:[
[[244,17],[1100,17],[1245,121],[1246,139],[24,139],[24,124]],
[[125,140],[1176,140],[1242,190],[1242,201],[1224,208],[38,208],[25,202],[25,192]],
[[101,209],[1181,209],[1238,246],[1238,265],[1227,270],[42,270],[28,266],[28,245]],
[[82,271],[1190,271],[1237,306],[1237,329],[28,329],[28,304]],
[[95,330],[1190,330],[1237,367],[1237,392],[1226,398],[43,398],[29,392],[29,368]],
[[96,399],[1190,399],[1235,433],[1235,445],[31,446],[32,435]],
[[91,447],[1184,447],[1227,471],[1227,537],[1208,543],[62,543],[42,537],[40,474]],
[[73,544],[1189,544],[1228,574],[1228,584],[38,584],[37,574]],
[[87,585],[1180,585],[1233,632],[1232,695],[1220,713],[1180,723],[65,723],[39,711],[32,687],[32,636]]]}
};
const WIDTH=1290,HEIGHT=885,TOP=150;
let variant=root.dataset.initial||'firm',selected=0;
const openGaps=new Set();
const stage=get('stage'),nav=get('layer-nav');
const svgNS='http://www.w3.org/2000/svg';
function svgEl(name,attrs={}){const e=document.createElementNS(svgNS,name);for(const [k,v]of Object.entries(attrs))e.setAttribute(k,v);return e;}
function build(){
 root.querySelectorAll('[data-spec-table]').forEach(table=>{table.hidden=table.dataset.specTable!==variant;});
 root.querySelectorAll('button[data-variant]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.variant===variant)));
 stage.replaceChildren();nav.replaceChildren();if(!IMAGES[variant]){const note=document.createElement('p');note.textContent='Select the mattress diagram image in this section’s settings.';stage.append(note);return;}
 const svg=svgEl('svg',{viewBox:`0 0 ${WIDTH} ${HEIGHT}`,'aria-hidden':'true'}),defs=svgEl('defs');svg.append(defs);
 defs.append(svgEl('image',{id:uid+'photograph',href:IMAGES[variant],width:WIDTH,height:755}));
 const layers=DATA[variant].layers,geo=GEO[variant];
 layers.forEach((l,i)=>{
  const c=svgEl('clipPath',{id:`${uid}layer-mask-${i}`});c.append(svgEl('polygon',{points:geo.bounds[i].map(p=>p.join(',')).join(' ')}));defs.append(c);
  // Hide the numbers baked into the source with a circular sample from adjacent
  // material, so controls can remain legible in the compact stack.
  const gradient=svgEl('radialGradient',{id:`${uid}number-fade-${i}`});gradient.append(svgEl('stop',{offset:'62%','stop-color':'white','stop-opacity':1}),svgEl('stop',{offset:'100%','stop-color':'white','stop-opacity':0}));defs.append(gradient);
  const mask=svgEl('mask',{id:`${uid}number-mask-${i}`,maskUnits:'userSpaceOnUse',x:0,y:0,width:WIDTH,height:755});mask.append(svgEl('circle',{cx:l.x/100*WIDTH,cy:l.y/100*755,r:54,fill:`url(#${uid}number-fade-${i})`}));defs.append(mask);
 });
 for(let i=layers.length-1;i>=0;i--){
  const group=svgEl('g',{'class':'slice','data-index':i});
  const clipped=svgEl('g',{'clip-path':`url(#${uid}layer-mask-${i})`});
  clipped.append(svgEl('use',{href:'#'+uid+'photograph'}));
  const patch=svgEl('g',{'mask':`url(#${uid}number-mask-${i})`});patch.append(svgEl('use',{href:'#'+uid+'photograph',transform:'translate(90 0)'}));clipped.append(patch);
  group.append(clipped);group.addEventListener('click',()=>pick(i));svg.append(group);
 }
 stage.append(svg);
 // One control per layer, numbered from top to bottom.
 for(let i=0;i<layers.length;i++){
  const num=i+1;
  const label=`Layer ${num}: ${layers[i].short}`;
  const b=document.createElement('button');b.type='button';b.className='hotspot';b.dataset.index=i;b.dataset.layer=num;b.textContent=num;b.setAttribute('aria-label',label);b.setAttribute('aria-controls',`${uid}layer-image-${i}`);b.onclick=()=>pick(i);stage.append(b);
  const n=document.createElement('button');n.type='button';n.textContent=num;n.dataset.index=i;n.dataset.layer=num;n.setAttribute('aria-label',`Select ${label.toLowerCase()}`);n.onclick=()=>pick(i);nav.append(n);
 }
 update();
}
function pick(i){
 selected=i;
 if(i<DATA[variant].layers.length-1){
  const boundary=i+1;
  if(openGaps.has(boundary))openGaps.delete(boundary);else openGaps.add(boundary);
 }
 update();
}
function positions(v,g){
 // A gap belongs to the layer below it (source index i). Translate every layer
 // above it equally, preserving all other pairwise distances.
 const sizes=new Map(Array.from(openGaps,i=>[i,g.rest[i-1]-g.rest[i]+12]));
 // The base is anchored. Only layers above an opened boundary move.
 return v.layers.map((_,i)=>TOP+g.rest[i]-Array.from(sizes).reduce((sum,[boundary,d])=>sum+(i<boundary?d:0),0));
}
function update(){
 const v=DATA[variant],g=GEO[variant],l=v.layers[selected],pos=positions(v,g),n=v.layers.length;
 stage.dataset.expanded=String(openGaps.size>0);stage.dataset.variant=variant;
 stage.dataset.openGaps=Array.from(openGaps).sort((a,b)=>a-b).join(',');
 stage.querySelectorAll('.slice').forEach(el=>{const i=Number(el.dataset.index);el.style.transform=`translateY(${pos[i]}px)`;el.id=`${uid}layer-image-${i}`;});
 stage.querySelectorAll('.hotspot').forEach(b=>{
  const i=Number(b.dataset.index),layer=v.layers[i];
  const y=layer.y/100*755+pos[i];
  const x=(i===0||i===n-1)?layer.x:[89,74,59,44,29,89,73,58,89][i];
  b.style.left=x+'%';b.style.top=y/HEIGHT*100+'%';
  b.setAttribute('aria-pressed',String(i===n-1?selected===i:openGaps.has(i+1)));
  if(i<n-1)b.setAttribute('aria-expanded',String(openGaps.has(i+1)));else b.removeAttribute('aria-expanded');
 });
 nav.querySelectorAll('button').forEach(b=>{const i=Number(b.dataset.index);b.setAttribute('aria-pressed',String(i===n-1?selected===i:openGaps.has(i+1)));});
 root.querySelectorAll('button[data-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.variant===variant)));
 get('layer-label').textContent=`Layer ${selected+1} of ${n}`;
 get('title').textContent=l.title;
 get('dimension').textContent=l.dim;get('dimension').hidden=!l.dim;
 get('material').textContent=MAT[l.mat];get('benefit').textContent=l.benefit;get('description').textContent=l.desc;get('count').textContent=n;
 get('hint').textContent='Click a layer to open the space below it. Click again to close. The base stays in place.';
}
 root.querySelectorAll('button[data-variant]').forEach(b=>b.onclick=()=>{if(b.dataset.variant===variant)return;variant=b.dataset.variant;selected=0;openGaps.clear();build();});
function step(d){
 const n=DATA[variant].layers.length;
 pick((selected+d+n)%n);
}
get('prev').onclick=()=>step(-1);get('next').onclick=()=>step(1);
root.addEventListener('keydown',e=>{if(e.key==='Escape'&&openGaps.size){openGaps.clear();update();}});

const editorHandler=e=>{const row=root.querySelector('[data-spec-block="'+e.detail.blockId+'"]');if(!row)return;variant=row.closest('[data-spec-table]').dataset.specTable;selected=0;openGaps.clear();build();};
if(window.Shopify?.designMode){document.addEventListener('shopify:block:select',editorHandler);this._editorHandler=editorHandler;}

build();

}
disconnectedCallback(){if(this._editorHandler)document.removeEventListener('shopify:block:select',this._editorHandler);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-mattress-chooser"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>root.querySelectorAll('[data-smc]:not([data-ready])').forEach(section=>{section.dataset.ready='true';if(section.classList.contains('smc--none')||matchMedia('(prefers-reduced-motion:reduce)').matches){section.classList.add('is-visible');return}const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.15});observer.observe(section)});init(document);document.addEventListener('shopify:section:load',event=>init(event.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-mattress-pair"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sleepy-firmness-carousel')){
  customElements.define('sleepy-firmness-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.ctrl)return;
      this.track=this.querySelector('[data-sc-track]');
      if(!this.track)return;
      this.ctrl=new AbortController();
      const signal=this.ctrl.signal;
      this.slides=Array.from(this.track.children).filter(n=>n.nodeType===1);
      this.bar=this.querySelector('[data-sc-controls]');
      this.prevBtn=this.querySelector('[data-sc-prev]');
      this.nextBtn=this.querySelector('[data-sc-next]');
      this.pauseBtn=this.querySelector('[data-sc-pause]');
      this.dots=Array.from(this.querySelectorAll('[data-sc-dot]'));
      const reduce=matchMedia('(prefers-reduced-motion:reduce)');
      const behavior=()=>reduce.matches?'auto':'smooth';
      const maxScroll=()=>this.track.scrollWidth-this.track.clientWidth;
      const step=dir=>this.track.scrollBy({left:dir*this.track.clientWidth*0.9,behavior:behavior()});
      const goTo=i=>{
        const slide=this.slides[i];
        if(slide)this.track.scrollTo({left:slide.offsetLeft-this.track.offsetLeft,behavior:behavior()});
      };
      this.prevBtn?.addEventListener('click',()=>step(-1),{signal});
      this.nextBtn?.addEventListener('click',()=>step(1),{signal});
      this.dots.forEach(dot=>dot.addEventListener('click',()=>goTo(Number(dot.dataset.scDot)),{signal}));
      this.sync=()=>{
        const max=maxScroll();
        const scrollable=max>2;
        if(this.bar)this.bar.hidden=!scrollable;
        if(!scrollable)return;
        const x=this.track.scrollLeft;
        let best=0,bd=Infinity;
        this.slides.forEach((s,i)=>{const d=Math.abs(s.offsetLeft-this.track.offsetLeft-x);if(d<bd){bd=d;best=i}});
        this.dots.forEach((d,i)=>d.setAttribute('aria-selected',String(i===best)));
        if(this.prevBtn)this.prevBtn.disabled=x<=1;
        if(this.nextBtn)this.nextBtn.disabled=x>=max-1;
      };
      this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.raf);this.raf=requestAnimationFrame(this.sync)},{signal,passive:true});
      this.ro=new ResizeObserver(()=>this.sync());this.ro.observe(this.track);
      this.sync();

      // Pointer dragging. Touch is left to native panning so the browser can
      // axis-lock and still scroll the page vertically from inside the track.
      //
      // Deliberately no setPointerCapture: a captured pointer makes the browser
      // dispatch the following click to the capturing element instead of the
      // link under the cursor, so cards stop navigating. Window-level listeners
      // keep tracking a drag past the element edge without that side effect.
      // The threshold must also clear ordinary click drift (a trackpad press
      // easily moves 5-6px), or a plain click gets treated as a drag.
      const DRAG_START=10;
      let pending=false,dragging=false,startX=0,startLeft=0,travel=0,suppressUntil=0;
      this.track.addEventListener("click",e=>{if(Date.now()<suppressUntil){e.preventDefault();e.stopImmediatePropagation()}},{signal,capture:true});
      const onMove=e=>{
        if(!pending)return;
        const dx=e.clientX-startX;
        travel=Math.max(travel,Math.abs(dx));
        if(!dragging){
          if(travel<DRAG_START)return;
          dragging=true;this.track.style.cursor='grabbing';
        }
        this.track.scrollLeft=startLeft-dx;
        e.preventDefault();
      };
      const onUp=()=>{
        if(!pending)return;
        const wasDrag=dragging;
        pending=false;dragging=false;this.track.style.cursor='';
        if(wasDrag)suppressUntil=Date.now()+400;
      };
      this.track.addEventListener('pointerdown',e=>{
        if(e.pointerType==='touch'||e.button!==0)return;
        pending=true;dragging=false;travel=0;
        startX=e.clientX;startLeft=this.track.scrollLeft;
      },{signal});
      addEventListener('pointermove',onMove,{signal});
      addEventListener('pointerup',onUp,{signal});
      addEventListener('pointercancel',onUp,{signal});
      this.track.addEventListener('dragstart',e=>e.preventDefault(),{signal});

      // Mobile tap navigation. Some browsers suppress the synthetic click on
      // links inside a horizontal scroller. Navigate directly after a short,
      // stationary touch while preserving genuine carousel swipes.
      let touchCard=null,touchX=0,touchY=0,touchMoved=false;
      this.track.addEventListener('pointerdown',e=>{
        if(e.pointerType!=='touch'&&e.pointerType!=='pen')return;
        touchCard=e.target.closest('[data-sc-card-url]');
        if(!touchCard)return;
        touchX=e.clientX;touchY=e.clientY;touchMoved=false;
      },{signal,passive:true});
      this.track.addEventListener('pointermove',e=>{
        if(!touchCard||(e.pointerType!=='touch'&&e.pointerType!=='pen'))return;
        if(Math.hypot(e.clientX-touchX,e.clientY-touchY)>10)touchMoved=true;
      },{signal,passive:true});
      this.track.addEventListener('pointerup',e=>{
        if(!touchCard||(e.pointerType!=='touch'&&e.pointerType!=='pen'))return;
        const card=touchCard;touchCard=null;
        if(touchMoved || Math.hypot(e.clientX-touchX,e.clientY-touchY)>10){suppressUntil=Date.now()+400;return;}
        const url=card.dataset.scCardUrl;
        if(url){e.preventDefault();window.location.assign(url)}
      },{signal});
      this.track.addEventListener('pointercancel',()=>{touchCard=null;touchMoved=false},{signal});
      this.addEventListener('keydown',e=>{
        if(e.target.closest('a,button')&&!e.target.closest('[data-sc-track]'))return;
        if(e.key==='ArrowLeft'){e.preventDefault();step(-1)}
        if(e.key==='ArrowRight'){e.preventDefault();step(1)}
      },{signal});
      this.addEventListener('shopify:block:select',e=>{
        const slide=e.target.closest('[data-sc-track] > *');
        if(slide)this.track.scrollTo({left:slide.offsetLeft-this.track.offsetLeft,behavior:'auto'});
      },{signal});

      // Autoplay, opt-in per section. Absent attributes leave it off.
      const interval=Number(this.dataset.scInterval)||0;
      if(this.dataset.scAutoplay==='true'&&interval>0){
        let paused=false;
        const stop=()=>{clearInterval(this.timer);this.timer=null};
        const start=()=>{
          stop();
          if(paused||reduce.matches||document.hidden||maxScroll()<=2)return;
          this.timer=setInterval(()=>{
            if(this.track.scrollLeft>=maxScroll()-2)this.track.scrollTo({left:0,behavior:behavior()});
            else step(1);
          },interval);
        };
        // A deliberate interaction ends autoplay for the session.
        const halt=()=>{paused=true;stop();if(this.pauseBtn)setPause(true)};
        const setPause=state=>{
          this.pauseBtn.setAttribute('aria-pressed',String(state));
          this.pauseBtn.setAttribute('aria-label',state?'Play carousel':'Pause carousel');
          this.pauseBtn.textContent=state?'▶':'❙❙';
        };
        this.addEventListener('pointerenter',stop,{signal});
        this.addEventListener('pointerleave',start,{signal});
        this.addEventListener('focusin',stop,{signal});
        this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget))start()},{signal});
        document.addEventListener('visibilitychange',()=>document.hidden?stop():start(),{signal});
        this.track.addEventListener('pointerdown',halt,{signal});
        this.track.addEventListener('touchstart',halt,{signal,passive:true});
        this.prevBtn?.addEventListener('click',halt,{signal});
        this.nextBtn?.addEventListener('click',halt,{signal});
        this.dots.forEach(d=>d.addEventListener('click',halt,{signal}));
        if(this.pauseBtn){
          setPause(false);
          this.pauseBtn.addEventListener('click',()=>{paused=!paused;setPause(paused);paused?stop():start()},{signal});
        }
        start();
      }
    }
    disconnectedCallback(){
      this.ctrl?.abort();this.ctrl=null;
      this.ro?.disconnect();
      cancelAnimationFrame(this.raf);
      clearInterval(this.timer);
    }
  });
}
if(!window.__sleepyReveal){
  window.__sleepyReveal=true;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}});
  },{rootMargin:'0px 0px -6% 0px',threshold:0.08}):null;
  const scan=root=>{
    root.querySelectorAll('[data-sc-reveal]:not([data-sc-seen])').forEach(el=>{
      el.dataset.scSeen='1';
      if(!io||reduce.matches||el.closest('[data-animation="none"]'))el.classList.add('is-in');
      else io.observe(el);
    });
  };
  window.__sleepyRevealScan=scan;
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
}else{window.__sleepyRevealScan?.(document)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-page-hero"] && !Shopify.designMode) return;
  try {
    
if(!window.__sleepyReveal){
  window.__sleepyReveal=true;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}});
  },{rootMargin:'0px 0px -6% 0px',threshold:0.08}):null;
  const scan=root=>{
    root.querySelectorAll('[data-sc-reveal]:not([data-sc-seen])').forEach(el=>{
      el.dataset.scSeen='1';
      if(!io||reduce.matches||el.closest('[data-animation="none"]'))el.classList.add('is-in');
      else io.observe(el);
    });
  };
  window.__sleepyRevealScan=scan;
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
}else{window.__sleepyRevealScan?.(document)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-payment-tabs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sleepy-pay-tabs')){
  customElements.define('sleepy-pay-tabs',class extends HTMLElement{
    connectedCallback(){
      if(this.ctrl)return;
      this.ctrl=new AbortController();const signal=this.ctrl.signal;
      const tabs=Array.from(this.querySelectorAll('[role=tab]'));
      const panels=Array.from(this.querySelectorAll('[role=tabpanel]'));
      if(!tabs.length)return;
      const key='spt:'+(this.closest('[id^=shopify-section-]')?.id||'');
      const show=(i,focus)=>{
        tabs.forEach((t,k)=>{const on=k===i;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1;});
        panels.forEach((p,k)=>{
          const on=k===i;
          if(on&&p.hidden){p.hidden=false;window.__sleepyRevealScan?.(p);}
          else if(!on)p.hidden=true;
        });
        if(focus)tabs[i].focus();
        if(this.dataset.remember==='true'){try{sessionStorage.setItem(key,String(i))}catch(e){}}
      };
      tabs.forEach((t,i)=>{
        t.addEventListener('click',()=>show(i,false),{signal});
        t.addEventListener('keydown',e=>{
          const n=tabs.length;let j=null;
          if(e.key==='ArrowRight')j=(i+1)%n;else if(e.key==='ArrowLeft')j=(i-1+n)%n;
          else if(e.key==='Home')j=0;else if(e.key==='End')j=n-1;
          if(j!==null){e.preventDefault();show(j,true);}
        },{signal});
      });
      // Restore the last tab within the session, if the merchant wants that.
      if(this.dataset.remember==='true'){
        try{const saved=Number(sessionStorage.getItem(key));if(Number.isInteger(saved)&&tabs[saved])show(saved,false);}catch(e){}
      }
      // Theme editor: selecting a tab block switches to it.
      this.addEventListener('shopify:block:select',e=>{
        const t=e.target.closest('[role=tab]');if(t)show(tabs.indexOf(t),false);
      },{signal});

      // ---- instalment calculators ----
      this.querySelectorAll('[data-calc]').forEach(calc=>{
        const n=Math.max(2,Number(calc.dataset.instalments)||4);
        const min=Number(calc.dataset.min)||0,max=Number(calc.dataset.max)||Infinity;
        const cur=calc.dataset.currency||'$';
        const input=calc.querySelector('[data-amount]'),total=calc.querySelector('[data-total]');
        const range=calc.querySelector('[data-range]'),fill=calc.querySelector('[data-fill]'),thumb=calc.querySelector('[data-thumb]');
        const marks=Array.from(calc.querySelectorAll('[data-mark]')),items=Array.from(calc.querySelectorAll('.spt__marks li'));
        const fmt=v=>{
          const whole=Math.abs(v-Math.round(v))<0.005;
          const s=whole?String(Math.round(v)):v.toFixed(2);
          return cur+s.replace(/\B(?=(\d{3})+(?!\d))/g,',');
        };
        const parse=()=>{
          const v=parseFloat(String(input.value).replace(/[^0-9.]/g,''));
          return Number.isFinite(v)?Math.min(max,Math.max(min,v)):0;
        };
        const paint=()=>{
          const amount=parse(),each=amount/n;
          total.textContent=fmt(amount);
          marks.forEach((m,i)=>{m.textContent=fmt(each*(i+1))});
          const pos=Number(range.value)||0,pct=n>1?pos/(n-1)*100:0;
          calc.style.setProperty('--fill',pct+'%');
          fill.style.width=pct+'%';thumb.style.left=pct+'%';
          items.forEach((li,i)=>li.classList.toggle('is-current',i===pos));
          range.setAttribute('aria-valuetext',(items[pos]?.textContent||'').trim().replace(/\s+/g,' '));
        };
        input.addEventListener('input',paint,{signal});
        input.addEventListener('blur',()=>{const v=parse();input.value=v?String(Math.abs(v-Math.round(v))<0.005?Math.round(v):v.toFixed(2)):'';paint();},{signal});
        range.addEventListener('input',paint,{signal});
        paint();
      });
    }
    disconnectedCallback(){this.ctrl?.abort();this.ctrl=null}
  });
}
if(!window.__sleepyReveal){
  window.__sleepyReveal=true;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}});
  },{rootMargin:'0px 0px -6% 0px',threshold:0.08}):null;
  const scan=root=>{
    root.querySelectorAll('[data-sc-reveal]:not([data-sc-seen])').forEach(el=>{
      el.dataset.scSeen='1';
      if(!io||reduce.matches||el.closest('[data-animation="none"]'))el.classList.add('is-in');
      else io.observe(el);
    });
  };
  window.__sleepyRevealScan=scan;
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
}else{window.__sleepyRevealScan?.(document)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-reasons-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sleepy-reasons'))customElements.define('sleepy-reasons',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const opt={signal:this.abort.signal},v=this.querySelector('.sr-viewport'),track=this.querySelector('.sr-track'),originals=[...track.children];let cycle=0,last=0,hover=false,focus=false,touch=false,userPaused=false,visible=true,resume=0,drag=null,moved=false,fraction=0;const reduced=matchMedia('(prefers-reduced-motion: reduce)');
const normalize=()=>{if(cycle&&v.scrollWidth>v.clientWidth){if(v.scrollLeft>=cycle*2)v.scrollLeft-=cycle;else if(v.scrollLeft<cycle)v.scrollLeft+=cycle;}};
const setup=()=>{const old=cycle?v.scrollLeft%cycle:0;track.querySelectorAll('[data-clone]').forEach(n=>n.remove());cycle=0;if(originals.length<2)return;let originalWidth=track.scrollWidth;if(originalWidth<=v.clientWidth)return;for(let n=0;n<2;n++)originals.forEach(card=>{const c=card.cloneNode(true);c.dataset.clone='true';c.setAttribute('aria-hidden','true');c.querySelectorAll('a,button').forEach(el=>el.tabIndex=-1);c.removeAttribute('data-shopify-editor-block');track.append(c)});cycle=track.children[originals.length].offsetLeft-originals[0].offsetLeft;v.scrollLeft=cycle+old;};
this.observer=new ResizeObserver(()=>{if(drag||touch)return;setup()});this.observer.observe(v);
v.addEventListener('mouseenter',()=>{hover=this.hasAttribute('data-pause-hover')},opt);v.addEventListener('mouseleave',()=>hover=false,opt);v.addEventListener('focusin',()=>focus=true,opt);v.addEventListener('focusout',e=>focus=v.contains(e.relatedTarget),opt);
v.addEventListener('pointerdown',e=>{moved=false;if(e.pointerType!=='mouse'){touch=true;return}if(e.button!==0)return;drag={x:e.clientX,left:v.scrollLeft};v.classList.add('is-dragging')},opt);
window.addEventListener('pointermove',e=>{if(!drag)return;const dx=e.clientX-drag.x;if(Math.abs(dx)>5)moved=true;if(moved){e.preventDefault();v.scrollLeft=drag.left-dx}}, {...opt,passive:false});
const release=()=>{if(drag||touch){drag=null;touch=false;v.classList.remove('is-dragging');resume=performance.now()+1600;normalize()}};window.addEventListener('pointerup',release,opt);window.addEventListener('pointercancel',release,opt);
v.addEventListener('click',e=>{if(moved){e.preventDefault();e.stopPropagation()}}, {...opt,capture:true});v.addEventListener('scroll',()=>{if(!drag&&!touch)normalize()},opt);v.addEventListener('wheel',()=>resume=performance.now()+1600,{...opt,passive:true});
const control=this.querySelector('.sr-motion');control?.addEventListener('click',()=>{userPaused=!userPaused;control.setAttribute('aria-pressed',String(userPaused));control.textContent=userPaused?'Resume movement':'Pause movement'},opt);
this.visibility=new IntersectionObserver(entries=>visible=entries[0].isIntersecting);this.visibility.observe(this);
const tick=t=>{const dt=last?Math.min(t-last,40):0;last=t;if(cycle&&this.hasAttribute('data-autoplay')&&!reduced.matches&&!hover&&!focus&&!touch&&!drag&&!userPaused&&visible&&!document.hidden&&t>resume){fraction+=Number(this.dataset.speed)*dt/1000;const pixels=Math.floor(fraction);if(pixels){v.scrollLeft+=pixels;fraction-=pixels;normalize()}}this.frame=requestAnimationFrame(tick)};setup();this.frame=requestAnimationFrame(tick);
}
disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();this.visibility?.disconnect();cancelAnimationFrame(this.frame);this.querySelectorAll('[data-clone]').forEach(n=>n.remove())}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-related-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sleepy-related'))customElements.define('sleepy-related',class extends HTMLElement{
connectedCallback(){if(!this.dataset.url||this.loading)return;this.loading=true;this.abort=new AbortController();fetch(this.dataset.url,{signal:this.abort.signal}).then(r=>{if(!r.ok)throw new Error('Recommendations unavailable');return r.text()}).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html');const next=doc.querySelector('sleepy-related [data-related-content]');if(next?.querySelector('.sc-beds__card'))this.querySelector('[data-related-content]').replaceWith(next)}).catch(()=>{}).finally(()=>{this.loading=false})}
disconnectedCallback(){this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-seven-zone"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('sleepy-seven-zones')){customElements.define('sleepy-seven-zones',class extends HTMLElement{connectedCallback(){
if(this._initialized)return;this._initialized=true;
const config=JSON.parse(this.querySelector('[data-zone-config]').textContent);
const zones=config.zones;
const root=this;
const explorer=root.querySelector('.sz-explorer');
const buttons=Array.from(root.querySelectorAll('[data-zone]'));
const modes=Array.from(root.querySelectorAll('button[data-mode]'));
const callout=root.querySelector('.sz-callout');
const track=root.querySelector('.sz-callout-track');
const copy=root.querySelector('.sz-copy');
const title=root.querySelector('.sz-callout h2');
const description=root.querySelector('.sz-callout p');
const counter=root.querySelector('.sz-callout-index');
const band=root.querySelector('.sz-selected-band');
const connector=root.querySelector('.sz-connector');
let selected=0,mode='zones';
function position(){
const width=track.clientWidth;
const anchor=width*(mode==='depth'?.925:(.16+selected*.11));
const left=Math.max(0,Math.min(width-callout.offsetWidth,anchor-callout.offsetWidth/2));
callout.style.transform='translateX('+left+'px)';
const end=left+Math.min(callout.offsetWidth-20,Math.max(20,anchor-left));
connector.setAttribute('viewBox','0 0 '+Math.max(1,width)+' 30');
connector.querySelector('path').setAttribute('d','M '+anchor+' 0 V 10 Q '+anchor+' 16 '+end+' 22 V 30');
connector.querySelector('circle').setAttribute('cx',anchor);
connector.querySelector('circle').setAttribute('cy',0);
}
function render(){
explorer.dataset.mode=mode;
modes.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mode===mode)));
buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===selected)));
band.setAttribute('x',105+selected*110);
if(mode==='depth'){
title.textContent=config.depth_title;description.textContent=config.depth_description;counter.textContent='30CM';
root.querySelector('.sz-hint').textContent='Select 7 Zone Support to explore each area.';
}else{
title.textContent=zones[selected].title;description.textContent=zones[selected].description;counter.textContent=String(selected+1).padStart(2,'0')+' / 07';
root.querySelector('.sz-hint').textContent='Select a zone to explore your support.';
}
copy.classList.remove('sz-entering');void copy.offsetWidth;copy.classList.add('sz-entering');position();
}
buttons.forEach((button,index)=>{
button.addEventListener('click',()=>{selected=index;mode='zones';render();});
button.addEventListener('keydown',event=>{
let next=index;
if(event.key==='ArrowRight')next=(index+1)%zones.length;
else if(event.key==='ArrowLeft')next=(index+zones.length-1)%zones.length;
else if(event.key==='Home')next=0;
else if(event.key==='End')next=zones.length-1;
else return;
event.preventDefault();selected=next;mode='zones';buttons[next].focus();render();
});
});
modes.forEach(button=>button.addEventListener('click',()=>{mode=button.dataset.mode;render();}));
const photo=root.querySelector('.sz-photo');if(photo){const loaded=()=>root.querySelector('.sz-drawing').classList.add('sz-has-photo');if(photo.complete&&photo.naturalWidth)loaded();else photo.addEventListener('load',loaded,{once:true});}
if(typeof ResizeObserver!=='undefined'){const observer=new ResizeObserver(position);observer.observe(track);observer.observe(callout);this._cleanup=()=>observer.disconnect();}else {window.addEventListener('resize',position);this._cleanup=()=>window.removeEventListener('resize',position);}
render();
}
disconnectedCallback(){this._cleanup?.();this._initialized=false;}
});}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-showroom"] && !Shopify.designMode) return;
  try {
    
if(!window.__sleepyReveal){
  window.__sleepyReveal=true;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}});
  },{rootMargin:'0px 0px -6% 0px',threshold:0.08}):null;
  const scan=root=>{
    root.querySelectorAll('[data-sc-reveal]:not([data-sc-seen])').forEach(el=>{
      el.dataset.scSeen='1';
      if(!io||reduce.matches||el.closest('[data-animation="none"]'))el.classList.add('is-in');
      else io.observe(el);
    });
  };
  window.__sleepyRevealScan=scan;
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
}else{window.__sleepyRevealScan?.(document)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-story-counter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseNumber = (value) => {
      const parsed = Number.parseFloat(String(value || '').replace(/[^0-9.-]/g, ''));
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const init = (root) => root.querySelectorAll('[data-ssc]:not([data-ready])').forEach((section) => {
      section.dataset.ready = 'true';

      const counters = [...section.querySelectorAll('[data-ssc-counter]')];
      const duration = Math.max(0, Number(section.dataset.counterDuration) || 1600);
      const stagger = Math.max(0, Number(section.dataset.counterStagger) || 0);
      const threshold = Math.max(0.05, Math.min(0.8, (Number(section.dataset.counterThreshold) || 20) / 100));
      const replay = section.dataset.counterReplay === 'true';
      const easing = section.dataset.counterEasing || 'ease-out';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let hasRun = false;

      const format = (value, decimals, separator) => new Intl.NumberFormat('en-NZ', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: separator
      }).format(value);

      const setValue = (element, value) => {
        const decimals = Math.max(0, Number(element.dataset.decimals) || 0);
        const separator = element.dataset.separator !== 'false';
        element.textContent = format(value, decimals, separator);
      };

      const reset = () => counters.forEach((counter) => setValue(counter, parseNumber(counter.dataset.start)));

      const ease = (progress) => {
        if (easing === 'linear') return progress;
        if (easing === 'ease-in-out') return progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;
        return 1 - Math.pow(1 - progress, 3);
      };

      const animate = (counter) => {
        const start = parseNumber(counter.dataset.start);
        const target = parseNumber(counter.dataset.target);
        const customDuration = Number(counter.dataset.duration) || duration;

        if (reducedMotion || customDuration <= 0 || start === target) {
          setValue(counter, target);
          return;
        }

        const startTime = performance.now();
        const frame = (time) => {
          const progress = Math.min(1, (time - startTime) / customDuration);
          const value = start + (target - start) * ease(progress);
          setValue(counter, value);
          if (progress < 1) window.requestAnimationFrame(frame);
          else setValue(counter, target);
        };
        window.requestAnimationFrame(frame);
      };

      const run = () => {
        if (hasRun && !replay) return;
        hasRun = true;
        section.classList.add('is-visible');
        counters.forEach((counter, index) => {
          window.setTimeout(() => animate(counter), reducedMotion ? 0 : index * stagger);
        });
      };

      reset();

      if (reducedMotion || !('IntersectionObserver' in window)) {
        run();
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            run();
            if (!replay) observer.unobserve(section);
          } else if (replay && hasRun) {
            hasRun = false;
            section.classList.remove('is-visible');
            reset();
          }
        });
      }, { threshold });

      observer.observe(section);
    });

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-value-props"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => root.querySelectorAll('[data-swcu]:not([data-ready])').forEach((section) => {
      section.dataset.ready = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          section.querySelectorAll('img.swcu__image').forEach((image) => image.decode?.().catch(() => {}));
          section.classList.add('is-visible');
          observer.unobserve(section);
        });
      }, { threshold: 0.14 });

      observer.observe(section);
    });

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-video-testimonials"] && !Shopify.designMode) return;
  try {
    
(() => {
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (root) => root.querySelectorAll('[data-svt]:not([data-ready])').forEach((section) => {
    section.dataset.ready = 'true';

    const viewport = section.querySelector('[data-svt-viewport]');
    const track = section.querySelector('[data-svt-track]');
    const items = [...section.querySelectorAll('[data-svt-item]')];
    const cards = [...section.querySelectorAll('[data-svt-card]')];
    const dots = [...section.querySelectorAll('[data-svt-dot]')];
    const previousButton = section.querySelector('[data-svt-prev]');
    const nextButton = section.querySelector('[data-svt-next]');

    if (!viewport || !track || !items.length) return;

    const autoplay = section.dataset.autoplay !== 'false';
    const autoplayDelay = Math.max(1000, Number(section.dataset.autoplayDelay) || 5000);
    const slideDuration = Math.max(0, Number(section.dataset.slideDuration) || 650);
    const loop = section.dataset.loop !== 'false';
    const pauseOnHover = section.dataset.pauseHover !== 'false';
    const draggable = section.dataset.draggable !== 'false';
    const desktopOffset = Math.max(0, Math.min(100, Number(section.dataset.desktopOffset) || 0));

    let touching = false;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoved = false;
    let suppressClickUntil = 0;
    let current = 0;
    let timer = 0;
    let animationFrame = 0;
    let scrollEndTimer = 0;
    let inView = false;
    let hovered = false;
    let dragging = false;
    let moved = false;
    let suppressClick = false;
    let startX = 0;
    let startScroll = 0;
    let lastX = 0;
    let lastTime = 0;
    let velocity = 0;

    const maxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const firstOffset = () => items[0]?.offsetLeft || 0;
    const targetFor = (index) => Math.max(0, Math.min(maxScroll(), items[index].offsetLeft - firstOffset()));

    const nearestIndex = (position = viewport.scrollLeft) => {
      let bestIndex = 0;
      let bestDistance = Infinity;
      items.forEach((item, index) => {
        const distance = Math.abs(targetFor(index) - position);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });
      return bestIndex;
    };

    const updateDots = () => {
      dots.forEach((dot, index) => dot.setAttribute('aria-selected', String(index === current)));
    };

    const anyVideoPlaying = () => cards.some((card) => card.classList.contains('is-playing'));
    const clearTimer = () => {
      window.clearTimeout(timer);
      timer = 0;
    };

    const cancelScrollAnimation = () => {
      if (animationFrame) window.cancelAnimationFrame(animationFrame);
      animationFrame = 0;
      viewport.classList.remove('is-programmatic');
    };

    const shouldAutoplay = () => autoplay
      && items.length > 1
      && inView
      && !document.hidden
      && !dragging
      && !touching
      && !(pauseOnHover && hovered)
      && !anyVideoPlaying()
      && !prefersReducedMotion()
      && (loop || current < items.length - 1);

    const schedule = () => {
      clearTimer();
      if (!shouldAutoplay()) return;
      timer = window.setTimeout(() => goTo(current + 1), autoplayDelay);
    };

    const animateTo = (destination, duration, complete) => {
      cancelScrollAnimation();
      const start = viewport.scrollLeft;
      const change = destination - start;

      if (Math.abs(change) < 1 || duration === 0 || prefersReducedMotion()) {
        viewport.scrollLeft = destination;
        current = nearestIndex();
        updateDots();
        complete?.();
        return;
      }

      const startTime = performance.now();
      viewport.classList.add('is-programmatic');

      const frame = (time) => {
        const progress = Math.min(1, (time - startTime) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        viewport.scrollLeft = start + change * eased;

        if (progress < 1) {
          animationFrame = window.requestAnimationFrame(frame);
        } else {
          animationFrame = 0;
          viewport.classList.remove('is-programmatic');
          current = nearestIndex();
          updateDots();
          complete?.();
        }
      };

      animationFrame = window.requestAnimationFrame(frame);
    };

    const normalizeIndex = (index) => {
      if (loop) return (index + items.length) % items.length;
      return Math.max(0, Math.min(items.length - 1, index));
    };

    function goTo(index, options = {}) {
      clearTimer();
      const nextIndex = normalizeIndex(index);
      current = nextIndex;
      updateDots();
      animateTo(targetFor(nextIndex), options.instant ? 0 : slideDuration, schedule);
    }

    const stopAllVideos = (except) => {
      cards.forEach((card) => {
        if (card === except) return;
        const video = card.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        const frame = card.querySelector('[data-svt-external]');
        if (frame) frame.src = '';
        card.classList.remove('is-playing');
      });
    };

    section.querySelectorAll('[data-svt-play]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('[data-svt-card]');
        clearTimer();
        stopAllVideos(card);
        card.classList.add('is-playing');

        const video = card.querySelector('video');
        if (video) {
          video.play().catch(() => {
            card.classList.remove('is-playing');
            schedule();
          });
        }

        const frame = card.querySelector('[data-svt-external]');
        if (frame) {
          const base = frame.dataset.baseSrc;
          frame.src = base + (base.includes('?') ? '&' : '?') + 'autoplay=1';
        }
      });
    });

    cards.forEach((card) => {
      const video = card.querySelector('video');
      if (!video) return;
      video.addEventListener('ended', () => {
        card.classList.remove('is-playing');
        schedule();
      });
      video.addEventListener('pause', () => {
        if (!video.ended && card.classList.contains('is-playing')) {
          card.classList.remove('is-playing');
          schedule();
        }
      });
    });

    const manualGoTo = (index) => {
      stopAllVideos();
      goTo(index);
    };

    previousButton?.addEventListener('click', () => manualGoTo(current - 1));
    nextButton?.addEventListener('click', () => manualGoTo(current + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => manualGoTo(Number(dot.dataset.svtDot))));

    viewport.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      manualGoTo(current + (event.key === 'ArrowRight' ? 1 : -1));
    });

    viewport.addEventListener('dragstart', (event) => event.preventDefault());

    // Let the browser handle touch scrolling, momentum and snapping.
    // Never preventDefault or capture touch pointers: vertical page scroll stays usable.
    viewport.addEventListener('touchstart', (event) => {
      touching = true;
      touchMoved = false;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      clearTimer();
      window.clearTimeout(scrollEndTimer);
      cancelScrollAnimation();
    }, { passive: true });

    viewport.addEventListener('touchmove', (event) => {
      if (!touching || !event.touches.length) return;
      const dx = Math.abs(event.touches[0].clientX - touchStartX);
      const dy = Math.abs(event.touches[0].clientY - touchStartY);
      if (dx > 8 && dx > dy) touchMoved = true;
    }, { passive: true });

    const finishTouch = (event) => {
      if (event.touches.length) return;
      touching = false;
      if (touchMoved) suppressClickUntil = performance.now() + 500;
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(() => {
        current = nearestIndex();
        updateDots();
        schedule();
      }, 250);
    };
    viewport.addEventListener('touchend', finishTouch, { passive: true });
    viewport.addEventListener('touchcancel', finishTouch, { passive: true });

    viewport.addEventListener('pointerdown', (event) => {
      clearTimer();

      if (event.pointerType === 'touch') { cancelScrollAnimation(); return; }
      if (!draggable || event.button !== 0) return;
      if (event.target.closest('button, a, input, select, textarea, video, iframe')) return;

      cancelScrollAnimation();
      dragging = true;
      moved = false;
      velocity = 0;
      startX = event.clientX;
      lastX = event.clientX;
      startScroll = viewport.scrollLeft;
      lastTime = performance.now();
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture?.(event.pointerId);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;

      const delta = event.clientX - startX;
      const now = performance.now();
      const elapsed = Math.max(1, now - lastTime);
      velocity = (lastX - event.clientX) / elapsed;
      lastX = event.clientX;
      lastTime = now;

      if (Math.abs(delta) > 4) moved = true;
      viewport.scrollLeft = startScroll - delta;
      event.preventDefault();
    });

    const finishDrag = (event) => {
      if (!dragging) {
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(schedule, 700);
        return;
      }

      dragging = false;
      viewport.classList.remove('is-dragging');
      if (viewport.hasPointerCapture?.(event.pointerId)) viewport.releasePointerCapture(event.pointerId);

      if (moved) {
        suppressClick = true;
        stopAllVideos();
        const projectedPosition = viewport.scrollLeft + velocity * 180;
        goTo(nearestIndex(projectedPosition));
        window.setTimeout(() => { suppressClick = false; }, 0);
      } else {
        schedule();
      }
    };

    viewport.addEventListener('pointerup', finishDrag);
    viewport.addEventListener('pointercancel', finishDrag);
    viewport.addEventListener('click', (event) => {
      if (!suppressClick && performance.now() >= suppressClickUntil) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    viewport.addEventListener('scroll', () => {
      clearTimer();
      if (!animationFrame && !dragging && !touching) {
        current = nearestIndex();
        updateDots();
      }
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(() => {
        if (!dragging && !touching && !animationFrame) {
          current = nearestIndex();
          updateDots();
          schedule();
        }
      }, 180);
    }, { passive: true });

    section.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      hovered = true;
      if (pauseOnHover) clearTimer();
    });
    section.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      hovered = false;
      schedule();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) clearTimer();
      else schedule();
    });

    if ('IntersectionObserver' in window) {
      const carouselObserver = new IntersectionObserver((entries) => {
        inView = entries[0]?.isIntersecting || false;
        if (inView) schedule();
        else clearTimer();
      }, { threshold: 0.15 });
      carouselObserver.observe(section);
    } else {
      inView = true;
    }

    if ('ResizeObserver' in window) {
      let observedWidth = viewport.clientWidth;
      const resizeObserver = new ResizeObserver(() => {
        const nextWidth = viewport.clientWidth;
        if (Math.abs(nextWidth - observedWidth) < 1) return;
        observedWidth = nextWidth;
        goTo(current, { instant: true });
      });
      resizeObserver.observe(viewport);
    }

    window.requestAnimationFrame(() => {
      if (window.innerWidth >= 750 && desktopOffset > 0 && items.length > 1) {
        const step = targetFor(1) - targetFor(0);
        viewport.scrollLeft = Math.max(0, step * desktopOffset / 100);
      }
      current = nearestIndex();
      updateDots();
      schedule();
    });

    if (section.classList.contains('svt--none') || prefersReducedMotion()) {
      section.classList.add('is-visible');
    } else {
      const revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          section.classList.add('is-visible');
          revealObserver.disconnect();
        }
      }), { threshold: 0.12 });
      revealObserver.observe(section);
    }
  });

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepy-why-choose-us"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => root.querySelectorAll('[data-swcu]:not([data-ready])').forEach((section) => {
      section.dataset.ready = 'true';

      const slider = section.querySelector('[data-swcu-slider]');
      const cards = slider ? [...slider.querySelectorAll('.swcu__card')] : [];
      const dots = [...section.querySelectorAll('[data-swcu-dot]')];
      const mobile = window.matchMedia('(max-width: 749px)');
      let current = 0;
      let pointerActive = false;
      let activePointerType = '';
      let dragging = false;
      let moved = false;
      let suppressClick = false;
      let startX = 0;
      let startScroll = 0;
      let scrollFrame = 0;

      const firstOffset = () => cards[0]?.offsetLeft || 0;
      const targetFor = (index) => cards[index] ? cards[index].offsetLeft - firstOffset() : 0;
      const nearestIndex = () => {
        if (!slider || !cards.length) return 0;
        let best = 0;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const nextDistance = Math.abs(targetFor(index) - slider.scrollLeft);
          if (nextDistance < distance) {
            distance = nextDistance;
            best = index;
          }
        });
        return best;
      };

      const updateDots = () => {
        current = nearestIndex();
        dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
      };

      const goTo = (index, behavior = 'smooth') => {
        if (!slider || !cards[index]) return;
        current = index;
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === current)));
        const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : behavior;
        slider.scrollTo({ left: targetFor(index), behavior: scrollBehavior });
      };

      if (slider && cards.length) {
        dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.swcuDot))));

        slider.addEventListener('scroll', () => {
          if (scrollFrame) return;
          scrollFrame = window.requestAnimationFrame(() => {
            scrollFrame = 0;
            updateDots();
          });
        }, { passive: true });

        slider.addEventListener('dragstart', (event) => event.preventDefault());

        slider.addEventListener('pointerdown', (event) => {
          if (!mobile.matches) return;
          if (event.pointerType !== 'touch' && event.button !== 0) return;
          pointerActive = true;
          activePointerType = event.pointerType;
          dragging = false;
          moved = false;
          startX = event.clientX;
          startScroll = slider.scrollLeft;
        });

        slider.addEventListener('pointermove', (event) => {
          if (!pointerActive) return;
          const distance = event.clientX - startX;

          if (activePointerType === 'touch') {
            if (Math.abs(distance) > 8) moved = true;
            return;
          }

          if (!dragging && Math.abs(distance) <= 4) return;

          if (!dragging) {
            dragging = true;
            moved = true;
            slider.classList.add('is-dragging');
            slider.setPointerCapture?.(event.pointerId);
          }

          slider.scrollLeft = startScroll - distance;
          event.preventDefault();
        });

        const finishDrag = (event) => {
          if (!pointerActive) return;
          pointerActive = false;

          if (!dragging) {
            if (moved && activePointerType === 'touch') {
              suppressClick = true;
              window.setTimeout(() => { suppressClick = false; }, 450);
            }
            activePointerType = '';
            return;
          }
          dragging = false;
          slider.classList.remove('is-dragging');
          if (slider.hasPointerCapture?.(event.pointerId)) slider.releasePointerCapture(event.pointerId);

          if (moved) {
            suppressClick = true;
            goTo(nearestIndex());
            window.setTimeout(() => { suppressClick = false; }, 0);
          }
          activePointerType = '';
        };

        slider.addEventListener('pointerup', finishDrag);
        slider.addEventListener('pointercancel', finishDrag);
        slider.addEventListener('click', (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);

        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(updateDots);
          resizeObserver.observe(slider);
        }

        window.requestAnimationFrame(updateDots);
      }

      const decodeImages = () => section.querySelectorAll('img.swcu__image').forEach((image) => image.decode?.().catch(() => {}));

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        decodeImages();
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          decodeImages();
          section.classList.add('is-visible');
          observer.unobserve(section);
        });
      }, { threshold: 0.14 });

      observer.observe(section);
    });

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
